var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 512,
    width: 512,
    id: "flag-icon-css-do",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.67,
    d: "M83.69 80.338h364.87v364.87H83.69z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "translate(-117.44 -112.73) scale(1.403)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#00319c",
    d: "M313.18 314.79h318.16v195.18H313.18z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#d62918",
    d: "M-99.223 315.39h317.25v194.58h-317.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#00319c",
    d: "M-98.615-1.78h317.25v217.63h-317.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#d62918",
    d: "M315.01.045h315.73v217.85H315.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#fff",
    d: "M-99.038 215.83h731.12V316.8h-731.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#fff",
    d: "M217.25-.71h98.537v510.93H217.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M259.33 218.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M259.83 218.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M260.33 218.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#848c9c",
    d: "M263.84 218.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#848ca5",
    d: "M264.67 218.95l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#848c9c",
    d: "M265.34 218.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M268.85 218.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M269.35 218.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M269.85 218.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M255.82 219.26l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M256.32 219.26l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M256.82 219.26l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "M257.32 219.26l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425a84",
    d: "M257.82 219.26l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M258.66 219.42l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M259.66 219.42l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "M251.68 223.92c-5.925.116-13.854.515-19.04 3.513-3.455 1.996-3.083 7.598 1.493 7.46v.476h-1.002v.476l7.52-1.908v-.477h-3.007v-.476h3.51l-1.004-1.91 18.047-1.907-1.002-3.34c6.736-.81 12.07-.214 18.55 1.432v.476l-4.012-.954c.465 2.065 2.81 1.546 4.512.954l-5.014.954v.477l11.532 1.036 12.032 2.78v.478l-6.517-.953v.477l8.022 2.385-1.506-1.432v-.477l2.006 2.386c3.18.132 5.57.85 7.52 3.34l-7.02-2.863 4.012 9.063h.5v-1.43h.502v1.43l4.512-.954c-1.168-4.804-3.176-10.482-8.02-12.88.426-1.83-.005-2.625-1.505-3.816 1.862 3.663-1.243 5.184-4.01 2.385l-1.002.955 1.002-3.34-3.008 2.863.502-3.34h-.502l-.5 2.863-1.505-1.43-.5 1.43-8.023-.953v-4.293l1.003 1.43h.502v-1.43l2.505 1.43h.502l10.027.478.5 3.816h.502l1.504-3.34c-5.795-2.44-12.756-3.214-19.05-3.338.327-3.243-3.24-3.83-6.017-4.23-4.785-.688-19.517-2.373-20.053 4.23z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M269.69 219.42l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M270.69 219.42l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314a7b",
    d: "M271.36 219.26l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "M271.86 219.26l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M272.36 219.26l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M272.86 219.26l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M273.36 219.26l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M254.31 219.74l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M254.81 219.74l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21315a",
    d: "M255.32 219.74l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M255.82 219.74l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M256.32 219.74l.5.477-.5-.477m16.544 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M273.36 219.74l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10295a",
    d: "M273.86 219.74l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636b7b",
    d: "M274.37 219.74l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M274.87 219.74l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M252.81 220.22l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M253.31 220.22l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "M253.81 220.22l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M254.31 220.22l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "M259.33 220.22l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "M259.83 220.22l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295284",
    d: "M260.33 220.22l.5.477-.5-.477m1.003 0l.5.477-.5-.477zm3.007 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a636b",
    d: "M267.35 220.22l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M268.85 220.22l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "M269.35 220.22l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M274.87 220.22l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10295a",
    d: "M275.37 220.22l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M275.87 220.22l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M276.37 220.22l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M251.81 220.7l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M252.31 220.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10295a",
    d: "M252.81 220.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "M255.82 220.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M256.32 220.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad9431",
    d: "M256.82 220.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c8c42",
    d: "M257.32 220.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "M257.82 220.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8442",
    d: "M259.33 220.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c8c42",
    d: "M260.33 220.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "M261.33 220.7l.5.477-.5-.477zm3.01 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c8c42",
    d: "M269.35 220.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "M271.69 220.85l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295284",
    d: "M272.36 220.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M276.37 220.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M276.87 220.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M277.37 220.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#31394a",
    d: "M251.81 221.17l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb518",
    d: "M255.82 221.17l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efbd08",
    d: "M257.82 221.17l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "M259.33 221.17l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efbd08",
    d: "M260.33 221.17l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M265.84 221.17l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "M266.34 221.17l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a636b",
    d: "M266.85 221.17l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "M267.85 221.17l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "M270.86 221.17l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a636b",
    d: "M272.36 221.17l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "M277.37 221.17l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M277.88 221.17l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212139",
    d: "M251.3 221.65l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "M255.82 221.65l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cead21",
    d: "M256.32 221.65l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "M256.99 221.97l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "M257.49 221.97l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M258.32 221.65l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cead21",
    d: "M259.83 221.65l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "M260.83 221.65l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c8c42",
    d: "M265.84 221.65l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "M266.34 221.65l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c8c42",
    d: "M266.85 221.65l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "M267.85 221.65l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295284",
    d: "M268.35 221.65l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8442",
    d: "M270.86 221.65l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M272.36 221.65l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M278.38 221.65l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M250.8 222.13l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M251.3 222.13l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M255.82 222.13l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "M258.32 222.13l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295284",
    d: "M258.82 222.13l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a636b",
    d: "M259.83 222.13l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb518",
    d: "M260.33 222.13l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad9431",
    d: "M260.83 222.13l.5.477-.5-.477m6.517 0l.502.477-.503-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "M268.52 222.44l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efbd08",
    d: "M270.86 222.13l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad9431",
    d: "M271.36 222.13l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cead21",
    d: "M271.86 222.13l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad9431",
    d: "M272.36 222.13l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M277.88 222.13l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M278.38 222.13l.5.477-.5-.477m-27.573.477l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M251.47 222.92l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M255.82 222.6l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "M256.82 222.6l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "M258.32 222.6l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "M258.82 222.6l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M259.83 222.6l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cead21",
    d: "M260.33 222.6l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c8c42",
    d: "M265.84 222.6l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a636b",
    d: "M266.34 222.6l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb518",
    d: "M266.85 222.6l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "M270.36 222.6l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a636b",
    d: "M271.36 222.6l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "M272.19 222.76l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M250.8 223.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "M255.82 223.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cead21",
    d: "M256.82 223.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8442",
    d: "M257.32 223.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "M257.82 223.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8442",
    d: "M258.82 223.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "M261.33 223.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M266.01 223.4l.167.318-.167-.318m.836-.318l1.002 1.43-1.002-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a636b",
    d: "M268.35 223.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "M270.36 223.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb518",
    d: "M271.86 223.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M248.8 223.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "M250.8 223.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M251.3 223.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M256.82 223.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "M258.82 223.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cead21",
    d: "M259.33 223.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "M259.83 223.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295284",
    d: "M260.33 223.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb518",
    d: "M260.83 223.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "M261.33 223.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M268.35 223.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad9431",
    d: "M270.86 223.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cead21",
    d: "M271.86 223.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "M272.86 223.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M277.88 223.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "M278.38 223.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M280.38 223.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M282.39 223.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M242.78 224.03l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M243.28 224.03l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M244.12 224.19l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "M244.79 224.03l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314a7b",
    d: "M245.29 224.03l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M246.12 224.19l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M246.79 224.03l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c8c42",
    d: "M256.82 224.03l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "M258.82 224.03l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8442",
    d: "M259.33 224.03l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M260.83 224.03l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8442",
    d: "M261.33 224.03l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "M262.33 224.03l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M262.84 224.03l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "M263.34 224.03l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "M265.34 224.03l.5.477-.5-.477m1.504 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "M268.35 224.03l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "M268.85 224.03l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8442",
    d: "M269.85 224.03l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "M270.86 224.03l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "M271.86 224.03l.5.477-.5-.477m1.003 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M282.39 224.03l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M283.22 224.19l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314a7b",
    d: "M283.89 224.03l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "M284.39 224.03l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M284.89 224.03l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M285.4 224.03l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M285.9 224.03l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M286.4 224.03l.5.477-.5-.477m-46.624.477l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M240.28 224.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M240.78 224.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "M241.28 224.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#29396b",
    d: "M241.78 224.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M242.28 224.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M242.78 224.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M243.28 224.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M250.8 224.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8442",
    d: "M256.32 224.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M256.82 224.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "M271.86 224.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M272.36 224.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295284",
    d: "M272.86 224.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M277.37 224.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M286.23 224.67l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M286.9 224.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10295a",
    d: "M287.4 224.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "M287.9 224.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636b7b",
    d: "M288.4 224.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M288.9 224.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M289.41 224.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M237.77 224.99l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M238.27 224.99l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#525a6b",
    d: "M238.77 224.99l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10295a",
    d: "M239.27 224.99l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M239.77 224.99l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "M245.29 224.99l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M250.8 224.99l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M277.37 224.99l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "M279.88 224.99l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "M280.38 224.99l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "M281.38 224.99l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M289.41 224.99l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M289.91 224.99l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "M290.41 224.99l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M290.91 224.99l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M291.41 224.99l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M291.91 224.99l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M235.76 225.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M236.26 225.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314a7b",
    d: "M236.77 225.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M237.27 225.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M237.77 225.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "M241.28 225.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M241.78 225.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "M242.28 225.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "M244.29 225.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efbd08",
    d: "M244.79 225.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "M245.62 225.62l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a636b",
    d: "M246.29 225.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M250.8 225.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M259.16 225.62l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M259.83 225.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M260.33 225.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#29396b",
    d: "M260.83 225.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425a84",
    d: "M261.33 225.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636b7b",
    d: "M264.34 225.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#737b94",
    d: "M264.84 225.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#29396b",
    d: "M268.35 225.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M269.19 225.62l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M270.19 225.62l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b6b4a",
    d: "M277.37 225.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M280.38 225.47l1.003 3.816-1.003-3.816z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cead21",
    d: "M282.89 225.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a636b",
    d: "M283.39 225.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8442",
    d: "M284.39 225.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "M286.4 225.47l-.5 1.908.5-1.908z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M291.41 225.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M291.91 225.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314a7b",
    d: "M292.41 225.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M292.92 225.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M293.42 225.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M234.26 225.94l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M234.76 225.94l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#31425a",
    d: "M235.26 225.94l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M235.76 225.94l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "M240.78 225.94l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cead21",
    d: "M242.78 225.94l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb518",
    d: "M244.62 226.1l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M245.29 225.94l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb518",
    d: "M246.12 226.1l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M251.3 225.94l.5.477-.5-.477m6.016 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M257.82 225.94l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M269.85 225.94l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M270.36 225.94l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M270.86 225.94l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M271.36 225.94l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M272.03 226.26l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M276.87 225.94l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb518",
    d: "M277.37 225.94l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "M281.89 225.94l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M282.39 225.94l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb518",
    d: "M282.89 225.94l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "M284.39 225.94l1.003.954-1.003-.954zm3.01 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "M287.9 225.94l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "M288.4 225.94l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad9431",
    d: "M288.9 225.94l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a636b",
    d: "M289.41 225.94l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M293.42 225.94l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21315a",
    d: "M293.92 225.94l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M294.42 225.94l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M294.92 225.94l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M233.26 226.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#525a6b",
    d: "M233.76 226.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M234.26 226.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "M238.77 226.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb518",
    d: "M241.28 226.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a636b",
    d: "M241.78 226.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c8c42",
    d: "M242.28 226.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M243.28 226.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "M244.29 226.42l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8442",
    d: "M244.79 226.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "M245.29 226.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295284",
    d: "M245.79 226.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "M246.29 226.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M251.3 226.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M255.82 226.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M256.32 226.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M256.82 226.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M257.82 226.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M270.86 226.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M271.52 226.74l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M272.53 226.74l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M276.87 226.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295284",
    d: "M280.88 226.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "M282.39 226.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8442",
    d: "M282.89 226.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "M283.89 226.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efbd08",
    d: "M284.39 226.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "M285.4 226.42l.5.477-.5-.477m1.67.318l.168.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cead21",
    d: "M287.4 226.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efbd08",
    d: "M287.9 226.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cead21",
    d: "M288.4 226.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295284",
    d: "M289.91 226.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "M290.41 226.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cead21",
    d: "M290.91 226.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8442",
    d: "M291.41 226.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "M291.91 226.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "M292.41 226.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M294.92 226.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#31394a",
    d: "M295.42 226.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M295.92 226.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M296.42 226.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M232.25 226.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212139",
    d: "M232.76 226.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M233.26 226.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "M235.26 226.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c8c42",
    d: "M235.76 226.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb518",
    d: "M236.26 226.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "M237.27 226.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M238.77 226.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "M239.77 226.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "M240.28 226.9l.5 1.43-.5-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M241.28 226.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "M241.78 226.9v1.908h1.003V226.9h-1.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efbd08",
    d: "M242.78 226.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb518",
    d: "M243.28 226.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "M244.29 226.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efbd08",
    d: "M245.29 226.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "M245.79 226.9l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M246.29 226.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M251.3 226.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M253.31 226.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M254.52 227.57v1.15h2.368l-2.368-1.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M255.32 226.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M255.82 226.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#31394a",
    d: "M257.82 226.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M274.37 226.9l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M274.87 226.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M276.54 227.21l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8442",
    d: "M276.87 226.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c8c42",
    d: "M283.39 226.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "M284.06 227.21l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb518",
    d: "M284.89 226.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M285.4 226.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295284",
    d: "M286.4 226.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad9431",
    d: "M287.9 226.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "M288.4 226.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295284",
    d: "M288.9 226.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8442",
    d: "M289.91 226.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c8c42",
    d: "M290.41 226.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb518",
    d: "M290.91 226.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "M291.41 227.85l1.504-.477-1.504.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M292.92 226.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295284",
    d: "M293.92 226.9l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "M296.42 226.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M296.93 226.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M231.25 227.37l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "M231.75 227.37l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M232.25 227.37l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad9431",
    d: "M235.26 227.37l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "M236.6 227.53l.334.16-.334-.16m1.17-.16l.5.478-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M238.77 227.37l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "M241.28 227.37l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "M244.45 227.69l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c8c42",
    d: "M244.79 227.37l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "M246.12 227.53l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8442",
    d: "M246.79 227.37l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M251.97 227.69l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M252.31 227.37l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M252.81 227.37l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M253.31 227.37l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M257.82 227.37l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M258.32 227.37l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21315a",
    d: "M271.36 227.37l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M275.37 227.37l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c8c42",
    d: "M281.89 227.37l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "M282.39 227.37l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efbd08",
    d: "M282.89 227.37l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb518",
    d: "M283.39 227.37l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8442",
    d: "M286.4 227.37l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "M286.9 227.37l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "M287.9 227.37l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a636b",
    d: "M288.4 227.37l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M288.9 227.37l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a636b",
    d: "M289.91 227.37l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "M290.91 227.37l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M291.91 227.37l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M292.41 227.37l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "M292.92 227.37l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efbd08",
    d: "M294.42 227.37l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M296.93 227.37l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212139",
    d: "M297.43 227.37l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M297.93 227.37l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M230.75 227.85l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M231.25 227.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M235.26 227.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295284",
    d: "M236.26 227.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "M236.77 227.85v1.908h.5l-.5-1.908z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c8c42",
    d: "M237.27 227.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "M238.27 227.85l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "M238.77 227.85l.5.477-.5-.477zm6.02 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "M245.62 228.01l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb518",
    d: "M246.29 227.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "M246.79 227.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M252.47 228.17l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M257.82 227.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M258.32 227.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M270.86 227.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M271.36 227.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000818",
    d: "M275.87 227.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "M281.89 227.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "M282.39 227.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M282.89 227.85l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "M283.39 227.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c8c42",
    d: "M284.89 227.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M285.9 227.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "M286.73 228.01l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c8c42",
    d: "M290.91 227.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efbd08",
    d: "M291.41 227.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cead21",
    d: "M293.42 227.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "M296.42 227.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "M296.93 227.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M297.93 227.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M298.43 227.85l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M230.75 228.33l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295284",
    d: "M235.26 228.33l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "M237.27 228.33l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "M238.27 228.33l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M239.77 228.33l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cead21",
    d: "M241.28 228.33l.5.477-.5-.477m1.504 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M244.29 228.33l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M245.29 228.33l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efbd08",
    d: "M246.46 228.65l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad9431",
    d: "M246.79 228.33l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M252.81 228.33l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M252.81 229.28l1.504-.954-1.504.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M254.31 228.33l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#525a6b",
    d: "M258.32 228.33l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M270.86 228.33l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M273.86 228.33l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M273.86 229.28l1.504-.954-1.504.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M275.37 228.33l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M275.87 228.33l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "M280.88 228.33l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c8c42",
    d: "M281.89 228.33l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efbd08",
    d: "M282.89 228.33l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb518",
    d: "M283.39 228.33l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M284.89 228.33l.5.477-.5-.477zm2.01 0l.5.477-.5-.477m1.003 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "M288.4 228.33l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efbd08",
    d: "M288.9 228.33l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cead21",
    d: "M290.91 228.33l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "M291.41 228.33l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M292.92 228.33l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c8c42",
    d: "M297.43 228.33l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M298.43 228.33l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M229.75 228.8l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M230.25 228.8l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efbd08",
    d: "M235.76 228.8l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c8c42",
    d: "M236.26 228.8l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M238.44 229.12l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad9431",
    d: "M239.77 228.8l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8442",
    d: "M240.78 228.8l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad9431",
    d: "M242.11 228.96l.334.16-.334-.16m1.17-.16l.5.478-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efbd08",
    d: "M244.79 228.8l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a636b",
    d: "M246.79 228.8l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M257.32 228.8l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636b7b",
    d: "M258.32 228.8l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M270.36 228.8l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M270.86 228.8l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8442",
    d: "M276.87 228.8l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "M283.39 228.8l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8442",
    d: "M286.4 228.8l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M286.9 228.8l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "M287.9 228.8l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M291.41 228.8l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "M292.41 228.8l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efbd08",
    d: "M292.92 228.8l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "M293.42 228.8l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M293.92 228.8l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "M295.92 228.8l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "M296.42 228.8l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efbd08",
    d: "M297.93 228.8l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M298.93 228.8l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M299.43 228.8l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#525a6b",
    d: "M229.75 229.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "M235.76 229.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb518",
    d: "M236.26 229.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "M237.27 229.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cead21",
    d: "M239.27 229.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "M239.77 229.28l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad9431",
    d: "M241.28 229.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "M242.78 229.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a636b",
    d: "M245.29 229.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "M245.79 229.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "M246.29 229.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "M257.82 229.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M258.32 229.28l.5.477-.5-.477m12.032 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M270.86 229.28l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#31394a",
    d: "M271.36 229.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M284.39 229.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c8c42",
    d: "M284.89 229.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M286.4 229.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad9431",
    d: "M286.9 229.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb518",
    d: "M288.9 229.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "M290.41 229.28l.5.477-.5-.477m1.003 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "M292.41 229.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8442",
    d: "M293.92 229.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cead21",
    d: "M294.42 229.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "M296.93 229.28l-.5 1.908h.5v-1.908z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M297.43 229.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "M298.43 229.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425a84",
    d: "M299.6 229.6l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "M229.75 229.76l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M235.76 229.76l.5.477-.5-.477m1.003 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb518",
    d: "M237.27 229.76l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "M238.27 229.76l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "M239.77 229.76l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M256.32 229.76l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21315a",
    d: "M256.82 229.76l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M257.32 229.76l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M257.82 229.76l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M271.86 229.76l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21315a",
    d: "M272.36 229.76l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M272.86 229.76l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "M287.4 229.76l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8442",
    d: "M288.9 229.76l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M289.41 229.76l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M290.41 229.76l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M291.91 229.76l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "M294.42 229.76l-.5 1.43.5-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "M295.42 229.76l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "M295.92 229.76l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "M296.42 229.76l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "M297.43 229.76l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M298.43 229.76l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M229.75 230.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "M235.76 230.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c8c42",
    d: "M237.77 230.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "M239.27 230.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M245.29 230.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M245.79 230.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M246.29 230.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10295a",
    d: "M246.79 230.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#525a6b",
    d: "M253.31 230.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#848c9c",
    d: "M253.81 230.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M256.32 230.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M272.86 230.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#848c9c",
    d: "M275.37 230.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636b7b",
    d: "M275.87 230.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10295a",
    d: "M282.39 230.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M282.89 230.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M283.39 230.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M283.89 230.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a636b",
    d: "M290.41 230.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M290.91 230.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efbd08",
    d: "M291.91 230.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cead21",
    d: "M292.41 230.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a636b",
    d: "M293.42 230.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb518",
    d: "M293.92 230.24l.5.477-.5-.477m1.838.16l.334.158-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8442",
    d: "M297.43 230.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "M298.43 230.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#525a6b",
    d: "M299.43 230.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M229.75 230.71l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M230.25 230.71l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M236.26 230.71l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a636b",
    d: "M236.77 230.71l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M240.28 231.67l1.504-.477-1.504.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M241.78 230.71l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M242.28 230.71l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314a7b",
    d: "M242.78 230.71l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "M243.28 230.71l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636b7b",
    d: "M243.78 230.71l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M244.29 230.71l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M244.79 230.71l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M245.29 230.71l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M245.79 230.71l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M283.39 230.71l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M283.89 230.71l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M284.39 230.71l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M284.89 230.71l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M285.4 230.71l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "M285.9 230.71l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314a7b",
    d: "M286.4 230.71l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M286.9 230.71l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M287.4 230.71l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M288.24 230.87l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "M292.41 230.71l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b63",
    d: "M294.92 230.71l.5.477-.5-.477zm1 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295284",
    d: "M296.93 230.71l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "M297.93 230.71l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M299.43 230.71l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M229.75 231.19l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M230.25 231.19l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M240.78 231.19l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M241.28 231.19l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M241.78 231.19l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M287.9 231.19l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M288.4 231.19l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M288.9 231.19l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "M293.92 231.19l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M294.42 231.19l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb518",
    d: "M294.92 231.19l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9c29",
    d: "M295.92 231.19l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b52",
    d: "M296.42 231.19l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M298.93 231.19l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M299.43 231.19l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M228.74 231.67l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M229.25 231.67l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M229.91 231.98l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M238.77 231.67l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M239.27 231.67l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M239.77 231.67l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "M240.78 231.67l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M287.9 231.67l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212139",
    d: "M288.4 231.67l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M288.9 231.67l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M289.57 231.98l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "M294.92 231.67l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c8c42",
    d: "M295.42 231.67l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295284",
    d: "M297.43 231.67l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M299.43 231.67l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "M299.93 231.67l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M300.44 231.67l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M228.24 232.14l-1.003 1.43 1.003-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "M228.74 232.14l-1.003 1.43 1.003-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "M229.25 232.14c-1.44 1.502-3.482 3.17-2.507 5.247-2.66 1.437-3.133 4.547-4.01 7.156l5.514.954 4.01-9.064-5.514.477v-.477l5.014-.477-2.507-3.816z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M236.26 232.14l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M236.77 232.14l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M237.6 232.3l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M238.77 232.14l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M241.28 232.14l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M287.9 232.14l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M288.4 232.14l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M291.41 232.14l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a8c",
    d: "M295.92 232.14l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395273",
    d: "M296.42 232.14l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M300.44 232.14l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M300.94 232.14l1.504 1.43-1.504-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M229.75 232.62l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M230.25 232.62l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M234.76 232.62l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M235.6 232.78l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M236.26 232.62l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "M241.28 232.62l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636b7b",
    d: "M287.9 232.62l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M291.41 232.62l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M291.91 232.62l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M292.75 232.78l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M293.58 232.94l.167.318-.167-.318m7.353-.318l.5.477-.5-.478z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M230.25 233.1l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M233.42 233.42l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M234.09 233.26l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M237.77 233.1l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M240.78 233.1l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21315a",
    d: "M241.28 233.1l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M287.4 233.1l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "M287.9 233.1l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M288.74 233.26l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M289.41 233.1l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M289.91 233.1l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M290.41 233.1l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M294.25 233.26l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M301.44 233.1l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M226.74 233.57l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212139",
    d: "M227.24 233.57l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M230.25 233.57l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M230.75 233.57l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M232.59 233.73l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M236.26 233.57l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M236.77 233.57l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M237.27 233.57l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M240.78 233.57l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M241.28 233.57l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M287.4 233.57l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M287.9 233.57l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M288.4 233.57l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M290.41 233.57l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M291.24 233.73l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M291.91 233.57l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M294.92 233.57l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M295.42 233.57l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M295.92 233.57l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M301.94 233.57l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M302.44 233.57l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M226.74 234.05l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M232.25 234.05l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M235.6 234.21l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M236.26 234.05l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "M240.28 234.05l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M288.4 234.05l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21315a",
    d: "M288.9 234.05l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M291.91 234.05l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M292.41 234.05l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M292.92 234.05l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#31425a",
    d: "M302.44 234.05l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M302.94 234.05l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M226.24 234.53l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M226.74 234.53l.5.477-.5-.477m4.01 0l.502.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M234.59 234.69l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M238.77 234.53l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21315a",
    d: "M239.27 234.53l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M239.77 234.53l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M240.28 234.53l.5.477-.5-.477m48.63 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M289.41 234.53l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314a7b",
    d: "M289.91 234.53l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M290.41 234.53l.5.477-.5-.477m2.507 0l-.502.954.502-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M293.42 234.53l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M293.92 234.53l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M302.94 234.53l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M225.74 235.01l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "M226.24 235.01l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M231.75 235.01l.5.477-.5-.477m1.003 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M233.59 235.17l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M236.26 235.01l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M236.77 235.01l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M237.27 235.01l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "M237.77 235.01l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M238.27 235.01l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M238.77 235.01l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M290.41 235.01l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M290.91 235.01l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#525a6b",
    d: "M291.41 235.01l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10295a",
    d: "M291.91 235.01l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M292.92 235.01l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "M293.42 235.01l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M293.92 235.01l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M294.42 235.01l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M294.92 235.01l.5.477-.5-.477m2.005 0l.502.477-.502-.477m6.016 0l.503.477-.502-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M303.44 235.01l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M225.74 235.48l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M231.75 235.48l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M232.76 235.48l.5.477-.5-.477m1.504 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21315a",
    d: "M234.76 235.48l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#525a6b",
    d: "M235.26 235.48l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M236.26 235.48l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M236.77 235.48l.5.477-.5-.477m55.648 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M292.92 235.48l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#525a6b",
    d: "M293.92 235.48l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21315a",
    d: "M294.42 235.48l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M296.42 235.48l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "M303.44 235.48l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M225.24 235.96l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10295a",
    d: "M225.74 235.96l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M229.75 235.96l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21315a",
    d: "M233.26 235.96l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M233.76 235.96l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M234.26 235.96l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M236.26 235.96l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M291.91 235.96l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M292.41 235.96l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M294.25 236.12l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M294.92 235.96l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "M295.42 235.96l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#080829",
    d: "M295.92 235.96l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M298.43 235.96l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M303.94 235.96l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M225.24 236.44l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M226.74 236.44l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M227.57 236.6l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M228.24 236.44l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M232.76 236.44l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M233.26 236.44l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M296.42 236.44l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10295a",
    d: "M296.93 236.44l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M299.93 236.44l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M300.77 236.6l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M301.6 236.76l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212139",
    d: "M303.94 236.44l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M224.73 236.91l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "M231.75 236.91l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M232.25 236.91l-.5.954.5-.954m64.672 0l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "M297.43 236.91l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M301.94 236.91l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M302.44 236.91l2.005 1.908-2.005-1.908z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M303.94 236.91l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M304.45 236.91l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M224.73 237.39l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M225.24 237.39l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10295a",
    d: "M231.25 237.39l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101831",
    d: "M297.93 237.39l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "M304.45 237.39l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M224.23 237.87l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101829",
    d: "M224.73 237.87l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M230.75 237.87l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M231.25 237.87l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M235.76 237.87l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M236.26 237.87v.477h57.653l-17.547-.477H236.26m61.663 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M298.43 237.87l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M304.45 237.87l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M304.95 237.87l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M224.23 238.35l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M224.73 238.35l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M230.75 238.35l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M235.76 238.35l2.507 2.385-2.507-2.385z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M236.26 238.35l1.504 1.43-1.504-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "M236.77 238.35l4.21 5.247.302 18.604h4.512c0-5.938 1.325-12.01-3.008-16.695l6.016 3.817-2.507-7.156 14.037 13.357-10.528-16.22 10.027 12.88h.503V238.35H236.77z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M260.33 238.35v14.31h.5l-.5-14.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M268.85 238.35v14.31h.5l-.5-14.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M269.35 238.35v13.357l10.528-12.403-10.528 16.22 14.54-13.358-3.01 6.678 6.017-3.816c-3.243 5.94-3.008 10.374-3.008 17.173h4.51l.303-18.603 4.21-5.247H269.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M292.92 238.35l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M293.42 238.35l-1.003 1.43 1.003-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M298.43 238.35l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M298.93 238.35l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M304.95 238.35l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M223.73 238.82l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000818",
    d: "M224.23 238.82l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M230.25 238.82l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M230.75 238.82l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M292.41 238.82l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21315a",
    d: "M298.93 238.82l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M303.94 238.82l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "M304.95 238.82l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M305.45 238.82l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M223.73 239.3l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M224.23 239.3l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M230.25 239.3l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M249.8 239.3l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M298.93 239.3l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M304.61 239.62l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M305.45 239.3l.5.477-.5-.477m-82.05.795l.166.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "M223.73 239.78l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M229.75 239.78l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M230.25 239.78l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M237.77 239.78l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M249.8 239.78l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212139",
    d: "M250.3 239.78l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#100808",
    d: "M279.38 239.78l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M291.91 239.78l-3.008 3.34 3.008-3.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M298.93 239.78l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10295a",
    d: "M299.43 239.78l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#31425a",
    d: "M305.45 239.78l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10295a",
    d: "M223.73 240.25l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "M229.75 240.25l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M238.27 240.25l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M249.8 240.25l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b5a00",
    d: "M250.3 240.25l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M278.38 240.25l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b5a00",
    d: "M278.88 240.25l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M299.43 240.25l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M305.45 240.25l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M305.95 240.25l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M223.23 240.73l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M229.25 240.73l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M229.75 240.73l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M238.27 240.73l2.507 2.385-2.507-2.385z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "M238.77 240.73l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392121",
    d: "M250.3 240.73l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cea508",
    d: "M250.97 241.05l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293129",
    d: "M251.3 240.73l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M277.88 240.73l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#634a00",
    d: "M278.88 240.73l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M279.38 240.73l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M299.43 240.73l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M299.93 240.73l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636b7b",
    d: "M305.95 240.73l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "M223.23 241.21l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21315a",
    d: "M229.25 241.21l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "M239.27 241.21l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M250.3 241.21l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efbd08",
    d: "M251.3 241.21l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a2908",
    d: "M277.37 241.21l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efbd08",
    d: "M278.38 241.21l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M278.88 241.21l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "M299.93 241.21l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "M305.95 241.21l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M222.73 241.68l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M223.23 241.68l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M229.25 241.68l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "M239.77 241.68l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#634a00",
    d: "M250.8 241.68l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb508",
    d: "M251.3 241.68l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "M251.81 241.68l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M277.37 241.68l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M278.88 241.68l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M299.93 241.68l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M300.44 241.68l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M305.95 241.68l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M306.45 241.68l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M222.73 242.16l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M223.23 242.16l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M228.74 242.16l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M229.25 242.16l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "M240.28 242.16l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M246.46 242.48l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10295a",
    d: "M250.8 242.16l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000818",
    d: "M251.3 242.16l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M251.81 242.16l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M252.31 242.16l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M276.87 242.16l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M277.37 242.16l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#210800",
    d: "M277.88 242.16l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M278.38 242.16l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M282.89 242.16l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M283.39 242.16l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M288.9 242.16l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M300.44 242.16l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M306.45 242.16l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636b7b",
    d: "M222.73 242.64l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21315a",
    d: "M228.74 242.64l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10295a",
    d: "M240.78 242.64l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#102110",
    d: "M246.79 242.64l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M247.29 242.64l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "M251.81 242.64l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M252.81 242.64l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M276.37 242.64l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M277.21 242.8l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M277.88 242.64l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M281.89 242.64l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a2908",
    d: "M282.39 242.64l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#310000",
    d: "M282.89 242.64l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M288.4 242.64l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "M300.44 242.64l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314a7b",
    d: "M306.45 242.64l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "M222.73 243.12l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636b7b",
    d: "M228.74 243.12l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "M240.78 243.12v19.558h.5c0-5.58 1.76-14.43-.5-19.558z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#634a00",
    d: "M246.79 243.12l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c7300",
    d: "M247.29 243.12l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "M247.8 243.12l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M251.81 243.12l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M252.31 243.12l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181000",
    d: "M252.81 243.12l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M275.87 243.12l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#311000",
    d: "M276.37 243.12l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M276.87 243.12l-1.003 1.43 1.003-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M277.37 243.12l.5.477-.5-.477m4.01 0l.502.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b5a00",
    d: "M281.89 243.12l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b5a00",
    d: "M282.39 243.12l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M282.89 243.12l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M288.4 243.12v19.08h.5c0-5.453 1.71-14.066-.5-19.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M300.44 243.12l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M306.45 243.12l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M306.95 243.12l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M222.23 243.59l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M222.73 243.59l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M228.24 243.59l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M228.74 243.59l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M246.79 243.59l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9408",
    d: "M247.29 243.59l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cea508",
    d: "M247.8 243.59l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293129",
    d: "M248.3 243.59l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M248.8 243.59l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M252.31 243.59l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M252.81 243.59l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101829",
    d: "M253.31 243.59l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M275.87 243.59l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#420000",
    d: "M276.87 243.59l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M280.38 243.59l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a2908",
    d: "M280.88 243.59l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9408",
    d: "M281.38 243.59l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efbd08",
    d: "M281.89 243.59l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M282.39 243.59l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M300.44 243.59l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M300.94 243.59l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M306.95 243.59l.5.477-.5-.477m-84.725.477l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M228.24 244.07l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M228.74 244.07l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313918",
    d: "M247.29 244.07l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "M247.8 244.07l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad8c08",
    d: "M248.3 244.07l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M248.8 244.07l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101829",
    d: "M252.81 244.07l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M253.81 244.07l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M275.37 244.07l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M276.87 244.07l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M280.38 244.07l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b5a00",
    d: "M280.88 244.07l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "M281.38 244.07l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#634a00",
    d: "M281.89 244.07l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M282.39 244.07l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "M300.94 244.07l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M301.94 244.07l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#525a6b",
    d: "M306.95 244.07l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M221.73 244.55l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M222.23 244.55l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M222.73 244.55l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M223.23 244.55l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "M223.73 244.55l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M224.23 244.55l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M224.73 244.55l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314a7b",
    d: "M228.24 244.55l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M247.29 244.55l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#423100",
    d: "M247.8 244.55l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M248.3 244.55l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181000",
    d: "M248.8 244.55l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M249.3 244.55l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181000",
    d: "M253.31 244.55l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M253.81 244.55l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M254.31 244.55l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M274.87 244.55l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M276.37 244.55l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M279.88 244.55l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M280.88 244.55l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M281.89 244.55l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636b7b",
    d: "M300.94 244.55l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000818",
    d: "M301.94 244.55l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M304.45 244.55l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M304.95 244.55l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314a7b",
    d: "M305.45 244.55l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636b7b",
    d: "M305.95 244.55l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M306.45 244.55l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M306.95 244.55l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M222.73 245.02l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M223.23 245.02l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M223.73 245.02l.5.477-.5-.477m1.003 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M225.24 245.02l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314a7b",
    d: "M225.74 245.02l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M226.24 245.02l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M228.24 245.02l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M229.25 245.02l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M229.75 245.02l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M248.3 245.02l1.504 1.43-1.504-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M248.8 245.02l3.51 3.34-3.51-3.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001010",
    d: "M249.3 245.02l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M253.31 245.02l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M253.81 245.02l1.504 1.43-1.504-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "M254.31 245.02l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#310000",
    d: "M274.87 245.02l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M275.37 245.02l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M275.87 245.02l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#420000",
    d: "M280.88 245.02l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M281.38 245.02l.5.477-.5-.477m5.013 0l.502.477-.502-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M300.94 245.02l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "M301.94 245.02l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M302.94 245.02l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21315a",
    d: "M303.44 245.02l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M303.94 245.02l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M305.78 245.18l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M221.22 245.5l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M221.73 245.5l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M223.23 245.5l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M223.73 245.5l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M224.23 245.5l1.504 1.908-1.504-1.908z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M224.73 245.5l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M225.57 245.66l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M226.24 245.5l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M226.74 245.5l1.504 2.385-1.504-2.385z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314a7b",
    d: "M227.24 245.5l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M227.74 245.5l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M228.24 245.5l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M229.25 245.5l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M229.75 245.5l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M286.09 245.17l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000818",
    d: "M243.28 245.5l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M243.78 245.5l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001010",
    d: "M249.8 245.5l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M253.81 245.5l.5.477-.5-.477m1.003 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M274.37 245.5l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M274.87 245.5l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M279.38 245.5l-1.003 1.43 1.003-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M279.88 245.5l-1.504 1.908 1.504-1.908z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M280.88 245.5l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M285.4 245.5l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#310000",
    d: "M285.9 245.5l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M286.4 245.5l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M295.09 245.82l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M297.43 245.5l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M297.93 245.5l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M300.94 245.5l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#080829",
    d: "M301.44 245.5l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M301.94 245.5l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M302.44 245.5l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M302.94 245.5l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M303.44 245.5l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M304.95 245.5l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M305.45 245.5l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M221.22 245.98l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M221.73 245.98l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M223.23 245.98l.5.477-.5-.477m3.51 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M227.57 246.14l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M228.74 245.98l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M229.25 245.98l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M229.75 245.98l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M230.25 245.98l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M243.28 245.98l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c7300",
    d: "M243.78 245.98l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392121",
    d: "M244.29 245.98l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M244.79 245.98l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M248.8 245.98v3.34h.5l-.5-3.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001010",
    d: "M250.3 245.98l.5.477-.5-.477m4.01 0l.502.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M255.32 245.98l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M273.86 245.98l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M273.86 246.93l1.504-.477-1.504.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M275.37 245.98l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001010",
    d: "M279.88 245.98l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b1821",
    d: "M280.38 245.98l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M284.39 245.98l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a2908",
    d: "M284.89 245.98l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c7300",
    d: "M285.4 245.98l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M285.9 245.98l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M295.42 245.98l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "M297.93 245.98l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M298.43 245.98l.5.477-.5-.477m2.34.16l.334.158-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.44 245.98l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M301.94 245.98l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M302.44 245.98l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M302.94 245.98l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M304.95 245.98l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M305.45 245.98l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M221.22 246.45l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M222.06 246.61l.334.16-.334-.16m2.005 0l.334.16-.335-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M225.74 246.45l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M226.24 246.45l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M227.24 246.45l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M228.24 246.45l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M228.74 246.45l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M229.25 246.45l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M229.75 246.45l-1.003 3.816h-.5l1.002-3.34h-.503l-.5 3.817 2.004-.954-2.505 3.815 2.005-1.43-2.507 1.907-.5 2.386h.5l5.014-5.725-1.504.477v-.477l1.504-.477v-.477h-2.006l-.5-3.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M230.25 246.45l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#102121",
    d: "M243.78 246.45l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efbd08",
    d: "M244.29 246.45l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad8c08",
    d: "M244.79 246.45l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#102121",
    d: "M245.29 246.45l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M245.79 246.45l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "M249.3 246.45c.048 3.826 2.298 5.608 5.515 7.633-.255-3.214-2.978-5.686-5.515-7.633z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001010",
    d: "M249.8 246.45l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M250.8 246.45l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M254.31 246.45l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M255.15 246.61l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M255.82 246.45l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M273.36 246.45l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M274.37 246.45l-1.003 1.43 1.003-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M274.87 246.45l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "M279.88 246.45l-5.013 7.633c2.775-1.652 6.545-4.118 5.013-7.633z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M283.39 246.45l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b2908",
    d: "M283.89 246.45l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c7b08",
    d: "M284.39 246.45l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "M284.89 246.45l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M285.9 246.45l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "M297.93 246.45l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M298.43 246.45l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M300.77 246.61l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103910",
    d: "M301.44 246.45l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M301.94 246.45l.5 10.018h.503l1.504-8.587h-.502l-1.002 5.726h-.502l-.5-7.156z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M302.44 246.45l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M302.94 246.45l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M304.45 246.45l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M305.45 246.45l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M306.45 246.45l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M306.95 246.45l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M308.46 246.45l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M221.22 246.93l1.504 1.43-1.504-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M222.23 246.93l.5 1.43h.503l-1.003-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M222.73 246.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M224.23 246.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M224.73 246.93l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M225.74 246.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213918",
    d: "M226.24 246.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M226.74 246.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M228.24 246.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M229.41 247.25l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M230.25 246.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M230.75 246.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a4208",
    d: "M244.29 246.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "M244.79 246.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9408",
    d: "M245.29 246.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M245.79 246.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001010",
    d: "M250.3 246.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M251.3 246.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M254.81 246.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M255.32 246.93l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001010",
    d: "M255.82 246.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M265.84 246.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#420000",
    d: "M273.36 246.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M274.37 246.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M277.88 246.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181000",
    d: "M278.88 246.93l-1.003 1.43 1.003-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M279.38 246.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M283.39 246.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b5a00",
    d: "M283.89 246.93l.5.477-.5-.477m1.003 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M285.4 246.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M294.92 246.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103910",
    d: "M295.42 246.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M295.92 246.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a6342",
    d: "M297.93 246.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M300.94 246.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M301.44 246.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b8c73",
    d: "M302.44 246.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395231",
    d: "M303.94 246.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M304.45 246.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M306.95 246.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M307.96 246.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M308.46 246.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M221.22 247.41l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M224.73 247.41l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M225.24 247.41l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M225.74 247.41l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M226.24 247.41l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M226.74 247.41l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M228.24 247.41l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M230.75 247.41l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M244.29 247.41l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b5a00",
    d: "M244.79 247.41l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M245.29 247.41l1.504.954-1.504-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M246.29 247.41l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001010",
    d: "M250.8 247.41l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M251.81 247.41l.5.477-.5-.477m3.51 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M256.32 247.41l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9408",
    d: "M264.34 247.41v.477l1.003 1.908h.5l-1.503-2.385z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M272.86 247.41l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#311000",
    d: "M273.86 247.41l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M274.37 247.41l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M277.37 247.41l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M277.88 247.41l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M278.88 247.41l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M282.89 247.41l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M283.39 247.41l-1.003 1.43 1.003-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181000",
    d: "M283.89 247.41l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b5a00",
    d: "M284.39 247.41l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M284.89 247.41l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M294.92 247.41l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M295.42 247.41l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M295.92 247.41l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M297.93 247.41l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M298.43 247.41l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M298.93 247.41l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M300.94 247.41l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M301.44 247.41l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a6342",
    d: "M302.44 247.41v2.385h.5l-.5-2.385z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M303.44 247.41l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M304.28 247.57l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M304.95 247.41l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M305.45 247.41l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M306.28 247.57l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M306.95 247.41l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M307.45 247.41l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103910",
    d: "M307.96 247.41l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M308.46 247.41l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M220.72 247.89l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M221.22 247.89l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M223.23 247.89l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M224.73 247.89l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "M225.24 247.89l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M225.74 247.89v1.43l1.504-.476v-.477l-1.504-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213918",
    d: "M226.74 247.89l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M227.74 247.89l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M229.08 248.04l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M230.75 247.89l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M245.29 247.89l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M246.79 247.89l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M250.8 247.89l1.504 1.43-1.504-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181000",
    d: "M251.3 247.89l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M252.31 247.89l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181000",
    d: "M255.82 247.89l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M256.48 248.2l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M256.82 247.89l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b5a00",
    d: "M263.84 247.89v1.908h.5l-.5-1.908z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "M264.34 247.89v2.385h-2.005v1.43h2.005v5.725h.5l.503-5.724h2.506v-1.43h-2.507v-2.386h-1.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M272.36 247.89l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M273.2 248.04l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M273.86 247.89l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M277.37 247.89l-1.504 1.908 1.504-1.908z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M278.38 247.89l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M282.39 247.89l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M283.89 247.89l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M284.39 247.89l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M295.42 247.89l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M295.92 247.89l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M296.42 247.89l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M297.93 247.89l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M298.43 247.89l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M298.93 247.89l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M300.94 247.89l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395231",
    d: "M303.44 247.89l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M304.45 247.89l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M304.95 247.89l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M305.45 247.89l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M305.95 247.89l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M306.95 247.89l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M307.45 247.89l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M307.96 247.89l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M221.73 248.36l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M222.23 248.36l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M223.06 248.52l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M223.73 248.36l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M224.73 248.36l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M225.24 248.36c-1.362 2.92-1.188 4.692 0 7.633h1.003l1.002-7.156h-.5l-.502 5.724h-1.003v-6.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M227.24 248.36l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M228.91 248.68l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M230.75 248.36l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M245.79 248.36l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#100808",
    d: "M246.29 248.36l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M246.79 248.36l2.005 1.908-2.005-1.908z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M247.29 248.36l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181000",
    d: "M251.81 248.36l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M252.31 248.36l2.005 2.385-2.005-2.385z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M252.81 248.36l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M255.82 248.36l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181000",
    d: "M256.82 248.36l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#311000",
    d: "M272.36 248.36l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M272.86 248.36l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M273.36 248.36l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M276.37 248.36l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M277.88 248.36l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M281.89 248.36l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M283.39 248.36l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M295.42 248.36l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M295.92 248.36l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103910",
    d: "M296.42 248.36l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M296.93 248.36l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M297.93 248.36l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M298.43 248.36l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M298.93 248.36l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M299.43 248.36l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M300.94 248.36l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M303.44 248.36l.5.477-.5-.477m1.003 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M304.95 248.36l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M305.78 248.52l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M306.45 248.36l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M306.95 248.36l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M307.45 248.36l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M307.96 248.36l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M224.73 248.84l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M227.24 248.84l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M230.75 248.84l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M245.79 248.84v13.357h-4.512v.477l5.013-.477v2.385h.503c0-4.117 1.645-12.417-1.003-15.742z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001010",
    d: "M246.79 248.84l.5.477-.5-.477m1.003 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M253.31 248.84l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M256.32 248.84l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M256.82 248.84l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101829",
    d: "M257.32 248.84l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M271.86 248.84l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#420000",
    d: "M272.86 248.84l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M275.87 248.84l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M277.37 248.84l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M280.88 248.84l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M281.38 248.84l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M281.89 248.84l-1.504 1.908 1.504-1.908z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181000",
    d: "M282.39 248.84l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M282.89 248.84l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M283.39 248.84v13.357h.5l-.5-13.357z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M295.42 248.84l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M296.26 249l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M296.93 248.84l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M297.93 248.84l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M298.43 248.84l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M298.93 248.84l2.005 11.926h.502c.83-4.254.04-8.275-2.507-11.926z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M299.43 248.84l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M300.44 248.84l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M300.94 248.84l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M303.44 248.84l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M304.45 248.84l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M306.45 248.84l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M306.95 248.84l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "M307.45 248.84l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M223.73 249.32l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M224.23 249.32l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M225.9 249.63l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M227.24 249.32l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M228.58 249.48l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M230.25 249.32l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M231.08 249.48l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M231.75 249.32l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8442",
    d: "M232.25 249.32l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M232.76 249.32l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M233.26 249.32l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "M246.79 249.32c0 3.607-1.78 12.99.515 15.884 1.008 1.27 3.493 1.394 5 1.766 0-7.3 1.478-13.1-5.515-17.65z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101829",
    d: "M247.29 249.32l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#100808",
    d: "M248.3 249.32l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M248.8 249.32l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M252.31 249.32l.5.477-.5-.477m1.504 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001010",
    d: "M256.82 249.32l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M257.82 249.32l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M271.36 249.32l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M271.36 250.27l1.504-.954-1.504.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M272.86 249.32l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M275.37 249.32l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M276.87 249.32l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1831",
    d: "M280.38 249.32l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#311000",
    d: "M280.88 249.32l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001010",
    d: "M281.89 249.32l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "M277.37 266.97c1.632-.403 3.99-.547 5.212-1.766 2.583-2.578.804-12.41.804-15.884-7.824 3.45-6.016 10.735-6.016 17.65z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M295.42 249.32l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M295.92 249.32l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M296.42 249.32l4.01 15.265h-.5c-.798-2.673-3.967-12.84-8.022-9.063 5.372.22 7.147 9.323 8.02 13.356h.503l6.518-19.08h-.5l-5.015 12.402h-.5c-1.357-4.06-1.248-9.78-4.513-12.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M296.93 249.32l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M297.43 249.32l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M297.93 249.32l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M298.43 249.32l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M299.43 249.32l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M299.93 249.32l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M300.44 249.32l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M300.94 249.32l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395231",
    d: "M302.94 249.32l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a6342",
    d: "M304.45 249.32l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M305.95 249.32l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M306.79 249.48l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M307.45 249.32l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M223.73 249.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M227.24 249.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M228.24 249.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M229.25 249.79l-2.005.477v.477l2.005-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M229.75 249.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M232.42 250.11l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M232.76 249.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M233.26 249.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M233.76 249.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M247.8 249.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181000",
    d: "M248.8 249.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M249.3 249.79l1.003.954-1.003-.954m3.51 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181000",
    d: "M253.81 249.79l1.504 1.43-1.504-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M254.31 249.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M257.65 249.95l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M258.32 249.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M261.33 249.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada584",
    d: "M261.83 249.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c7b08",
    d: "M263.84 249.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cea508",
    d: "M265.34 249.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9463",
    d: "M265.84 249.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdb584",
    d: "M266.34 249.79v.477h1.504l-1.504-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M267.85 249.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M270.86 249.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M272.36 249.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M274.87 249.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#210800",
    d: "M275.37 249.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M275.87 249.79l-1.003 1.43 1.003-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M276.37 249.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M279.88 249.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#100808",
    d: "M280.38 249.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101829",
    d: "M281.38 249.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M293.42 249.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M293.92 249.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M295.92 249.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103910",
    d: "M297.43 249.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M297.93 249.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M298.43 249.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M299.43 249.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M300.44 249.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "M302.44 249.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M302.94 249.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M304.45 249.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M305.45 249.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M305.95 249.79l.5.477-.5-.477m1.003 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M307.45 249.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5231",
    d: "M223.73 250.27l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M225.74 250.27v1.43h.5l-.5-1.43m3.51 0l.5.477-.5-.477m2.34.16l.333.158-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M232.76 250.27l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M233.26 250.27l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M248.3 250.27l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M248.8 250.27v.477l1.504.477-1.504-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M253.31 250.27l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M254.81 250.27l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M257.32 250.27l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M257.82 250.27l1.504 1.43-1.504-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "M258.32 250.27l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd9408",
    d: "M261.83 250.27v1.43h.5l-.5-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#310000",
    d: "M270.86 250.27l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M271.36 250.27l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M271.86 250.27l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M274.37 250.27l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#311000",
    d: "M274.87 250.27l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M275.87 250.27l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M279.38 250.27l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181000",
    d: "M279.88 250.27l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M280.88 250.27l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "M293.92 250.27l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M294.42 250.27l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M295.92 250.27l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M297.43 250.27l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M297.93 250.27l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M298.43 250.27l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M299.93 250.27l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M300.44 250.27l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M302.44 250.27v2.862h.5l-.5-2.862z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M302.94 250.27l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M304.45 250.27l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M305.45 250.27l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M305.95 250.27l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M306.95 250.27l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M223.73 250.75l.5.477-.5-.477m4.01 0l.502.477-.5-.477m1 0l.503.477-.502-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M230.75 250.75l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M231.25 250.75l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M232.25 250.75l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M232.76 250.75l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M248.8 250.75l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M250.3 250.75l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M253.81 250.75l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M254.31 250.75l4.01 3.816-4.01-3.816z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M257.82 250.75l.5.477-.5-.477m1.003 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M270.36 250.75l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#311000",
    d: "M271.36 250.75l.5.477-.5-.477m3.008 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M275.37 250.75l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M278.88 251.7l1.504-.477-1.504.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M280.38 250.75l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M293.92 250.75l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M294.42 250.75l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M295.92 250.75l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M296.42 250.75l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295210",
    d: "M297.93 250.75l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395231",
    d: "M298.43 250.75l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M299.93 250.75l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M300.44 250.75l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M303.94 250.75l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M304.45 250.75l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M304.95 250.75l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M305.45 250.75l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M306.45 250.75l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M306.95 250.75l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M223.23 251.23l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M223.73 251.23l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M227.74 251.23l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M228.24 251.23l-.5 1.43h.5v-1.43m2.005 0l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M231.75 251.23l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M232.25 251.23l.5.477-.5-.477m2.005 0l.502.477-.502-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M249.3 251.23l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M250.3 251.23l2.005 1.908-2.005-1.908z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M254.31 251.23l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001010",
    d: "M255.32 251.23l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "M258.32 251.23l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M259.33 251.23l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M269.85 251.23l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M269.85 252.18l1.504-.477-1.504.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M271.36 251.23l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#310000",
    d: "M273.86 251.23l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#422100",
    d: "M274.37 251.23l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101829",
    d: "M274.87 251.23l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M278.38 251.23l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181000",
    d: "M279.38 251.23l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M279.88 251.23l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#426331",
    d: "M293.92 251.23l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M294.42 251.23l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M294.92 251.23l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M296.42 251.23l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M297.93 251.23l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "M298.43 251.23l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M300.44 251.23l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M303.94 251.23l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M304.45 251.23l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M304.95 251.23l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M305.45 251.23l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M306.45 251.23l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M223.4 252.02l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M225.74 251.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M227.41 252.02l.167.318-.167-.318m.836-.318l.5.477-.5-.478z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M231.75 251.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "M234.26 251.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M234.76 251.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M238.77 251.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M239.27 251.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M239.77 251.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001010",
    d: "M250.3 251.7l.5.477-.5-.477m1.003 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M254.81 251.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001010",
    d: "M255.82 251.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M258.32 251.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M259.16 251.86l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M261.33 251.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada584",
    d: "M261.83 251.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c7b08",
    d: "M263.84 251.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cea508",
    d: "M265.34 251.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9463",
    d: "M265.84 251.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M267.85 251.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M269.35 251.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M270.36 251.7l-1.003 1.43 1.003-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M270.86 251.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M273.36 251.7l-1.003 1.43 1.003-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M273.86 251.7l-1.003 1.43 1.003-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001010",
    d: "M274.37 251.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M278.38 251.7l-1.504 1.908 1.504-1.908z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M279.38 251.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a6342",
    d: "M293.92 251.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M294.42 251.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M294.92 251.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M296.42 251.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M298.43 251.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M300.44 251.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M300.94 251.7l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M303.94 251.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M304.45 251.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M304.95 251.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M305.95 251.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M306.45 251.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M307.96 251.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "M308.46 251.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M308.96 251.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M309.46 251.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M225.24 252.18v2.385h1.003v-2.385h-1.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M229.25 252.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M231.25 252.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M231.75 252.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M233.76 252.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M234.26 252.18l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M234.76 252.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M237.77 252.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5231",
    d: "M238.27 252.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M238.77 252.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#396b10",
    d: "M239.27 252.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M239.77 252.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M250.8 252.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181000",
    d: "M251.81 252.18l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M252.31 252.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M255.32 252.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001010",
    d: "M256.32 252.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M258.82 252.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M259.33 252.18l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001010",
    d: "M259.83 252.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b5a00",
    d: "M263.84 252.18v5.247h.5l-.5-5.247z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#420000",
    d: "M269.35 252.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M270.36 252.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M273.86 252.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314a7b",
    d: "M274.37 252.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001010",
    d: "M277.37 252.18l.5.477-.5-.477m1.003 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M293.92 252.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M294.42 252.18l2.507 4.293h.5l-3.007-4.293z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M294.92 252.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M295.42 252.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M296.42 252.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M296.93 252.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M298.43 252.18l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M298.93 252.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M300.94 252.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M303.94 252.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M304.45 252.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M304.95 252.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M305.95 252.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M306.45 252.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M307.45 252.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M307.96 252.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M305.45 255.52l5.013-1.43-1.002-1.91-4.01 3.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M309.46 252.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M309.96 252.18l.5.477-.5-.477m-86.73.477l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M223.73 252.66l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M227.41 252.97l.167.318-.167-.318m1.337-.318l.5.477-.5-.478z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M229.25 252.66l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M231.25 252.66l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M233.76 252.66l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M234.26 252.66l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M235.26 252.66l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M237.27 252.66l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M237.77 252.66l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M236.26 259.81h-.5v-5.247h-.503l-.5 2.385h-.502v-2.385h-.502l-3.008 10.972h.502l1.002-1.908h.5l-1.002 2.385h.5l2.508-3.34-2.005 4.294h.502l5.067-7.156.948-7.155c-3.278 1.504-3.008 4.076-3.008 7.155z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M239.27 252.66l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M251.3 252.66l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M252.81 252.66l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M255.32 252.66l1.504 1.43-1.504-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M255.82 252.66l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M256.82 252.66l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101829",
    d: "M259.33 252.66l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.33 252.66l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#210800",
    d: "M268.85 252.66l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M270.36 252.66l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "M273.36 252.66l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M273.86 252.66l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M276.37 252.66l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181000",
    d: "M276.87 252.66l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M277.88 252.66l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M294.08 252.97l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M294.42 252.66l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103910",
    d: "M295.42 252.66l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M295.92 252.66l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M296.42 252.66l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M296.93 252.66l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M298.43 252.66l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M300.94 252.66l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "M303.94 252.66l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M304.45 252.66l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M305.95 252.66l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M306.95 252.66l-1.003 1.43 1.003-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M307.45 252.66l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M309.96 252.66l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#396b10",
    d: "M223.73 253.13l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M228.24 253.13l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M228.74 253.13l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M230.75 253.13l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M231.25 253.13l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M233.76 253.13l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M234.59 253.29l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M235.26 253.13l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M236.77 253.13l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M237.27 253.13l.5.477-.5-.477m1.504 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M239.27 253.13l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M251.81 253.13l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M252.64 253.29l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M256.32 253.13l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M257.32 253.13l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181000",
    d: "M259.83 253.13l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M260.5 253.45l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M260.83 253.13l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M268.35 253.13l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M269.85 253.13l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M271.86 253.13l-1.003 1.43 1.003-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M272.36 253.13l-2.507 2.862 2.507-2.862z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212118",
    d: "M272.86 253.13l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M273.36 253.13l-1.003 1.43 1.003-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M275.87 253.13l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181000",
    d: "M276.37 253.13l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M277.37 253.13l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M292.92 253.13l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M293.42 253.13l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M294.42 253.13l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M295.42 253.13l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M295.92 253.13l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395231",
    d: "M296.93 253.13l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M298.93 253.13v1.43h.5l-.5-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M301.27 253.29l.334.16-.334-.16m1.17-.16l.5.478-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "M303.94 253.13l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M304.45 253.13l.5.477-.5-.477m1.003 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M305.95 253.13l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M306.95 253.13l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M309.96 253.13l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M310.46 253.13l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M223.73 253.61l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M226.74 253.61v.477h1.504l-1.504-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M228.24 253.61l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M229.75 253.61l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M230.25 253.61l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M233.26 253.61l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M233.76 253.61l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M233.76 254.09v.477l1.504.477v-1.43l-1.504.476z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5231",
    d: "M235.26 253.61l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M236.77 253.61l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M238.6 253.77l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M239.27 253.61l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M252.31 253.61l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212118",
    d: "M252.81 253.61l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M253.31 253.61l2.005 1.908-2.005-1.908z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M253.81 253.61l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "M256.82 253.61l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M257.82 253.61l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M259.83 253.61l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211810",
    d: "M260.83 253.61l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M261.33 253.61l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M268.35 253.61l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M268.85 253.61l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M269.35 253.61l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M276.2 253.77l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M276.87 253.61l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M292.41 253.61l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M292.92 253.61l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M293.42 253.61l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295210",
    d: "M293.92 253.61l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M294.42 253.61l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M295.92 253.61l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M296.42 253.61l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M296.93 253.61l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M301.44 253.61l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M303.44 253.61l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M303.94 253.61l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M305.45 253.61l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M306.45 253.61l.5.477-.5-.477m1.003 0l-3.008 1.908v.477l1.002.477 2.006-2.862z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M307.96 253.61l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M308.46 253.61l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M308.96 253.61l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M309.46 253.61l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "M310.46 253.61l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M223.73 254.09l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M224.23 254.09l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M226.74 254.09l.5.477-.5-.477m1.003 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M228.74 254.09l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5231",
    d: "M229.25 254.09l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M229.75 254.09l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M233.26 254.09l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M235.26 254.09l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M235.76 254.09l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M236.26 254.09l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M237.94 254.41l.167.318-.167-.318m.836-.318v3.34h.5l-.5-3.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.481,
    fill: "#8c8c8c",
    d: "M252.31 254.09v12.88h.5l-.5-12.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M252.81 254.09l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211810",
    d: "M253.31 254.09l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M254.31 254.09l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M256.82 254.09l1.504 1.43-1.504-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212118",
    d: "M257.32 254.09l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M258.32 254.09l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M260.33 254.09l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M260.83 254.09l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M261.33 254.09l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M267.85 254.09l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#310000",
    d: "M268.85 254.09l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M274.87 254.09l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M275.37 254.09l-1.504 1.908 1.504-1.908z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212118",
    d: "M275.87 254.09l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M276.37 254.09l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M276.87 254.09v12.88h.5l-.5-12.88m15.04 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M292.41 254.09l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M294.42 254.09l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M294.92 254.09l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M296.42 254.09l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M297.43 254.09l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M301.44 254.09l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M301.94 254.09l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M303.44 254.09l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M307.45 254.09l-1.003 1.43 1.003-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M307.96 254.09l-1.504 1.908 1.504-1.908z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M309.46 254.09l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M310.46 254.09l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M310.96 254.09l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M224.23 254.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M226.74 254.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M227.24 254.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M228.74 254.56l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M229.25 254.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M229.75 254.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M230.25 254.56l.5.477-.5-.477m2.507 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M233.26 254.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M253.31 254.56l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M253.81 254.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.81 254.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M255.32 254.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212118",
    d: "M257.82 254.56l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M258.32 254.56l2.005 2.385-2.005-2.385z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M258.82 254.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M260.33 254.56v1.43h.5l-.5-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M260.83 254.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M261.83 254.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M267.35 254.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M268.02 254.88l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211810",
    d: "M268.35 254.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M270.36 254.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M271.86 254.56l-1.003 1.43 1.003-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M273.86 254.56l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "M274.37 254.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211810",
    d: "M275.37 254.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M275.87 254.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M291.41 254.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M291.91 254.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M294.92 254.56l1.504 1.43-1.504-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M295.42 254.56l.5.477-.5-.477m1.003 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M296.93 254.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M297.43 254.56l.5.477-.5-.477m1.504 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M299.43 254.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M301.94 254.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M303.44 254.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M304.95 254.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M310.46 254.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M310.96 254.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M224.23 255.04l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M224.73 255.04l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M226.57 255.2l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M227.74 255.04l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M229.25 255.04l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M229.75 255.04l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#396b10",
    d: "M230.25 255.04l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M230.75 255.04l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M231.25 255.04l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M232.76 255.04l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M234.26 255.04l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M235.76 255.04v4.293h.5l-.5-4.293z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M237.6 255.2l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M254.31 255.04l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211810",
    d: "M255.32 255.04l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M255.82 255.04l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M259.33 255.04l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M260.83 255.04l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392121",
    d: "M261.33 255.04l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M261.83 255.04l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M262.33 255.04l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M266.85 255.04l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211810",
    d: "M267.35 255.04l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M268.35 255.04l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M269.85 255.04l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M273.86 255.04l.5.477-.5-.477m1.003 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M275.37 255.04l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "M291.41 255.04l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M292.41 255.04l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M292.92 255.04l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M293.42 255.04l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M295.92 255.04l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M296.93 255.04l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M297.43 255.04l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M299.27 255.2l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M301.94 255.04l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M302.94 255.04l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M303.44 255.04l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M304.95 255.04l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M308.12 255.36l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M224.73 255.52l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M226.4 255.84l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M227.74 255.52l.5.477-.5-.477m1.67.318l.168.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M230.08 255.68l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M230.75 255.52l.5 4.293h.503l-1.003-4.293z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M231.25 255.52l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M231.75 255.52l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M232.25 255.52l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M254.81 255.52l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M255.32 255.52l1.504.954v-.477l-1.504-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212118",
    d: "M255.82 255.52l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M258.32 255.52l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M259.83 255.52l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M261.33 255.52l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M261.83 255.52l1.504 1.43-1.504-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M262.33 255.52l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M262.84 255.52l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M266.85 255.52l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M267.35 255.52l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M267.85 255.52l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M269.35 255.52l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M272.86 255.52l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211810",
    d: "M273.36 255.52l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M274.37 255.52l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M290.91 255.52l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M291.41 255.52l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M291.91 255.52l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M292.41 255.52l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M292.92 255.52l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M293.42 255.52l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M293.92 255.52l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M295.42 255.52l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M297.43 255.52l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M298.93 255.52l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M299.43 255.52l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M301.94 255.52l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M302.94 255.52l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M304.95 255.52l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293129",
    d: "M305.95 255.52l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M306.95 255.52l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "M307.45 255.52l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M222.73 256l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M223.23 256l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M224.73 256l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "M225.24 256l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M225.74 256l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M227.24 256l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M229.75 256c-.107 2.545-.633 4.77 2.005 6.2l-2.005-6.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M230.42 256.31l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M231.75 256l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M232.25 256l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M255.32 256l.5.477-.5-.477m1.504 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M258.82 256l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181000",
    d: "M259.83 256l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M260.33 256l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M261.83 256l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M262.84 256l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M266.34 256l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M266.85 256l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.35 256l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M267.85 256l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M268.35 256l-.5 1.43.5-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M268.85 256l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#210800",
    d: "M269.35 256l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M269.85 256l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M270.36 256l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M272.36 256l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212118",
    d: "M272.86 256l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M273.36 256l-1.003 1.43 1.003-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M273.86 256l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M290.41 256l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M291.24 256.15l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M291.91 256l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M293.92 256l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M294.42 256l.5.477-.5-.477m1.504 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M296.42 256l.5.477-.5-.477m1.003 0l1.002.954-1.002-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M297.93 256l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M299.43 256l.5.477-.5-.477m2.507 0l1.002.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M302.94 256l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M304.45 256l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M305.45 256l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M305.95 256l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M306.45 256l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M306.95 256l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "M307.45 256l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M309.96 256l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M310.46 256l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M222.73 256.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M223.73 256.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1010",
    d: "M224.73 256.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M225.24 256.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M225.74 256.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#311000",
    d: "M226.24 256.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M226.74 256.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M227.24 256.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M229.25 256.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M232.25 256.47l-.5.954.5-.954m2.005 0l.502.477-.502-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M255.82 256.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212118",
    d: "M256.32 256.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M256.82 256.47l2.005 1.908-2.005-1.908z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M257.32 256.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M258.99 256.79l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "M259.33 256.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M260.83 256.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M261.83 256.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392121",
    d: "M262.33 256.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M263.34 256.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c7b08",
    d: "M265.34 256.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M265.84 256.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M266.34 256.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M266.85 256.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.85 256.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M270.52 256.79l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M271.86 256.47l.5.477-.5-.477m1.504 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M290.41 256.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M290.91 256.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M291.41 256.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M294.42 256.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M294.92 256.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M296.42 256.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M296.42 257.43l1.504-.477-1.504.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M299.43 256.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M301.94 256.47v1.43h.5l-.5-1.43m1.003 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M304.45 256.47l-.5 1.43.5-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M305.95 256.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M306.45 256.47l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M306.95 256.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M307.45 256.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M308.96 256.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M309.46 256.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M309.96 256.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M310.46 256.47l-1.003 1.43 1.003-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M222.73 256.95l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M223.23 256.95l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M223.73 256.95l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M224.23 256.95l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M224.73 256.95l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M226.24 256.95l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M226.74 256.95l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#526b42",
    d: "M229.25 256.95l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M230.58 257.11l.334.16-.334-.16m1.67-.16l.502.478-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M233.76 256.95l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#524242",
    d: "M256.32 256.95l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#210800",
    d: "M256.82 256.95l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M257.82 256.95l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M258.32 256.95l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M259.49 257.27l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M259.83 256.95l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M260.33 256.95l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211810",
    d: "M260.83 256.95l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M261.33 256.95l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M262.33 256.95l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M262.84 256.95l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212118",
    d: "M263.34 256.95l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b5a10",
    d: "M264.84 256.95l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M265.34 256.95l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M266.34 256.95l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M266.85 256.95l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M267.35 256.95l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M268.35 256.95l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M268.85 256.95l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M270.02 257.27l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M271.36 256.95l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M271.86 256.95l-1.504 1.908 1.504-1.908z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#524242",
    d: "M272.86 256.95l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M290.41 256.95l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M292.92 256.95l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M293.42 256.95l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M294.42 256.95l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M294.92 256.95l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M296.93 256.95l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M297.43 256.95l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M297.93 256.95l-.5 1.43.5-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M299.43 256.95l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "M302.44 256.95l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M303.94 256.95l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M305.11 257.27l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M305.45 256.95l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M306.45 256.95l-3.51 5.247 3.51-5.247z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "M306.95 256.95l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M307.96 256.95l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M308.46 256.95l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M308.96 256.95l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M309.46 256.95l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M222.73 257.43v.954l1.003-.954h-1.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M223.73 257.43l1.003 1.908-1.504-.954c.49 1.924 1.006 3.09 3.007 3.816v.477l-2.006-.477 1.004 1.43-1.504-.476 4.512 4.294.5-1.908 1.505.954-3.008-2.863v-.476l1.503.477c-.73-2.894-2.22-4.817-5.013-6.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M224.23 257.43l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M224.73 257.43l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M225.24 257.43l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M226.24 257.43l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M226.74 257.43l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M227.24 257.43l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M229.25 257.43l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M230.75 257.43l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M231.75 257.43v4.293h.5l-.5-4.293m2.172.318l.168.318-.168-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M237.27 257.43l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#527b31",
    d: "M238.77 257.43l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.575,
    fill: "#734a42",
    d: "M256.32 257.43v10.495h.5l-.5-10.495z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M256.82 257.43l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#311000",
    d: "M257.32 257.43l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M258.32 257.43l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M258.82 257.43l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M259.83 257.43v.954h1.003l-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M261.33 257.43l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M262.33 257.43l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M262.84 257.43l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392121",
    d: "M263.34 257.43l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#423100",
    d: "M263.84 257.43l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5231",
    d: "M264.34 257.43l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M264.84 257.43l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M265.34 257.43l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M265.84 257.43l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M266.34 257.43l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M268.85 257.43l-2.005.954v.477l2.506-.953-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M270.36 257.43l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M270.86 257.43l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#210800",
    d: "M271.86 257.43l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M272.36 257.43l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#734a42",
    d: "M272.86 257.43l-.5 10.972h.5c.905-2.913 1.247-8.143 0-10.972z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.42 257.43l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M294.92 257.43l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M295.42 257.43l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M296.93 257.43l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M297.43 257.43l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M299.77 257.59l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M302.44 257.43l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M304.45 257.43l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M305.45 257.43l.5.477-.5-.477m1.003 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M306.95 257.43l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M307.45 257.43l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M307.96 257.43l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M308.46 257.43l-1.003.477v.477l1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M308.96 257.43l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M223.23 257.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M223.73 257.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293100",
    d: "M225.24 257.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#311000",
    d: "M225.74 257.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M226.24 257.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M227.24 257.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a2121",
    d: "M227.74 257.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M228.24 257.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M228.74 257.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M229.25 257.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M237.1 258.06l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#526b42",
    d: "M238.77 257.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M256.82 257.9v10.018l5.515.954c-1.204-3.52-1.936-9.067-5.515-10.972z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M257.82 257.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#100808",
    d: "M258.82 257.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M259.33 257.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#310000",
    d: "M260.83 257.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#524242",
    d: "M261.33 257.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M262 258.22l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M263.84 257.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M264.51 258.22l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M264.84 257.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M266.85 257.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M268.85 257.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#100808",
    d: "M269.35 257.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M269.85 257.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "M270.36 257.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#311000",
    d: "M271.36 257.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M271.86 257.9l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M272.36 257.9l-2.005 1.43 2.005 6.203-3.51.954.502 1.908 3.51-.477-.502-10.018z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M293.42 257.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M293.92 257.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395231",
    d: "M295.42 257.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M297.93 257.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M298.43 257.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M299.93 257.9v1.43h.5l-.5-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M301.94 257.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M302.44 257.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "M303.94 257.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M304.45 257.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M304.95 257.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#102110",
    d: "M306.45 257.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M306.95 257.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M307.96 258.38v.477h1.504l-1.504-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#426331",
    d: "M222.73 258.38l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M223.73 258.38l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M224.23 258.38l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M225.74 258.38l1.504 1.43-1.504-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M226.24 258.38l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M227.91 258.7l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M228.41 258.7l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M228.74 258.38l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M229.25 258.38l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M233.76 258.38l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M238.77 258.38l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M258.32 258.38l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M258.82 258.38l1.003.954v-.954h-1.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M259.83 258.38l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a2121",
    d: "M260.33 258.38l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M261 258.7l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M262.33 258.38v.477h1.504l-1.504-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M263.84 258.38l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M265.84 258.38l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M266.34 258.38l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M267.35 258.38l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M269.35 258.38l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M269.85 258.38l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M270.86 258.38l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a6342",
    d: "M293.42 258.38l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M293.92 258.38l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M294.42 258.38l.5.477-.5-.477m1.17.318l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M295.92 258.38l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M297.43 258.38l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "M297.93 258.38l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M298.43 258.38l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M302.11 258.7l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M303.44 258.38l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M303.94 258.38l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M304.45 258.38l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M305.95 258.38l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M306.45 258.38l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M306.95 258.38l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M307.45 258.38l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M308.46 258.38l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M309.46 258.38l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M222.73 258.86l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M224.23 258.86l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M226.74 258.86l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M228.74 258.86l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M233.59 259.02l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M238.77 258.86l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M258.82 258.86l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.83 258.86l2.507 9.54c3.053-1.066 7.74-1.487 9.525-4.293l-9.024 2.863-3.008-8.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M260.33 258.86l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M261.33 258.86l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M261.83 258.86l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M264.34 258.86l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M264.84 258.86l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M266.34 258.86l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M268.02 259.18l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M268.35 258.86l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M269.19 259.02l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.85 258.86l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M270.36 258.86l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M293.42 258.86l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M293.92 258.86l4.01 15.265h-.5v-.954h-.502l.5 4.294h-.5v-.954h-.5v3.816h-.503c-.042-4.86-1.967-9.208-4.512-13.357l-1.002.953v.477c3.673 3.488 4.798 10.968 5.014 15.742h-1.003l-2.004-10.018h-.5l1.503 13.357h-.503l-2.005-10.017h-.5l1.503 15.265h-.502l-1.002-12.403h-.5l1.002 12.403h-.5l-.503-6.678h-.502l.5 8.11h-.5l-.5-6.68h-.503l-1.504 9.065 5.516-.477v-.477l-3.51-.476v-.477l13.036 3.34v-.478l-6.016-1.91v-.476l9.024 1.908c-2.83-3.43-6.43-2.878-10.528-2.385v-.477l11.53.477v-.477l-8.02-1.908v-.477l8.02.477v-.477c-5.732-1.247-8.607-.53-13.034 3.34l1.002-4.772h-.5l-.502 1.432h-.502l2.507-7.156h.5l-.5 5.246 11.53-4.293v-.477l-10.527 2.862c4.018-3.14 9.828-5.807 15.04-6.2v-.478c-6 0-9.22 1.376-14.037 4.77 3.77-4.68 9.63-5.16 15.04-7.155v-.477c-6.807.51-10.042 2.052-15.542 5.724 3.402-3.234 9.21-8.877 14.54-7.632l-1.004-2.385c-4.616 1.043-8.634 3.593-12.032 6.678 2.335-3.127 10.544-11.767 14.54-11.45-4.055-3.54-11.837 7.26-14.54 9.542l11.03-11.926-9.526 8.108 10.528-13.357v-.476c-4.99 1.752-6.462 7.684-10.027 10.972l7.52-11.926c-3.35 2.3-6.083 6.67-7.018 10.495-2.31.276-1.505 3.916-1.505 5.724h-.502c0-5.8-.7-12.852-4.512-17.65z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M294.42 258.86l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M294.92 258.86l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M295.92 258.86l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M297.93 258.86l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M298.43 258.86l.5.477-.5-.477m5.013 0l.502.477-.502-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M303.94 258.86l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M304.45 258.86l.5.477-.5-.477m1.003 0l1.002.954-1.002-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M305.95 258.86l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M306.95 258.86l-3.008 2.385v.477l3.008-2.862z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M307.45 258.86l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M307.96 258.86l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#102110",
    d: "M308.46 258.86l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M308.96 258.86l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M222.73 259.33l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M223.23 259.33l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M224.73 259.33l1.504 1.43-1.504-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M227.24 259.33l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#733939",
    d: "M227.74 259.33l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M228.24 259.33l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M228.74 259.33l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M230.75 259.33l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M233.26 259.33l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M235.76 259.33l.5.477-.5-.477m2.507 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M238.77 259.33l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#100808",
    d: "M259.33 259.33l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M260.33 259.33l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M262.33 259.33l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M262.84 259.33v.477h1.504l-1.504-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M264.34 259.33l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M266.34 259.33l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M267.18 259.49l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M268.35 259.33l.5.477-.5-.477m1.003 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#210800",
    d: "M269.85 259.33l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M292.41 259.33l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M292.92 259.33l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M293.42 259.33l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M294.42 259.33l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M294.92 259.33l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "M295.42 259.33l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M295.92 259.33l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M296.42 259.33l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M297.93 259.33l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "M298.43 259.33l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M299.93 259.33l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M300.44 259.33l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M301.77 259.49l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#102110",
    d: "M303.44 259.33l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M303.94 259.33l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M305.45 259.33l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M307.45 259.33l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M307.96 259.33l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M308.46 259.33l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M222.73 259.81l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M223.23 259.81l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M227.24 259.81l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M227.74 259.81l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M228.74 259.81l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M229.25 259.81l.5.477-.5-.477m1.504 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M233.26 259.81l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M235.26 259.81l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M236.6 259.97l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M238.27 259.81l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#420000",
    d: "M259.33 259.81l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "M260.33 259.81l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M261.33 259.81l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M261.83 259.81l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M262.33 259.81l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M266.18 259.97l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M266.85 259.81l1.003 2.862h.5l-1.503-2.862m1.504 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M269.02 260.13l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M269.35 259.81l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M269.85 259.81l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M270.36 259.81l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M292.41 259.81l.5.477-.5-.477m1.003 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M293.92 259.81l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M294.92 259.81l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M295.42 259.81l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M295.92 259.81l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M296.42 259.81l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M296.93 259.81l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M298.43 259.81l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M299.93 259.81l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M301.44 259.81l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M302.94 259.81l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M303.44 259.81l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M304.95 259.81l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M306.45 259.81l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M306.95 259.81l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M307.45 259.81l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103910",
    d: "M307.96 259.81l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M308.46 259.81l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M223.23 260.29l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M227.74 260.29l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M228.74 260.29l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#396b10",
    d: "M229.25 260.29l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M233.26 260.29l.5.477-.5-.477m1.003.954l1.504-.477-1.504.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M236.26 260.29l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M238.27 260.29l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M259.33 260.29l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M261.33 260.29l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M262.84 260.29l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M263.34 260.29l.5.477-.5-.477m1.504 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M265.34 260.29l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M267.35 260.29l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M268.18 260.45l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M269.35 260.29l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M269.85 260.29l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M270.36 260.29l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M292.41 260.29l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "M292.92 260.29l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M293.42 260.29l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M293.92 260.29l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M294.92 260.29l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "M295.42 260.29l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M295.92 260.29l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M296.42 260.29l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M296.93 260.29l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M298.76 260.45l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M300.44 260.29l.5.477-.5-.477m1.003 0l.5.477-.5-.477m1.504 0l.5.477-.5-.477m2.005 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.95 260.29l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M306.45 260.29l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M307.45 260.29l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M307.96 260.29l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M222.73 260.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M223.23 260.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M223.73 260.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "M226.24 260.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M227.74 260.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M229.25 260.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M229.75 260.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M234.76 260.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M235.26 260.77l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M235.76 260.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M236.26 260.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213918",
    d: "M237.77 260.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M238.27 260.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M259.33 260.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M260.83 260.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M261.83 260.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M262.67 260.92l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M263.34 260.77l1.504 1.43-1.504-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M265.34 260.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M265.84 260.77l1.003 1.43-1.003-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M266.68 260.92l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M269.35 260.77l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M269.85 260.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#210800",
    d: "M270.36 260.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103910",
    d: "M292.92 260.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M293.42 260.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M293.92 260.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M294.92 260.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "M295.42 260.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M295.92 260.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103910",
    d: "M296.42 260.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M296.93 260.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M298.93 260.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M300.44 260.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M301.44 260.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M302.44 260.77l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M302.94 260.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M304.45 260.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "M305.45 260.77l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M305.95 260.77l.5.477-.5-.477m1.003 0l-.502.954.503-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M307.45 260.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M307.96 260.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M308.46 260.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M308.96 260.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c9c84",
    d: "M309.46 260.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M309.96 260.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M310.46 260.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M222.73 261.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M223.23 261.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M223.73 261.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M226.24 261.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M226.74 261.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M228.24 261.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M229.75 261.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M234.26 261.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M235.26 261.24l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M235.76 261.24l.5.477-.5-.477m1.504 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M237.77 261.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#420000",
    d: "M259.83 261.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "M260.83 261.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M261.33 261.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M261.83 261.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M264.34 261.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M264.84 261.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M265.34 261.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M266.34 261.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M267.85 261.24v.477h1.504l-1.504-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M269.35 261.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M270.36 261.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M270.86 261.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a6342",
    d: "M292.92 261.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "M293.42 261.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a6342",
    d: "M293.92 261.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M295.42 261.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M295.42 262.2l1.504-.477-1.504.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M296.93 261.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M297.43 261.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M298.93 261.24l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M299.43 261.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M302.44 261.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M305.45 261.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M306.95 261.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M307.45 261.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M307.96 261.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M308.46 261.24l.5.477-.5-.477m1.504 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M310.46 261.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M310.96 261.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M311.46 261.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M312.13 261.56l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M222.73 261.72l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M223.23 261.72l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M223.73 261.72l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M224.23 261.72l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M224.73 261.72l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M226.74 261.72l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M227.41 262.04l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M228.24 261.72l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M229.75 261.72l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M230.25 261.72l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M231.75 261.72l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M233.76 261.72l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M235.26 261.72l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M236.77 261.72l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M237.27 261.72l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M259.83 261.72l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M261.33 261.72l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M262.33 261.72l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M263.17 261.88l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M263.84 261.72l.5.477-.5-.477m1.838.16l.334.158-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M266.85 261.72l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M267.35 261.72l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M270.36 261.72l-2.005.477v.477l2.506-.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M270.86 261.72l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M292.92 261.72l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M293.42 261.72l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "M293.92 261.72l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M295.92 261.72l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M296.42 261.72l2.005 8.11h.502c-.026-2.93-.393-5.855-2.507-8.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M296.93 261.72l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M297.43 261.72l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M298.93 261.72l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M300.94 261.72l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M302.44 261.72l.5.477-.5-.477m1.504 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M304.45 261.72l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M304.95 261.72l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M306.45 261.72l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M306.95 261.72l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M307.45 261.72l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M308.96 261.72l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M309.46 261.72l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M309.96 261.72l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295210",
    d: "M310.46 261.72l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a6342",
    d: "M310.96 261.72l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M311.46 261.72l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M222.73 262.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M223.23 262.2l1.504.954-1.504-.954m1.504 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M225.24 262.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M225.74 262.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M228.24 262.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M228.74 262.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M230.25 262.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M230.75 262.2v.477h1.504l-1.504-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M233.26 262.2l.5.477-.5-.477m1.504 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M245.79 262.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M259.83 262.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M261.33 262.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M261.83 262.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M262.33 262.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M263 262.51l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M265.01 262.51l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M265.51 262.51l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M266.01 262.51l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M266.34 262.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M266.85 262.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M270.36 262.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#210800",
    d: "M270.86 262.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "M283.39 262.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M283.89 262.2v.477h4.512l-4.512-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "M288.4 262.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M291.41 262.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M292.92 262.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M293.42 262.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "M293.92 262.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M295.92 262.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M296.93 262.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "M297.43 262.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M297.93 262.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M299.6 262.51l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M301.94 262.2l.5.477-.5-.477m1.504 0l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M303.94 262.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M304.45 262.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M305.95 262.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M306.45 262.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M306.95 262.2l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M307.45 262.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M308.46 262.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M308.96 262.2l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5231",
    d: "M223.23 262.67l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M226.57 262.83l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M228.74 262.67l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M230.75 262.67l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M231.25 262.67l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M232.76 262.67l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M233.26 262.67l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M234.26 262.67l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M235.76 262.67l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M236.26 262.67l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M240.78 262.67l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.309,
    fill: "#bdbdbd",
    d: "M241.28 262.67v.477h4.512v7.155c2.72-4.32.175-7.63-4.512-7.632z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M245.79 262.67l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#420000",
    d: "M260.33 262.67l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "M261.33 262.67l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M262.33 263.15v.477l2.507-.477h-2.507m5.013-.477l.502.477-.502-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M267.85 262.67l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M268.35 262.67l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "M270.86 262.67l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M271.36 262.67l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M283.39 262.67l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M283.89 262.67v.477h4.512l-4.512-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M288.4 262.67l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "M291.41 262.67l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M291.91 262.67l.5.477-.5-.477m1.17.318l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M293.42 263.63l1.504-.477-1.504.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M295.92 262.67l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M296.42 262.67l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M297.43 262.67l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M297.93 262.67l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M301.94 262.67l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M302.44 262.67l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M302.94 262.67l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M305.95 262.67l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M306.95 262.67l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M307.96 262.67l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M223.23 263.15l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M224.23 263.15l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M224.73 263.15l.5.477-.5-.477m2.84.16l.335.158-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M228.74 263.15l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M230.75 263.15l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "M231.25 263.15l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M232.76 263.15l.5.477-.5-.477m1.003 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M234.26 263.15l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M235.26 263.15l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M235.76 263.15l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M240.78 263.15v3.816h.5l-.5-3.816z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M260.33 263.15l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M261.83 263.15l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M263.34 263.15l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M265.34 263.15l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M265.84 263.15l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M266.68 263.31l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M267.35 263.15l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M268.35 263.15l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M268.85 263.15l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M269.69 263.31l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M270.36 263.15l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M270.86 263.15l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M271.36 263.15l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M283.39 263.15v6.2h.5l-.5-6.2m5.013 0v7.155h.502l-.502-7.155z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M291.41 263.15l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395231",
    d: "M291.91 263.15l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M293.92 263.15l2.507 8.586h.5l-3.007-8.586z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M294.42 263.15l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M295.92 263.15l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M298.1 263.47l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M299.43 263.15l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M299.93 263.15l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M301.44 263.15l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M302.77 263.31l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M303.44 263.15l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M305.45 263.15l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.95 263.15l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M306.45 263.15l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M307.96 263.15l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M223.23 263.63l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M223.73 263.63l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M225.24 263.63l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M225.9 263.95l.167.318-.167-.318m1.838-.318l.502.477-.502-.478z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M228.24 263.63l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213918",
    d: "M228.74 263.63l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M230.75 263.63l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M231.25 263.63l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M232.25 263.63l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M233.26 263.63l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M233.76 263.63l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213918",
    d: "M234.76 263.63l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M235.26 263.63l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M260.33 263.63l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M261.83 263.63l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M263.34 263.63l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M263.84 263.63l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M264.34 263.63v.477h1.504l-1.504-.477m2.005 0l-1.504.954v.477l1.505-1.43m1.504 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M268.35 263.63l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M268.85 263.63l.5.477-.5-.477m2.005 0l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#210800",
    d: "M271.36 263.63l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M291.41 263.63l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M292.08 263.95l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M292.41 263.63l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M293.42 263.63l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M294.42 263.63l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M294.92 263.63l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M296.42 263.63l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M298.43 263.63l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M300.1 263.95l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M301.44 263.63l.5.477-.5-.477m1.003 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M303.44 263.63l.5.477-.5-.477m2.005 0l.502.477-.502-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M305.95 263.63l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M307.45 263.63l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M307.96 263.63l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M309.88 265.94l-2.005 3.34c1.344-.938 2.617-1.733 2.005-3.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M312.97 263.63l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M223.73 264.1l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M224.23 264.1l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M226.24 264.1l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M229.25 264.1l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M230.75 264.1l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M231.75 264.1l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M232.25 264.1l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M233.26 264.1l.5.477-.5-.477m1.003 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M234.76 264.1l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M236.6 264.26l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#420000",
    d: "M260.83 264.1l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "M261.83 264.1l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M262.84 264.1l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M263.34 264.1l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M263.84 264.1l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M267.35 264.1l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M267.85 264.1l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M270.86 264.1l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M271.86 264.1l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M291.41 264.1l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M292.41 264.1l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M292.92 264.1l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M293.58 264.42l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M294.92 264.1l.5.477-.5-.477m1.504 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M296.93 264.1l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M298.43 264.1l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M300.94 264.1l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M301.44 264.1l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M301.94 264.1l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M302.94 264.1l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M305.45 264.1l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M306.95 264.1l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M307.45 264.1l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M311.97 264.1l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M312.47 264.1l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M224.23 264.58l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M226.74 264.58l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M227.24 264.58l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M229.25 264.58l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M230.08 264.74l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M230.75 264.58l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M231.75 264.58l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M232.76 264.58l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M233.26 264.58l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M234.26 264.58l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M236.26 264.58l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M236.77 264.58l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M246.29 264.58l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M260.83 264.58l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M262.33 264.58l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M264.34 264.58l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M266.34 264.58l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M266.85 264.58l.5.477-.5-.477m1.504 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M268.85 264.58l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M269.35 264.58l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M271.86 264.58l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M292.41 264.58l3.51 11.45h.5c-.034-3.994-1.295-8.33-4.01-11.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M292.92 264.58l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M294.92 264.58l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M296.93 264.58l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M298.6 264.9l.167.318-.167-.318m2.34-.318l.5.477-.5-.478z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M301.44 264.58l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M301.94 264.58l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M302.94 264.58l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M304.95 264.58l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103910",
    d: "M306.95 264.58l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M307.45 264.58l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M308.46 264.58l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M308.96 264.58l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M310.96 264.58l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M311.46 264.58l-1.003 1.908 1.003-1.908z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M311.97 264.58l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M224.23 265.06l1.504 1.43-1.504-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M224.73 265.06l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M227.74 265.06l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M229.75 265.06l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M230.25 265.06l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M231.25 265.06l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M231.75 265.06l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M232.76 265.06l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M233.76 265.06l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M234.26 265.06l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M235.76 265.06l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5231",
    d: "M236.77 265.06l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101829",
    d: "M246.29 265.06l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M260.83 265.06l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M262.33 265.06l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M263 265.38l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M263.34 265.06l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M263.84 265.06l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M264.34 265.06l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M266.85 265.06l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M267.35 265.06l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M267.85 265.06l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#210800",
    d: "M271.36 265.06l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M271.86 265.06l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "M282.89 265.06l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a6342",
    d: "M292.08 265.38l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M292.92 265.06l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M293.58 265.38l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M295.25 265.22l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M296.93 265.06l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M301.27 265.22l.334.16-.334-.16m1.17-.16l.5.478-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M304.45 265.06l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M306.45 265.06l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M306.95 265.06l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M307.45 265.06l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M307.96 265.06l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M308.46 265.06l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M308.96 265.06l.5.477-.5-.477m1.003 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M310.46 265.06l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M310.96 265.06l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M218.72 265.54l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M219.22 265.54l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M225.24 265.54l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M225.74 265.54l1.003.954-1.003-.954m3.008 0l.5.477-.5-.477m1.003 0l.502.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M230.25 265.54l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M230.75 265.54l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "M231.25 265.54l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M232.25 265.54v.954h1.003l-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M232.76 265.54l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5231",
    d: "M233.76 265.54l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M235.26 265.54l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M236.77 265.54l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M237.27 265.54l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M246.29 265.54l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M246.79 265.54l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "M247.29 265.54l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#420000",
    d: "M261.33 265.54l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "M262.33 265.54l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M263.34 265.54l.5.477-.5-.477m1.504 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M265.34 265.54l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M266.18 265.69l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M266.85 265.54l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "M267.35 265.54l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#310000",
    d: "M269.85 265.54l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M270.36 265.54l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M281.89 265.54l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636b7b",
    d: "M282.39 265.54l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M282.89 265.54l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M293.92 265.54l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M295.42 265.54l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M296.93 265.54l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M297.43 265.54l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M298.43 265.54l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M298.93 265.54l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M300.6 265.85l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M301.44 265.54l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M301.94 265.54l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M302.44 265.54l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M304.28 265.69l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M306.45 265.54l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M306.95 265.54l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M307.79 265.69l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M308.46 265.54l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M309.46 265.54l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M309.96 265.54l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M310.46 265.54l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c9c84",
    d: "M218.72 266.01l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M219.22 266.01l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M225.74 266.01l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "M228.74 266.01l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M229.25 266.01l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "M230.25 266.01l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M231.08 266.17l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#311000",
    d: "M231.75 266.01l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M233.76 266.01l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M234.76 266.01l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M235.26 266.01l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M233.14 270.89h-.5c-.095-2.733-1.16-4.483-4.012-5.247.07 1.455 1.116 7.137 3.51 5.247h.5l-1.002 4.293c1.497-1.58 7.68-7.142 5-9.593-2.293-2.097-3.47 4.253-3.496 5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M236.26 266.01l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M237.27 266.01l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M247.29 266.01l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M247.8 266.01l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#31425a",
    d: "M248.3 266.01l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M248.8 266.01l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M261.33 266.01l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M262.84 266.01l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M263.84 266.01l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M264.34 266.01l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#310000",
    d: "M268.85 266.01l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M269.35 266.01l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M280.38 266.01l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21315a",
    d: "M280.88 266.01l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M281.38 266.01l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M281.89 266.01l.5.477-.5-.477m8.523 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M290.91 266.01l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M291.41 266.01l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M291.91 266.01l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M293.92 266.01l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M295.42 266.01l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M295.92 266.01l-.5.954.5-.954m1.003 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M301.44 266.01l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M303.94 266.01l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M305.95 266.01l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#102110",
    d: "M306.45 266.01l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M307.29 266.17l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M307.96 266.01l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M308.46 266.01l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M308.96 266.01l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M309.46 266.01l-1.504 2.385 2.507-2.385h-1.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M219.22 266.49l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M219.72 266.49l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M225.74 266.49l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M226.24 266.49l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M226.74 266.49l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M228.24 266.49v.477h1.504l-1.504-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M229.75 266.49l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M230.25 266.49l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M231.92 266.81l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "M232.25 266.49l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M233.26 266.49l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M233.76 266.49l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M234.26 266.49l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M234.76 266.49l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M235.93 266.81l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M237.43 266.81l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M248.8 266.49l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M249.3 266.49l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636b7b",
    d: "M249.8 266.49l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21315a",
    d: "M250.3 266.49l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M250.8 266.49l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M251.3 266.49l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M261.33 266.49l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M262.84 266.49l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M263.34 266.49l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "M263.84 266.49l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#100808",
    d: "M267.35 266.49l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#310000",
    d: "M267.85 266.49l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#210800",
    d: "M268.35 266.49l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M277.88 266.49l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M278.38 266.49l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10295a",
    d: "M278.88 266.49l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#525a6b",
    d: "M279.38 266.49l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M279.88 266.49l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M280.38 266.49l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M290.41 266.49l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M290.91 266.49l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103910",
    d: "M291.41 266.49l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M291.91 266.49l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M293.92 266.49l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M294.42 266.49l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M295.92 266.49l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M297.43 266.49l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M300.94 266.49l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M303.44 266.49l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M305.45 266.49v.477h2.005v-.477h-2.005z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M307.45 266.49l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M307.96 266.49l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M308.46 266.49l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M309.96 266.49l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M219.22 266.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M219.89 267.29l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M220.22 266.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M220.72 266.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M222.73 266.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M225.24 266.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "M225.74 266.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M226.74 266.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M227.24 266.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M228.24 266.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "M230.25 266.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M230.75 266.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M232.25 266.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a2908",
    d: "M232.76 266.97l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M233.26 266.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a3131",
    d: "M233.76 266.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M234.26 266.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M240.28 266.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M240.78 266.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M241.28 266.97l.5.477-.5-.477m9.525 0l.502.477-.502-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M251.3 266.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M251.81 266.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M252.31 266.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#420000",
    d: "M261.83 266.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#100808",
    d: "M266.34 266.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b0008",
    d: "M266.85 266.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M264.84 267.44v.477h1.504c-3.848 5.97-1.042 13.987-.5 20.512h.5c1.404-5.846 1.538-14.243 0-20.036l2.005.954.5-1.908-.5-.477-3.51.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#940008",
    d: "M268.35 266.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M268.85 266.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M276.87 266.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M277.37 266.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M277.88 266.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M278.38 266.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M289.91 266.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M290.41 266.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M291.91 266.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M292.41 266.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M294.42 266.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M295.92 266.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M297.43 266.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M297.93 266.97l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M300.94 266.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M302.94 266.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M305.45 266.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M306.45 266.97l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "M307.12 267.29l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M307.45 266.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M307.96 266.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M309.46 266.97l-1.504 1.908 1.504-1.908z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M219.22 267.44l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M220.22 267.44l1.003 2.862h.5l.502-1.908-2.005-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M220.72 267.44l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M221.22 267.44l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M221.73 267.44l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "M222.73 267.44l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M223.23 267.44l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M225.24 267.44l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M225.74 267.44l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M227.74 267.44l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "M228.24 267.44l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M230.75 267.44l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a1000",
    d: "M231.25 267.44l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M231.75 267.44l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M233.76 267.44l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M235.6 267.6l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M237.27 267.44l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M238.27 267.44l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M238.77 267.44l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#526b42",
    d: "M239.27 267.44l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#396b10",
    d: "M239.77 267.44l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M240.28 267.44l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213918",
    d: "M240.78 267.44l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M241.28 267.44l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M261.83 267.44l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "M263.84 267.44l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad0008",
    d: "M264.34 267.44l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "M268.85 267.44l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M289.91 267.44l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M290.41 267.44l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M291.91 267.44l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M292.41 267.44l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M294.42 267.44l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M294.92 267.44l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M295.92 267.44l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M296.42 267.44l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M297.93 267.44l.5.477-.5-.477m1.003 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M299.43 267.44l.5.477-.5-.477m1.003 0l1.002.954-1.002-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M300.94 267.44l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M302.44 267.44l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M302.94 267.44l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M304.95 267.44l1.003.954-1.003-.954zm2.5 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M309.96 267.44l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M310.46 267.44l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M310.96 267.44l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M311.46 267.44l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c9c84",
    d: "M218.72 267.92l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M219.22 267.92l1.504 2.385-1.504-2.385z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M219.72 267.92l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M221.73 267.92l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M222.23 267.92l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M222.73 267.92l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M223.23 267.92l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M224.73 267.92l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M225.57 268.08l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M226.24 267.92l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b8c73",
    d: "M228.24 267.92l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M231.25 267.92l1.003.954v-.954h-1.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a1000",
    d: "M232.25 267.92l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M233.26 267.92l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#526b42",
    d: "M237.27 267.92l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M237.77 267.92l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M238.27 267.92l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M236.77 271.74l1.003-.477v.477l-3.51 2.862c3.116-1.18 4.69-2.8 6.016-5.724l-1.505.954 1.003-1.908-3.008 3.816z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M239.77 267.92l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M240.28 267.92l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M240.78 267.92l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M256.32 267.92l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#845a52",
    d: "M256.82 267.92l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#734a42",
    d: "M257.32 267.92l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#842118",
    d: "M257.82 267.92l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M258.32 267.92l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M258.82 267.92l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M261.83 267.92l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#310000",
    d: "M262.84 267.92l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#310010",
    d: "M263.84 267.92l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#180821",
    d: "M264.34 267.92l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#310010",
    d: "M264.84 267.92l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M265.34 267.92l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M265.84 267.92l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M268.85 267.92l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M270.36 267.92l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M270.86 267.92l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M271.36 267.92l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c4a4a",
    d: "M271.86 267.92l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M272.86 267.92l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M289.91 267.92l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M291.91 267.92l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M292.41 267.92l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M294.92 267.92l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M295.92 267.92l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M297.93 267.92l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M300.6 268.24l.167.318-.167-.318m1.838-.318l.502.477-.502-.478z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M306.45 267.92l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M309.46 267.92l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M309.96 267.92l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M311.46 267.92l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M311.97 267.92l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M218.89 268.72l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M219.72 268.4l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M220.22 268.4l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#102110",
    d: "M222.23 268.4l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M222.73 268.4v.477l1.504.477-1.504-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M223.73 268.4l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M224.73 268.4l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M225.24 268.4v2.385h-.5l-.503-1.43h-.5l.5 4.77h-.5l-.502-5.248h-.502l-.5 3.816h-.502l-2.506-1.908 1.504 2.862h-.5l-2.007-2.385c1.685 5.644 4.09 4.866 8.098 8.038 1.49 1.18 2.433 3.735 3.434 5.32l-2.005-1.432 1.002 1.43-2.507-1.43 3.008 2.862.502-1.43h.5c-1.258 2.283-3.485 2.55-6.015 2.86v-.476l1.003-.954 2.507.477c-1.803-1.802-4.047-2.106-6.517-1.43l3.008 2.384v.478l-3.008 3.34 6.016-.955-.502.954h.502l3.008-1.43-6.016 2.862v.476c5.07-.624 5.68-2.31 8.522-5.725-.394 1.536-.394 2.4 1.003 3.34l-.783-5.698 6.8-7.658-2.508 1.908 2.005-2.863c-2.838.558-4.072 2.557-4.01 5.247l-3.008 2.862h-.503c1.07-3 3.978-4.71 3.008-8.11-2.616 1.855-3.37 4.128-3.51 7.155l-2.004-9.54.502 1.907h-.5v-.954h-.503l.5 6.68h-.5c-1.568-3.656-.198-10.99-3.51-13.358z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M226.24 268.4l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M228.41 268.72l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M229.75 268.4l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M232.76 268.4l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#311000",
    d: "M233.26 268.4l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213918",
    d: "M237.27 268.4l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M237.77 268.4l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M240.28 268.4l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M258.32 268.4l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M258.82 268.4l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#736b6b",
    d: "M259.33 268.4l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b2908",
    d: "M259.83 268.4l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M260.33 268.4l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M262.33 268.4l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000818",
    d: "M262.84 268.4l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M263.34 268.4l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "M261.83 285.09h.5c-.808-6.093-.472-11.147 2.508-16.696-5.91 2.883-5.56 11.946-3.008 16.696z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M264.84 268.4l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c2118",
    d: "M265.34 268.4l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce0008",
    d: "M267.35 268.4l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd0008",
    d: "M268.35 268.4l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "M268.85 268.4l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M269.35 268.4l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b5252",
    d: "M269.85 268.4l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M270.36 268.4l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M270.86 268.4l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M282.89 268.4l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M289.41 268.4l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M289.91 268.4l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M290.41 268.4l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M290.91 268.4l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M292.41 268.4l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M292.92 268.4l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M294.92 268.4l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M296.59 268.72l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M297.93 268.4l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M302.11 268.72l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M302.44 268.4l.5.477-.5-.477m2.005 0l.502.477-.502-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M307.45 268.4l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M308.46 268.4l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M308.96 268.4l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M309.46 268.4l.5.477-.5-.477m2.507 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M220.22 268.88l.5.477-.5-.477m2.005 0l.502.477-.502-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M223.4 269.19l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M224.23 268.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#526b42",
    d: "M224.73 268.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M226.24 268.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M229.75 268.88l.5.477-.5-.477m2.507 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M232.76 268.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M233.26 268.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M237.43 269.19l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M238.77 268.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M239.27 268.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M240.28 268.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M246.29 268.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M260.33 268.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M260.83 268.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#733939",
    d: "M261.33 268.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M261.83 268.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M262.33 268.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M264.34 268.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b5252",
    d: "M264.84 268.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#310000",
    d: "M267.35 268.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1010",
    d: "M268.35 268.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M268.85 268.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M282.89 268.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M289.41 268.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M289.91 268.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M290.41 268.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M290.91 268.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M292.92 268.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M294.92 268.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M295.42 268.88l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M298.1 269.19l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M299.93 268.88l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M300.44 268.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M301.44 268.88l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M304.95 268.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M306.95 268.88l-2.005 2.385 2.005-2.385z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M307.45 268.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M307.96 268.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M308.46 268.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M308.96 268.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M309.96 268.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M310.46 268.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395231",
    d: "M310.96 268.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M311.46 268.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M312.63 269.19l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M312.97 268.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M218.89 269.67l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M219.22 269.35l.5.477-.5-.477m1.003 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M220.72 269.35l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M222.06 269.51l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213918",
    d: "M224.23 269.35l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5231",
    d: "M224.73 269.35l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M226.24 269.35l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M226.74 269.35l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M228.24 269.35l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M228.74 269.35l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M230.25 269.35l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "M232.76 269.35l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M235.26 269.35l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M238.77 269.35l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M239.77 269.35l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M240.28 269.35l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M246.29 269.35l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#733939",
    d: "M246.79 269.35l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M247.29 269.35l.5.477-.5-.477m14.54 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M262.33 269.35l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M263.84 269.35l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M264.34 269.35l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#842118",
    d: "M264.84 269.35l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.35 269.35l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad0008",
    d: "M267.85 269.35l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M268.35 269.35l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#debdb5",
    d: "M281.89 269.35l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c4a4a",
    d: "M282.39 269.35l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1810",
    d: "M282.89 269.35l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#946b63",
    d: "M283.56 269.67l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "M289.41 269.35l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M289.91 269.35l.5.477-.5-.477m1.003 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M291.41 269.35l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M292.92 269.35l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M293.42 269.35l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M295.42 269.35l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M296.42 269.35l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M296.93 269.35l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M300.1 269.67l.167.318-.167-.318m1.337-.318l.5.477-.5-.478z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.45 269.35l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M304.95 269.35l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M306.95 269.35l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M307.45 269.35l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M307.96 269.35l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M309.46 269.35l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M309.96 269.35l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M311.46 269.35l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "M311.97 269.35l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M312.97 269.35l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M313.47 269.35l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M216.71 269.83l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M217.55 269.99l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M218.22 269.83l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M219.22 269.83l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M220.72 269.83l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M221.73 269.83l-.5 1.43.5-1.43m1.504 0v1.43h.5l-.5-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "M224.73 269.83l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M226.74 269.83l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M228.74 269.83l.5.477-.5-.477m2.005 0l.502.477-.502-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M232.76 269.83l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M235.26 269.83l.5.477-.5-.477m1.838.16l.334.158-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M238.27 269.83l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M239.77 269.83l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M246.79 269.83v7.633h-.5l-.503-6.68h-4.512v13.835l2.006-.954 1.003 3.34 2.507-1.432.5 5.247 4.513-1.432c2.11 1.433 3.456 1.443 4.512-.954h1.003l3.008 2.862-.5-9.063-9.025-.477v-.477l8.523.476v-1.43c-6.316-.142-7.018-3.95-7.018-9.065l-5.515-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M247.29 269.83l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b5252",
    d: "M247.8 269.83l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M248.3 269.83l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M261.83 269.83l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M262.33 269.83l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "M263.84 269.83l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c6b5b5",
    d: "M264.34 269.83l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1810",
    d: "M264.84 269.83l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b0808",
    d: "M266.85 269.83l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#100808",
    d: "M267.35 269.83l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a3131",
    d: "M267.85 269.83l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M280.88 269.83l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a56363",
    d: "M281.38 269.83l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M281.89 269.83l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M277.37 271.26c0 4.812-.467 8.764-6.517 9.063 1.338 3.622 7.82 1.32 9.972-.584 2.988-2.642 2.56-6.378 2.56-9.91l-6.015 1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M288.9 269.83l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M289.41 269.83l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M291.41 269.83l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M293.42 269.83l.5.477-.5-.477m2.005 0l.502.477-.502-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M296.93 269.83l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M300.94 269.83l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M301.44 269.83l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M300.44 274.12l4.512-4.293c-2.48.6-3.495 2.178-4.512 4.293z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M303.94 269.83l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M306.45 269.83l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "M306.95 269.83l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M307.45 269.83l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M308.96 269.83l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M309.46 269.83l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M311.97 269.83l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M312.47 269.83l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M312.97 269.83l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "M313.47 269.83l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M313.97 269.83l.5.477-.5-.477m-97.26.477l.502.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293129",
    d: "M217.21 270.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M218.05 270.47l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M218.89 270.62l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M219.22 270.31l.5.477-.5-.477m1.003 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M220.72 270.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M224.73 270.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M226.74 270.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M228.74 270.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M230.75 270.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M232.76 270.31v1.43h.5l-.5-1.43m2.172.318l.168.318-.168-.318m1.84-.318l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M238.1 270.47l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M239.27 270.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M239.77 270.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M240.78 270.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a3131",
    d: "M245.79 270.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M248.3 270.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#842118",
    d: "M248.8 270.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c6363",
    d: "M249.3 270.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M249.8 270.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M261.33 270.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M261.83 270.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M263.34 270.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M263.84 270.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c6363",
    d: "M264.34 270.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M266.85 270.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a2129",
    d: "M267.35 270.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M267.85 270.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d6a5a5",
    d: "M279.38 270.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#946b63",
    d: "M279.88 270.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a52921",
    d: "M280.38 270.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M280.88 270.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a2129",
    d: "M283.39 270.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "M283.89 270.31v.477h4.512l-4.512-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212139",
    d: "M288.4 270.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M290.41 270.31l1.504.954v-.477l-1.504-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M291.41 270.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M291.91 270.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M293.42 270.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M293.92 270.31l-.5.954.5-.954m1.504 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M295.92 270.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M296.93 270.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M297.93 270.31l.5.477-.5-.477m1.003 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M299.93 270.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M300.94 270.31l.5.477-.5-.477m2.507 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M305.95 270.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M306.45 270.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M308.46 270.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M308.96 270.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M312.97 270.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M313.47 270.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M313.97 270.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M217.21 270.78l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M217.72 270.78l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M218.22 270.78l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "M220.72 270.78l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M221.73 270.78l.5.477-.5-.477m3.676.318l.168.318-.168-.318m1.337-.318l.502.477-.502-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M227.24 270.78l.5.477-.5-.477m1.504 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M229.25 270.78l.5.477-.5-.477m2.005 0l.502.477-.502-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M236.26 270.78l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M236.77 270.78l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M237.77 270.78l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M239.27 270.78l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1810",
    d: "M249.8 270.78l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a51008",
    d: "M250.3 270.78l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M250.8 270.78l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#943131",
    d: "M251.64 270.94l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c6b5b5",
    d: "M252.31 270.78l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M261.33 270.78l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M263.34 270.78l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M263.84 270.78l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#943131",
    d: "M264.34 270.78l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1810",
    d: "M266.34 270.78l1.003 4.293-1.003-4.293z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b0808",
    d: "M266.85 270.78l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#733939",
    d: "M267.35 270.78l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c69c94",
    d: "M276.87 270.78l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad3931",
    d: "M277.71 270.94l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M278.38 270.78l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M278.88 270.78l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1810",
    d: "M279.38 270.78l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M283.39 270.78v3.816h.5l-.5-3.816z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "M283.89 270.78c0 8.845-5.168 12.114-14.037 11.45l-.5 9.062c1.894-.03 4.557.11 5.012-1.908l2.005 1.43 2.006-1.907-.502 1.91 1.003-.956h.5l3.01-.476-.502 1.432 1.504-1.91 1.002.955h1.504v-1.43l1.002.477.502-4.293c2.544-2.115 1.002-10.676 1.002-13.834h-4.512z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M290.41 270.78l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M291.91 270.78l.5.477-.5-.477m2.005 0l.502.477-.502-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M295.92 270.78v1.43h.5l-.5-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M296.93 270.78l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M298.43 270.78v2.385h.5l-.5-2.385z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M300.44 270.78l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M300.94 270.78l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "M302.94 270.78l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.45 270.78l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M305.95 270.78l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M307.96 270.78l-1.003 1.43 1.003-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M308.46 270.78l.5.477-.5-.477m-90.74.477l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M218.72 271.26l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M219.22 271.26l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M221.22 271.26l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M221.73 271.26l.5.477-.5-.477m1.504 0v.954h1.003v-.954h-1.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M227.24 271.26l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M229.25 271.26l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M237.27 271.26l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#396b10",
    d: "M238.77 271.26l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M239.27 271.26l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.475,
    fill: "#8c7373",
    d: "M252.31 271.26v4.293h.5l-.5-4.293z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M260.83 271.26l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "M261.33 271.26l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636b7b",
    d: "M263.34 271.26l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M264.34 271.26l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#420000",
    d: "M266.85 271.26l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M290.41 271.26l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M290.91 271.26l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M291.91 271.26l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M293.92 271.26l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M296.93 271.26l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M299.93 271.26l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M300.44 271.26l.5.477-.5-.477m2.005 0l.502.477-.502-.477m2.006 0l-2.506 2.862 2.507-2.862z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "M304.95 271.26l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M305.45 271.26l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M307.96 271.26l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M217.72 271.74l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M218.22 271.74l.5.477-.5-.477m1.504 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M221.89 272.06l.167.318-.167-.318m3.51 0l.166.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#526b42",
    d: "M227.24 271.74l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M229.25 271.74l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M229.75 271.74l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M232.76 271.74l.5.477-.5-.477m3.008.477v.477h1.504l-1.504-.477m1.504-.477l.5.477-.5-.477m1.003 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M238.77 271.74l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M256.65 271.9l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M257.32 271.74l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M257.82 271.74l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M258.32 271.74l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M260.83 271.74l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M261.33 271.74l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M262.84 271.74l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M263.34 271.74l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a51008",
    d: "M264.34 271.74l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#310000",
    d: "M266.85 271.74l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#940008",
    d: "M267.35 271.74l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M267.85 271.74l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M270.86 271.74l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M271.36 271.74l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M272.19 271.9l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M272.86 271.74l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M290.41 271.74l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M290.91 271.74l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M291.41 271.74l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M291.91 271.74l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M292.41 271.74l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M294.25 271.9l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M296.42 271.74l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M296.93 271.74l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M297.43 271.74l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M299.93 271.74l.5.477-.5-.477m2.005 0l.502.477-.502-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M307.96 271.74l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#396b10",
    d: "M218.22 272.21l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M219.72 272.21l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M223.9 272.53l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#396b10",
    d: "M227.24 272.21l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M228.74 272.21l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M229.75 272.21l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M230.25 272.21l1.504 1.43-1.504-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M232.42 272.53l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M236.26 272.21l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M238.27 272.21l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "M256.82 272.21c.03 2.393.295 3.615 3.008 3.816.42-2.58-.402-3.27-3.008-3.816z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M257.82 272.21l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M258.32 272.21l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "M258.82 272.21l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636b7b",
    d: "M259.33 272.21l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M259.83 272.21l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M260.33 272.21l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#31425a",
    d: "M260.83 272.21l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21315a",
    d: "M262.84 272.21l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M263.84 272.21l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1810",
    d: "M264.34 272.21l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#420000",
    d: "M266.85 272.21l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce0008",
    d: "M267.35 272.21l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M267.85 272.21l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M269.35 272.21l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M269.85 272.21l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21315a",
    d: "M270.36 272.21l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M270.86 272.21l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M271.36 272.21l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003994",
    d: "M268.35 273.17c1.174 4.14 4.465 2.81 4.512-.954l-4.512.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M290.41 272.21l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M290.91 272.21l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M291.41 272.21l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M291.91 272.21l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M292.41 272.21l.5.477-.5-.477m2.005 0l.502.477-.502-.477zm7.025 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M303.94 272.21l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M306.95 272.21l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M307.45 272.21l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M218.22 272.69l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M219.72 272.69l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M220.22 272.69l.5.477-.5-.477m2.005 0l.502.477-.502-.477m3.008 0l.502.477-.502-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M228.74 272.69l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M230.25 272.69l1.504 1.43-1.504-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M235.26 272.69l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M237.77 272.69l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M238.27 272.69l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M259.83 272.69l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M260.33 272.69l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M260.83 272.69l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M262.84 272.69l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b5adad",
    d: "M263.84 272.69l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b0808",
    d: "M266.85 272.69l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M267.35 272.69l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#524242",
    d: "M267.85 272.69l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#525a6b",
    d: "M268.35 272.69l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M268.85 272.69l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M269.35 272.69l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395231",
    d: "M290.91 272.69l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M291.41 272.69l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M291.91 272.69l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M292.41 272.69l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M294.42 272.69l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M294.92 272.69l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M296.59 273.01l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M296.93 272.69l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M300.94 272.69l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M303.44 272.69l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M306.45 272.69l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M218.22 273.17l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M220.22 273.17l.5.477-.5-.477m2.172.318l.168.318-.168-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M223.73 273.17l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M229.25 273.17l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M231.75 273.17l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M232.25 273.17l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M234.76 273.17l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M260.33 273.17l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M260.83 273.17l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M262.33 273.17l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M262.84 273.17l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad0008",
    d: "M267.35 273.17l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#390821",
    d: "M267.85 273.17l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M290.91 273.17l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M291.41 273.17l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103910",
    d: "M291.91 273.17l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M292.41 273.17l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M292.92 273.17l.5.477-.5-.477m1.504 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M297.43 273.17l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M298.43 273.17l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M300.44 273.17l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M302.94 273.17l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M305.95 273.17l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M306.45 273.17l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M218.22 273.65l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M218.72 273.65l.5.477-.5-.477m2.005 0l.502.477-.502-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M223.73 273.65l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M228.24 273.65l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M229.25 273.65l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M229.75 273.65l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "M231.75 273.65l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M233.76 273.65l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M234.26 273.65l.5.477-.5-.477m1.504 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M236.26 273.65l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M236.77 273.65l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M237.27 273.65l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M260.33 273.65l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M262.33 273.65l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b0008",
    d: "M266.85 273.65l.5.477-.5-.477m1.003 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M289.74 273.8l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M290.91 273.65l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M291.75 273.8l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M292.41 273.65l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M292.92 273.65l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M295.09 273.96l.167.318-.167-.318m1.504 0l.167.318-.166-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M297.43 273.65l.5.477-.5-.477m1.003 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M299.93 273.65l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M302.44 273.65l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M305.45 273.65l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M305.95 273.65l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M307.96 273.65l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M308.46 273.65l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M308.96 273.65l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395231",
    d: "M309.46 273.65l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M309.96 273.65l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5231",
    d: "M218.72 274.12l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M220.72 274.12l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M222.23 274.12l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M222.73 274.12l.5.477-.5-.477m2.507 0l-.502.954h1.003l-.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#396b10",
    d: "M227.24 274.12l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#526b42",
    d: "M228.41 274.44l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M231.25 274.12l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M231.75 274.12l.5.477-.5-.477m1.67.318l.168.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M233.76 274.12l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M234.76 274.12l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M235.26 274.12l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M235.76 274.12l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M260.33 274.12l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#31425a",
    d: "M262.33 274.12l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b0808",
    d: "M267.51 274.44l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd0008",
    d: "M267.85 274.12l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M268.35 274.12l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M289.41 274.12l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M289.91 274.12l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M290.91 274.12l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M291.41 274.12l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M292.41 274.12l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M292.92 274.12l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M298.43 274.12v1.908h.5l-.5-1.908z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M299.77 274.28l.334.16-.334-.16m1.67-.16l-1.002 1.432 1.003-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M301.94 274.12l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M304.95 274.12l-1.003 2.385h.502l.5-2.385z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M305.45 274.12l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M306.95 274.12l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M307.45 274.12l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M307.96 274.12l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M308.46 274.12l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M309.96 274.12l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M310.46 274.12l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M218.72 274.6l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M221.06 274.76l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#526b42",
    d: "M227.24 274.6l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M229.08 274.76l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M230.25 274.6l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M231.25 274.6l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M232.76 274.6v1.43l1.504-1.43h-1.504z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M234.26 274.6l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M234.76 274.6l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#525a6b",
    d: "M256.32 274.6l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M260.16 274.76l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M262.33 274.6l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M268.02 274.92l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#390821",
    d: "M268.35 274.6l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M283.39 274.6l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "M289.91 274.6l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M291.41 274.6l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M292.41 274.6l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "M292.92 274.6l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M293.42 274.6l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M295.25 274.76l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M296.42 274.6l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M299.43 274.6l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M304.95 274.6l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M305.45 274.6l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M305.95 274.6l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M306.45 274.6l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M306.95 274.6l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M310.46 274.6l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M218.72 275.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M219.22 275.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M221.22 275.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M222.73 275.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M224.73 275.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M227.24 275.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M228.24 275.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M229.41 275.39l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M231.25 275.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M232.76 275.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M233.76 275.08l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "M234.76 275.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M235.26 275.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#733939",
    d: "M240.78 275.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M245.79 275.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M256.32 275.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M261.83 275.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M262.33 275.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M266.85 275.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "M267.35 275.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b0008",
    d: "M268.35 275.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636b7b",
    d: "M272.86 275.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M283.56 275.39l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "M289.91 275.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M290.41 275.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M291.41 275.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M293.25 275.24l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M295.42 275.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M296.93 275.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293129",
    d: "M304.45 275.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M304.95 275.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M305.45 275.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M305.95 275.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M310.46 275.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M310.96 275.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M219.22 275.55l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M221.22 275.55l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M222.73 275.55l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M223.23 275.55l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M224.73 275.55l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M227.41 275.87l.167.318-.167-.318m.836-.318l.5.477-.5-.478z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M230.75 275.55l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M231.25 275.55l-.5 2.385h.5v-2.385z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M232.42 275.87l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M234.26 275.55l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M234.93 275.87l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M235.26 275.55l.5.477-.5-.477m4.01 0l.502.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M239.77 275.55l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M240.28 275.55l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#310000",
    d: "M240.78 275.55l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a51008",
    d: "M246.29 275.55l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#845a52",
    d: "M252.31 275.55l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M256.32 275.55l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "M256.82 275.55l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M261.83 275.55l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M262.33 275.55l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a51008",
    d: "M266.85 275.55l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#940008",
    d: "M267.35 275.55l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd0008",
    d: "M268.18 275.71l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M268.85 275.55l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "M272.36 275.55l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M272.86 275.55l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M289.91 275.55l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M290.41 275.55l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M291.41 275.55l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M291.91 275.55l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M293.42 275.55l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M295.42 275.55l.5.477-.5-.477zm5.02 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M303.94 275.55l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M304.45 275.55l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M304.95 275.55l.5.477-.5-.477m4.345.16l.334.158-.335-.16m1.17-.158l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M310.96 275.55l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M219.22 276.03l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M219.72 276.03l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M221.73 276.03l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M223.23 276.03l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M223.73 276.03l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M224.73 276.03l-.5 1.43.5-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M228.24 276.03l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M228.74 276.03l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M229.75 276.03l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#738c63",
    d: "M232.76 276.03l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M233.76 276.03l-2.005 2.385 2.005-2.385z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M234.26 276.03l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M235.43 276.35l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M237.27 276.03l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M237.77 276.03l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M238.27 276.03l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M238.77 276.03v1.43h.5l-.5-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M239.61 276.19l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M240.28 276.03l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#733939",
    d: "M240.78 276.03l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M246.29 276.03l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#943131",
    d: "M252.31 276.03l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M256.82 276.03l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636b7b",
    d: "M257.32 276.03l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10295a",
    d: "M257.82 276.03l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M258.66 276.19l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M259.33 276.03l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M261.83 276.03l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M262.33 276.03l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M266.85 276.03l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd0008",
    d: "M267.35 276.03l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M268.35 276.03l2.005 5.247-2.005-5.247z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#391810",
    d: "M268.85 276.03l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636b7b",
    d: "M269.35 276.03l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21315a",
    d: "M269.85 276.03l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#525a6b",
    d: "M271.86 276.03l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c4a42",
    d: "M276.87 276.03l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1810",
    d: "M282.89 276.03l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M290.07 276.35l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395231",
    d: "M290.41 276.03l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M291.41 276.03l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M291.91 276.03l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M293.42 276.03l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M295.42 276.03l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M299.93 276.03l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M303.11 276.35l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M303.44 276.03l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M307.96 276.03l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M308.46 276.03l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M308.96 276.03l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M309.46 276.03l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M309.96 276.03l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M310.96 276.03l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M219.72 276.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M220.22 276.51l1.003.954-1.003-.954m1.504 0l1.504.954v-.477l-1.504-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M222.23 276.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M224.23 276.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M227.24 276.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M228.24 276.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M228.74 276.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M229.75 276.51v1.43h.5l-.5-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M231.75 276.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#396b10",
    d: "M232.25 276.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M232.76 276.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M233.76 276.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M234.76 276.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M236.26 276.51l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M236.77 276.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#396b10",
    d: "M237.27 276.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M239.77 276.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M240.28 276.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M246.29 276.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a51008",
    d: "M252.31 276.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M259.33 276.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M259.83 276.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M261.83 276.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M263.84 276.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a51008",
    d: "M266.85 276.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b0808",
    d: "M268.02 276.83l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b0008",
    d: "M268.85 276.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M269.35 276.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad3931",
    d: "M276.87 276.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#842118",
    d: "M282.89 276.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M290.41 276.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M291.91 276.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M293.75 276.67l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M296.93 276.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M301.94 276.51l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M302.44 276.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M306.95 276.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M307.45 276.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M307.96 276.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M309.96 276.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M310.96 276.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M311.46 276.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M314.97 276.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M315.64 276.83l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M220.22 276.98l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "M224.73 276.98l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M226.74 276.98l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M227.24 276.98l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M228.74 276.98l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M231.75 276.98l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdc6ad",
    d: "M232.25 276.98l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M233.26 276.98l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M234.26 276.98l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#526b42",
    d: "M235.43 277.3l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M236.26 276.98l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M239.27 276.98l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M239.77 276.98l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M246.29 276.98l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1810",
    d: "M252.31 276.98l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a59494",
    d: "M252.81 276.98l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M259.33 276.98l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M259.83 276.98l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10295a",
    d: "M261.83 276.98l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c6b5b5",
    d: "M263.84 276.98l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1810",
    d: "M264.51 277.3l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd0008",
    d: "M268.85 276.98l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M269.35 276.98l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#debdb5",
    d: "M276.37 276.98l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1810",
    d: "M276.87 276.98l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M282.89 276.98l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a7b42",
    d: "M289.91 276.98l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M290.41 276.98l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M290.91 276.98l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M291.91 276.98l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M293.42 276.98l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M293.92 276.98v1.43h.5l-.5-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M296.09 277.3l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M296.93 276.98l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M298.93 276.98l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M301.44 276.98l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M301.94 276.98l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M305.95 276.98l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395231",
    d: "M306.45 276.98l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M306.95 276.98l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M310.46 276.98l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M310.96 276.98l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M311.46 276.98l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M313.47 276.98l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M313.97 276.98l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M314.47 276.98l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "M314.97 276.98l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M220.72 277.46l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M221.22 277.46l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M224.73 277.46l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M225.4 277.78l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M227.24 277.46l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5231",
    d: "M228.74 277.46l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M231.25 277.46l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M231.75 277.46l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M232.76 277.46l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M234.26 277.46l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M235.76 277.46l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M238.27 277.46l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M238.77 277.46l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M239.77 277.46l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a51008",
    d: "M246.79 277.46l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#842118",
    d: "M252.81 277.46l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M259.33 277.46l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "M261.83 277.46v3.816h.5l-.5-3.816z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M263.84 277.46l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a51008",
    d: "M266.85 277.46l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad0008",
    d: "M268.35 277.46l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#733939",
    d: "M269.35 277.46l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c4239",
    d: "M276.37 277.46l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1810",
    d: "M282.39 277.46l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M288.9 277.46l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a6342",
    d: "M290.07 277.78l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M290.91 277.46l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a6342",
    d: "M291.91 277.46l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M298.43 277.46l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M298.93 277.46l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M300.94 277.46l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M301.44 277.46l.5.477-.5-.477m3.51 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "M305.45 277.46l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M305.95 277.46l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M310.96 277.46l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M311.46 277.46l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M311.97 277.46l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M312.47 277.46l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M312.97 277.46l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M313.64 277.78l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M313.97 277.46l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "M314.47 277.46l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M314.97 277.46l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M221.22 277.94l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M221.73 277.94l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5231",
    d: "M222.23 277.94l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M222.73 277.94l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M227.24 277.94l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#526b42",
    d: "M228.74 277.94l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213918",
    d: "M231.25 277.94l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M232.25 277.94l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M233.76 277.94l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M234.26 277.94l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "M235.26 277.94l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M235.76 277.94l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M237.77 277.94l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M238.27 277.94l.5.477-.5-.477m1.003 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M239.77 277.94l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M246.79 277.94l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1810",
    d: "M252.81 277.94l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M253.31 277.94l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M259.33 277.94l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M263.84 277.94l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M264.34 277.94l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad0008",
    d: "M267.35 277.94l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd0008",
    d: "M267.85 277.94l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b0008",
    d: "M268.35 277.94l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#940008",
    d: "M269.35 277.94l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M269.85 277.94l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a5847b",
    d: "M275.87 277.94l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1810",
    d: "M276.37 277.94l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392121",
    d: "M282.39 277.94l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103910",
    d: "M288.9 277.94l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M290.91 277.94l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M291.41 277.94l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M291.91 277.94l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M296.09 278.26l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M297.93 277.94l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M298.43 277.94l.5.477-.5-.477m2.005 0l.502.477-.502-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M303.94 277.94l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M304.45 277.94l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M304.95 277.94l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M309.29 278.1l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M309.96 277.94l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M310.46 277.94l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a6342",
    d: "M310.96 277.94l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M311.46 277.94l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M311.97 277.94l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M312.47 277.94l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M312.97 277.94l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M313.97 277.94l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M314.47 277.94l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M222.73 278.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M223.23 278.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5231",
    d: "M223.73 278.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M224.23 278.42l.5.477-.5-.477m1.504 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M227.24 278.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "M230.75 278.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M231.25 278.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M231.75 278.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M233.76 278.42l.5.477-.5-.477m1.504 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M237.27 278.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M237.77 278.42l.5.477-.5-.477m1.504 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M247.29 278.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M253.31 278.42l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a59494",
    d: "M253.81 278.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a51008",
    d: "M264.34 278.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M267.85 278.42v6.678h1.504l-1.504-6.678z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b0808",
    d: "M268.52 278.73l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce0008",
    d: "M269.35 278.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M269.85 278.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1810",
    d: "M275.87 278.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M281.89 278.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M288.9 278.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M289.41 278.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103910",
    d: "M289.91 278.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M290.91 278.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M291.41 278.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c9c84",
    d: "M292.08 278.73l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M293.92 278.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M294.42 278.42l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M297.93 278.42l.5.477-.5-.477m1.504 0l-1.504 1.908 1.504-1.908z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M299.93 278.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M302.94 278.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M303.44 278.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M303.94 278.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M304.45 278.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M304.95 278.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M305.78 278.57l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M306.45 278.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a6342",
    d: "M306.95 278.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#426331",
    d: "M307.45 278.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M307.96 278.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M308.46 278.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M309.29 278.57l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M312.47 278.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M312.97 278.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M313.47 278.42l.5.477-.5-.477m-89.237.477l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M224.73 278.89l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M225.24 278.89l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#422100",
    d: "M225.74 278.89l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M226.24 278.89l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M227.24 278.89l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M227.74 278.89l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293129",
    d: "M230.75 278.89l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M231.25 278.89l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M231.75 278.89l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M233.26 278.89l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M235.26 278.89l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M237.27 278.89l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M239.27 278.89l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M247.29 278.89l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M247.8 278.89l1.003 1.43-1.003-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c7373",
    d: "M254.31 278.89l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M254.81 278.89l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M264.34 278.89l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a51008",
    d: "M267.51 279.21l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b2131",
    d: "M269.85 278.89l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#946b63",
    d: "M274.87 278.89l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1810",
    d: "M275.37 278.89l.5.477-.5-.477m6.016 0l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M281.89 278.89l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M288.9 278.89l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M289.41 278.89l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M289.91 278.89l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M291.41 278.89l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M294.59 279.21l.167.318-.167-.318m1.337-.318l.5.477-.5-.478z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M301.94 278.89l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M302.44 278.89l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "M302.94 278.89l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395231",
    d: "M303.44 278.89l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M303.94 278.89l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M304.45 278.89l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M304.95 278.89l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M310.96 278.89l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M311.46 278.89l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M311.97 278.89l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M312.47 278.89l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M224.73 279.37l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M225.24 279.37l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M226.24 279.37l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M227.74 279.37l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M230.25 279.37l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M230.75 279.37l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M231.25 279.37l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M233.09 279.53l.334.16-.334-.16m2.005 0l.334.16-.335-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M236.77 279.37l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M238.77 279.37l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M239.27 279.37l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M254.81 279.37l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c7373",
    d: "M255.32 279.37l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M255.82 279.37l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#943131",
    d: "M264.51 279.69l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#940008",
    d: "M268.35 279.37l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad0008",
    d: "M268.85 279.37l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#940008",
    d: "M269.85 279.37l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M270.36 279.37l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a5847b",
    d: "M273.86 279.37l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c2118",
    d: "M274.37 279.37l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M281.38 279.37l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M289.07 279.69l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M289.41 279.37v.477h1.504v-.477h-1.504z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M289.91 279.37l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M291.41 279.37l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395231",
    d: "M291.91 279.37l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M295.92 279.37l.5.477-.5-.477m5.515 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "M301.94 279.37l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M302.44 279.37l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M309.96 279.37l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M310.46 279.37l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M310.96 279.37l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M311.46 279.37l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M224.73 279.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#422100",
    d: "M226.74 279.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M227.74 279.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M228.24 279.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M230.25 279.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M231.25 279.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M232.76 279.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M234.76 279.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M236.26 279.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M236.77 279.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#396b10",
    d: "M238.77 279.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M239.27 279.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a51008",
    d: "M248.8 279.85l.5.477-.5-.477m7.02 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c2929",
    d: "M256.32 279.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#845a52",
    d: "M256.82 279.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a59494",
    d: "M257.32 279.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c6b5b5",
    d: "M257.82 279.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c7373",
    d: "M258.66 280.01l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212139",
    d: "M259.33 279.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M267.35 279.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce0008",
    d: "M268.35 279.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b0808",
    d: "M268.85 279.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce0008",
    d: "M269.85 279.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#734a42",
    d: "M270.36 279.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#946b63",
    d: "M270.86 279.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd8c8c",
    d: "M271.36 279.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a5847b",
    d: "M271.86 279.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c5a52",
    d: "M272.36 279.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad3931",
    d: "M272.86 279.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M273.36 279.85l.5.477-.5-.477m7.02 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M280.88 279.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M289.41 279.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M290.58 280.16l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M291.41 279.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "M291.91 279.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M294.42 279.85v1.43h.5l-.5-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M300.94 279.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M308.46 279.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M308.96 279.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M309.46 279.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M309.96 279.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M310.46 279.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M224.73 280.32l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M225.24 280.32l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M226.24 280.32l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213918",
    d: "M226.74 280.32l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M228.24 280.32l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M230.25 280.32l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M230.75 280.32l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M231.25 280.32l.5.477-.5-.477m1.504 0l.5.477-.5-.477m1.504 0l-1.003 1.908h.502l.5-1.908z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M234.76 280.32l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M236.1 280.48l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M238.27 280.32l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M238.77 280.32l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M248.8 280.32l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M249.3 280.32l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M259.33 280.32l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c6363",
    d: "M264.34 280.32l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a51008",
    d: "M267.51 280.64l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "M268.85 280.32l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M270.36 280.32l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M279.88 280.32l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M280.38 280.32l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M289.41 280.32l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M291.91 280.32l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M297.93 280.32l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M299.93 280.32l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M300.44 280.32l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M307.45 280.32l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M307.96 280.32l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M308.46 280.32l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M308.96 280.32l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M225.24 280.8l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M225.74 280.8l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M226.24 280.8l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M226.74 280.8l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M227.24 280.8l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M228.24 280.8l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "M228.74 280.8l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M230.25 280.8l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M230.75 280.8l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M231.25 280.8l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M234.26 280.8l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M235.26 280.8l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M235.76 280.8l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M238.27 280.8l-1.003 1.43 1.003-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M249.8 280.8l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M250.3 280.8l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a51008",
    d: "M259.33 280.8l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c7373",
    d: "M264.34 280.8l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b0808",
    d: "M268.85 280.8l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M270.36 280.8l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M278.88 280.8l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#291029",
    d: "M279.38 280.8l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#29396b",
    d: "M288.4 280.8l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M289.41 280.8l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M290.41 280.8l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M290.91 280.8l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M291.91 280.8l.5.477-.5-.477m7.52 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M299.93 280.8l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M303.94 280.8l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M304.45 280.8l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M304.95 280.8v.477h2.005l-2.005-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M306.95 280.8l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M307.45 280.8l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M307.96 280.8v.477h1.504l-1.504-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a6342",
    d: "M309.46 280.8v.477h1.504l-1.504-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b8c73",
    d: "M310.96 280.8l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M311.46 280.8l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M311.97 280.8l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M225.24 281.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M227.24 281.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M228.74 281.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M229.75 281.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M230.25 281.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#733939",
    d: "M230.75 281.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M234.26 281.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M234.76 281.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M238.27 281.28l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M250.8 281.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M251.3 281.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M251.81 281.28l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1810",
    d: "M259.33 281.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M259.83 281.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425a84",
    d: "M261.83 281.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b5adad",
    d: "M264.34 281.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M267.35 281.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#940008",
    d: "M269.19 281.44l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad0008",
    d: "M269.85 281.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M270.36 281.28l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1810",
    d: "M277.37 281.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M277.88 281.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M278.38 281.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "M288.4 281.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#396321",
    d: "M289.41 281.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M290.91 281.28v1.43h.5l-.5-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M291.91 281.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M292.41 281.28l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M294.42 281.28v2.385h1.003l-1.003-2.385z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M294.92 281.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M298.93 281.28l-1.003 1.43 1.003-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M299.43 281.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M303.11 281.6l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M303.44 281.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M303.94 281.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M310.96 281.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M311.46 281.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M311.97 281.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M225.24 281.75l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M225.74 281.75l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M226.24 281.75l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M227.24 281.75l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M227.74 281.75l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M229.41 282.07l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M229.75 281.75l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M230.42 282.07l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M230.92 282.07l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M232.76 281.75l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M236.77 281.75l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#946b63",
    d: "M240.78 281.75l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M251.81 281.75l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M252.81 281.75l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M253.31 281.75l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a51008",
    d: "M253.81 281.75l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1810",
    d: "M254.31 281.75v.477h4.01l-4.01-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M258.32 281.75l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a51008",
    d: "M258.82 281.75l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M259.33 281.75l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M259.83 281.75l.5.477-.5-.477m2.172.318l.168.318-.168-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M264.34 281.75l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1810",
    d: "M265.01 282.07l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000818",
    d: "M269.35 281.75l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M269.85 281.75l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#080829",
    d: "M270.36 281.75l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1810",
    d: "M271.36 281.75l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M275.37 281.75l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M275.87 281.75l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1021",
    d: "M276.37 281.75l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M276.87 281.75l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "M288.4 281.75l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a7b42",
    d: "M289.41 281.75l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M292.41 281.75l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M298.93 281.75l.5.477-.5-.477m2.507 0l1.002.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M301.94 281.75l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M302.44 281.75l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M308.46 281.75l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M308.96 281.75l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M309.46 281.75l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395231",
    d: "M309.96 281.75l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M310.46 281.75l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M310.96 281.75l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M311.46 281.75l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M225.24 282.23l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M225.74 282.23l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M226.24 282.23l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M226.74 282.23l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M227.24 282.23l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5231",
    d: "M227.74 282.23l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M229.75 282.23l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M232.59 282.39l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#396b10",
    d: "M236.26 282.23l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M254.31 282.23l.5.477-.5-.477zm3.51 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#391810",
    d: "M259.83 282.23l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M264.34 282.23l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#291029",
    d: "M269.35 282.23l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M271.86 282.23v.477h3.51l-3.51-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "M288.4 282.23l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M288.9 282.23l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a6342",
    d: "M289.57 282.55l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M292.58 282.55l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M298.43 282.23l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M300.94 282.23l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M301.44 282.23l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M305.95 282.23l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M306.45 282.23l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M306.95 282.23l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a6342",
    d: "M307.45 282.23l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M307.96 282.23l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M308.46 282.23l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M308.96 282.23l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M225.24 282.71l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M225.74 282.71l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "M226.24 282.71l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M226.74 282.71l1.003.954v-.954h-1.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "M227.74 282.71l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M228.24 282.71l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M229.75 282.71l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M230.25 282.71l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a2908",
    d: "M230.75 282.71l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M232.25 282.71l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M235.26 282.71l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M235.76 282.71l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M236.26 282.71l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M259.83 282.71l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M260.33 282.71l.5.477-.5-.477m1.504 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M262.33 282.71l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a51008",
    d: "M264.84 282.71l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#390821",
    d: "M269.35 282.71l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M288.4 282.71l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M288.9 282.71l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M290.91 282.71l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M291.41 282.71l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M296.93 284.14l1.504-1.43-1.504 1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M299.93 282.71l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M300.44 282.71l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M300.94 282.71l.5.477-.5-.477m4.01 0l.502.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M305.45 282.71l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M305.95 282.71l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M306.45 282.71l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M219.72 283.19l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M220.22 283.19l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M225.74 283.19l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M226.74 283.19l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M228.24 283.19l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M228.74 283.19l.5 1.43h.503l-1.003-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M230.25 283.19l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M230.75 283.19l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M232.09 283.34l.334.16-.334-.16m1.67-.16l.502.478-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M234.26 283.19l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M234.76 283.19l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M235.26 283.19l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#391810",
    d: "M260.33 283.19l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M261.83 283.19l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M262.33 283.19l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M264.84 283.19l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M267.35 283.19l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b0808",
    d: "M269.35 283.19l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395231",
    d: "M289.41 283.19l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M291.41 283.19l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M292.41 283.19l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M292.92 283.19l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M299.43 283.19l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M299.93 283.19l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M303.94 283.19l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M304.45 283.19l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M304.95 283.19l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M219.72 283.66l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293129",
    d: "M220.22 283.66l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M220.72 283.66l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M221.22 283.66l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M221.73 283.66l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M225.74 283.66l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M227.24 283.66l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M227.74 283.66l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M228.74 283.66l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M231.75 283.66l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M233.26 283.66l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M233.76 283.66l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M234.76 283.66l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M235.26 283.66l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M239.27 283.66l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M239.77 283.66l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M242.78 283.66l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "M260.83 283.66l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M262.33 283.66l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#943131",
    d: "M265.01 283.98l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a51008",
    d: "M267.35 283.66l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M288.9 283.66l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "M289.41 283.66l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M291.58 283.98l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M292.92 283.66l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M294.75 283.82l.334.16-.334-.16m1.67-.16l.502.478-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M298.93 283.66l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M299.43 283.66l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M302.94 283.66l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "M303.44 283.66l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M303.94 283.66l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M219.72 284.14l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M220.22 284.14l.5.477-.5-.477zm1.51 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M222.56 284.3l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#526b42",
    d: "M223.23 284.14l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M223.73 284.14l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M224.23 284.14l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M224.73 284.14l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M225.24 284.14l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M225.74 284.14l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M226.24 284.14l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M227.74 284.14l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M228.24 284.14l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M231.75 284.14l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M232.76 284.14l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M233.26 284.14l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M234.76 284.14l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M235.26 284.14v1.908h.5l-.5-1.908z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M235.76 284.14l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M239.27 284.14l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213918",
    d: "M239.77 284.14l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M240.28 284.14l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M242.28 284.14l-1.003 1.43 1.003-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181000",
    d: "M242.78 284.14l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M260.83 284.14l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M261.33 284.14l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M262.33 284.14l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M267.35 284.14l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M288.9 284.14v1.43h.5l-.5-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M289.41 284.14l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M293.08 284.46l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M296.93 285.57l2.507-1.43-2.507 1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M298.43 284.14l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M302.44 284.14l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M302.94 284.14l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M303.44 284.14l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M220.22 284.62l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M224.73 284.62l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M225.24 284.62l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M226.24 284.62l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M226.74 284.62l1.504 1.43-1.504-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M228.74 284.62l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M229.75 284.62l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M232.76 284.62l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M234.26 284.62l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M234.76 284.62l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M235.26 284.62l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M236.26 284.62l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M239.27 284.62l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M239.77 284.62c-1.625 3.332-3.374 6.928 1.003 9.063 0-2.8 1.056-6.905-1.003-9.063z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M241.28 284.62l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M242.28 284.62l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M242.78 284.62l-.5.954h1l-.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M243.28 284.62l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#31394a",
    d: "M261.33 284.62l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#525a6b",
    d: "M262.33 284.62l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c7373",
    d: "M265.01 284.94l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a51008",
    d: "M267.35 284.62l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M287.57 284.94l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M287.9 284.62l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "M288.4 284.62l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M289.41 284.62l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M291.41 284.62l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M294.92 284.62l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M297.93 284.62l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M301.44 284.62l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M301.94 284.62l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M302.44 284.62l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M302.94 284.62l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M303.78 284.78l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a6342",
    d: "M304.78 284.78l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295210",
    d: "M305.45 284.62l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M305.95 284.62l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M306.45 284.62v.477h2.507l-2.507-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M308.96 284.62l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "M309.46 284.62l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M309.96 284.62l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M310.46 284.62l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M310.96 284.62l.5.477-.5-.477m-90.74.477l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M221.73 285.09l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M222.56 285.25l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M223.4 285.41l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "M226.74 285.09l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M229.75 285.09l-.5 1.43h.5v-1.43m2.507 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M232.76 285.09l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M234.26 285.09l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M234.76 285.09c-1.176 3.072-.87 4.894 1.003 7.633h.5v-7.633h-.5v5.724h-1.003v-5.724z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M236.26 285.09l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M238.77 285.09l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#396b10",
    d: "M239.27 285.09l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293129",
    d: "M240.78 285.09l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293100",
    d: "M241.78 285.09l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M243.28 285.09l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M261.33 285.09l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M261.83 285.09l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "M262.33 285.09l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "M267.35 285.09l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b5252",
    d: "M267.85 285.09l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M268.35 285.09l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#290018",
    d: "M268.85 285.09l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#420000",
    d: "M269.35 285.09l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001010",
    d: "M287.9 285.09l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "M288.4 285.09l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M289.41 285.09l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M289.91 285.09l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M291.41 285.09v1.43h.5l-.5-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M292.92 285.09l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M297.43 285.09l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M299.93 285.09l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M300.44 285.09v.477h1.504l-1.504-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M302.27 285.25l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M302.94 285.09l.5.477-.5-.477m3.51 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M306.95 285.09l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M307.45 285.09l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M307.96 285.09l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M308.46 285.09l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M308.96 285.09l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M220.72 285.57l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M227.24 285.57l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M229.75 285.57l.5.477-.5-.477m2.507 0l1.002.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5231",
    d: "M232.76 285.57l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M233.76 285.57l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M234.26 285.57l.5.477-.5-.477m2.005 0l.502.477-.502-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M236.77 285.57l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M238.77 285.57l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M239.94 285.89l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M240.78 285.57l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#100808",
    d: "M241.28 285.57l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M241.78 285.57l-.5 7.633 1.503-1.432h.5l-.5 1.91c3.922-1.12 4.645-3.654 3.51-7.156l-2.508 5.247h-.5v-6.2h-.502l-1.003 5.247v-5.247z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M242.28 285.57l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293100",
    d: "M243.28 285.57l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M245.79 285.57l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M246.29 285.57l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M261.83 285.57l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#080829",
    d: "M262.33 285.57l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c6b5b5",
    d: "M264.84 285.57l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M266.85 285.57l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M267.35 285.57l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M287.9 285.57l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M288.4 285.57l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M289.24 285.73l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M292.92 285.57l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M294.42 285.57l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M296.93 285.57l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M298.93 285.57l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M299.43 285.57l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M299.93 285.57l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M304.45 285.57l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M304.95 285.57l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M305.45 285.57l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M305.95 285.57l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M306.45 285.57l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M306.95 285.57l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M220.72 286.05l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M221.22 286.05l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M227.74 286.05l1.003.954v-.954h-1.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M228.74 286.05l.5.477-.5-.477m2.005 0l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M231.25 286.05l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M232.25 286.05l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213918",
    d: "M233.76 286.05l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M235.26 286.05v2.385h.5l-.5-2.385z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#526b42",
    d: "M236.77 286.05l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M238.27 286.05l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M238.77 286.05l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M241.28 286.05l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M242.28 286.05v1.908h.5l-.5-1.908z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M243.28 286.05l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M243.78 286.05l.5.477-.5-.477m1.504 0l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293100",
    d: "M245.79 286.05l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M246.29 286.05l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M261.83 286.05l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "M262.33 286.05l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M262.84 286.05l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#842118",
    d: "M266.85 286.05l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293129",
    d: "M288.4 286.05l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M288.9 286.05l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M289.91 286.05l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M292.92 286.05l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M294.42 286.05l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M297.93 286.05l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M298.43 286.05l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M298.93 286.05l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M302.94 286.05l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M303.44 286.05l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "M303.94 286.05l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "M304.45 286.05l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M304.95 286.05l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M305.78 286.21l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M221.73 286.53l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M225.9 286.84l.167.318-.167-.318m6.852-.318l.5.477-.5-.478z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M233.26 286.53l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M233.76 286.53l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M236.93 286.84l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M237.77 286.53l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M238.27 286.53l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M239.77 286.53l.5.477-.5-.477m1.504 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#422100",
    d: "M243.78 286.53l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M245.29 286.53l.5.477-.5-.477m1.003 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M246.79 286.53l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M262.33 286.53l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M263 286.84l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#736b6b",
    d: "M266.85 286.53l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M288.4 286.53l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M288.9 286.53l.5.477-.5-.477m1.003 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M291.41 286.53l.5 1.908h.503l-1.003-1.908z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M291.91 286.53l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M292.92 286.53l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M293.92 286.53l.5.477-.5-.477zm3.01 0l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M297.43 286.53l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M297.93 286.53l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M301.44 286.53l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M301.94 286.53v.477l2.005.477v-.477l-2.005-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M302.44 286.53l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M302.94 286.53l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M303.44 286.53v.477h1.504l-1.504-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M305.11 286.84l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M305.45 286.53v.477l2.005.477v-.477l-2.005-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M306.45 286.53l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M306.95 286.53l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a6342",
    d: "M307.45 286.53l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M307.96 286.53l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M308.46 286.53l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M221.73 287l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M224.57 287.16l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M225.24 287l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "M229.75 287l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "M233.26 287l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M237.77 287l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M239.94 287.32l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M241.11 287.16l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M243.78 287l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M244.29 287l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M244.79 287l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M246.29 287l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M246.79 287l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M263.34 287l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1810",
    d: "M266.34 287l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M266.85 287l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M288.4 287l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "M288.9 287l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M289.91 287l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M290.41 287l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M292.92 287l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M296.93 287l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M299.93 287l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M300.44 287l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M300.94 287l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M301.77 287.16l.334.16-.334-.16m2.172-.16l.502.478-.502-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M304.61 287.32l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M305.45 287l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M305.95 287l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M307.45 287l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M307.96 287l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "M308.46 287l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.96 287l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M309.46 287l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M309.96 287l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M222.39 287.8l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M222.73 287.48l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M223.23 287.48l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M223.73 287.48l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M229.25 287.48l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M229.75 287.48l.5.477-.5-.477m2.34.16l.334.158-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M233.42 287.8l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M236.77 287.48l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M237.27 287.48l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M237.77 287.48l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M240.78 287.48v1.43h.5l-.5-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M243.78 287.48v.954h1.003l-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M244.29 287.48l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M245.79 287.48l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a2908",
    d: "M246.79 287.48l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M263.34 287.48l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c2118",
    d: "M266.34 287.48l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M287.4 287.48l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103910",
    d: "M287.9 287.48l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M289.07 287.8l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M290.24 287.64l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M295.92 287.48l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M299.1 287.8l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M299.77 287.64l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M293.92 293.2c4.806-2.536 8.44-4.293 14.037-4.293-4.637-2.66-12.495-1.07-14.037 4.293z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M303.94 287.48l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M304.95 287.48l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M305.45 287.48l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293129",
    d: "M305.95 287.48l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M306.45 287.48l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M306.95 287.48l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M222.73 287.96l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M227.24 287.96l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M227.74 287.96l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M228.74 287.96l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M229.25 287.96l.5.477-.5-.477m2.507 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M236.77 287.96l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M237.27 287.96l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M239.61 288.12l.334.16-.334-.16m2.674-.16v1.432h.5l-.5-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M245.29 287.96l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293100",
    d: "M246.79 287.96l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M263.34 287.96l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M263.84 287.96l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c6363",
    d: "M266.34 287.96l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M286.9 287.96l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21315a",
    d: "M287.4 287.96l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a7b42",
    d: "M287.9 287.96l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M290.41 287.96l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M291.41 287.96l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M297.93 287.96l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M298.43 287.96l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M306.45 287.96l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M306.95 287.96l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M307.45 287.96l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M307.96 287.96l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M308.46 287.96l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M221.73 288.43l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M222.23 288.43l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M226.24 288.43l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M226.74 288.43l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M227.24 288.43l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M228.74 288.43l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M231.92 288.75l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M233.26 288.43l.5.477-.5-.477m2.005 0l.502.477-.502-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#526b42",
    d: "M237.1 288.59l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M239.27 288.43l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M243.95 288.75l.167.318-.167-.318m1.504 0l.167.318-.166-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M246.79 288.43l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M256.32 288.43l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M256.82 288.43l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M263.84 288.43l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M266.34 288.43l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M285.9 288.43l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.9 288.43l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M287.4 288.43l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#396321",
    d: "M287.9 288.43l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M288.9 288.43l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M289.41 288.43l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M290.41 288.43l.5.477-.5-.477m1.504 0l.5.477-.5-.477m2.507 0l.502.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M296.93 288.43l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M297.43 288.43l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M297.93 288.43l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M307.96 288.43l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M308.46 288.43l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M308.96 288.43l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M309.46 288.43l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M221.73 288.91l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M224.73 288.91l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M225.57 289.07l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M226.24 288.91l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M228.24 288.91l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M233.42 289.23l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M234.76 288.91v1.908h1.003v-1.908h-1.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M236.77 288.91l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#396b10",
    d: "M237.27 288.91l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M239.27 288.91v2.385h.5l-.5-2.385z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M240.94 289.23l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M256.32 288.91l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "M256.82 288.91l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M263.84 288.91l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M264.34 288.91l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M264.84 288.91l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd0008",
    d: "M265.34 288.91l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M265.84 288.91l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M277.37 288.91l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M278.04 289.23l.167.318-.167-.318m5.348-.318l.5.477-.5-.478z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M283.89 288.91l2.005 1.43v-.476l-2.005-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001010",
    d: "M285.9 288.91l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M286.4 288.91l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M286.9 288.91l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M287.4 288.91l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M288.07 289.23l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M289.24 289.07l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M290.41 288.91l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M291.41 288.91l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M291.91 288.91l-.5 1.908.5-1.908z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M293.42 288.91l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M294.08 289.23l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M294.42 288.91l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M295.42 289.39v.477h1.504l-1.504-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M296.42 288.91l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M296.93 288.91l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M302.44 288.91l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M302.94 288.91l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M303.44 288.91l-1.003.477v.477l1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M303.94 288.91l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a6342",
    d: "M304.45 288.91v.477h3.51l-3.51-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295210",
    d: "M307.96 288.91l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M308.46 288.91l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M308.96 288.91l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M309.46 288.91l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "M309.96 288.91l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M310.46 288.91l.5.477-.5-.477m-89.237.477l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M221.73 289.39l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M223.73 289.39l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M224.23 289.39l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M224.73 289.39l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "M227.74 289.39l.5.477-.5-.477m4.01 0l.502.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M236.26 289.39l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M236.77 289.39l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M237.27 289.39l.5.477-.5-.477m5.013 0l.502.477-.502-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M243.62 289.55l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M245.29 289.39l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M251.81 289.39l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M255.82 289.39l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M256.32 289.39l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M256.82 289.39l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M257.32 289.39l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c7373",
    d: "M264.84 289.39l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b0808",
    d: "M265.34 289.39l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M265.84 289.39l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000818",
    d: "M274.37 289.39l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "M277.37 289.39l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M281.38 289.39l1.003.954v-.954h-1.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001039",
    d: "M283.39 289.39l.5.477-.5-.477m1.504 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M285.9 289.39l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.4 289.39l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M286.9 289.39l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M287.4 289.39l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M290.58 289.71l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M292.92 289.39v.477l2.507.954v-.476l-2.507-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M293.42 289.39l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M294.42 289.39l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M295.92 289.39l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M300.94 289.39l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M301.77 289.55l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M303.44 289.39l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M303.94 289.39l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M304.45 289.39l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M304.95 289.39l.5.477-.5-.477m4.01 0l.502.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M309.46 289.39l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M309.96 289.39l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "M310.8 289.55l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M221.22 289.86l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M222.73 289.86l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M223.23 289.86l.5.477-.5-.477m4.01 0l.502.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M227.74 289.86l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M229.25 289.86l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M229.75 289.86l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M231.25 289.86l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M231.75 289.86l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M232.25 289.86l.5.477-.5-.477m1.337.16l.334.158-.333-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M236.26 289.86l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M236.77 289.86l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#426331",
    d: "M237.27 289.86l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M240.94 290.18l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M242.28 289.86l.5.477-.5-.477m1.003 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M245.12 290.02l.334.16-.334-.16m1.67-.16l.502.478-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M251.3 289.86l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211800",
    d: "M251.81 289.86l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M252.31 289.86l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M255.32 289.86l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M255.82 289.86l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M256.32 289.86l-1.003 2.862-1.504-.954 1.504 3.816h.502v-1.908h.5v3.34c2.425-1.53 2.112-4.25 1.504-6.68h-.5v4.77h-.503l-.5-5.246z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M257.32 289.86l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M257.82 289.86l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M264.34 289.86l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b4242",
    d: "M264.84 289.86l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M265.34 289.86l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103910",
    d: "M274.37 289.86l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10214a",
    d: "M274.87 289.86l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M276.37 289.86l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M276.87 289.86l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M277.37 289.86l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M278.88 289.86l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001010",
    d: "M281.38 289.86l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M283.39 289.86l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M285.9 289.86l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M286.4 289.86l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M286.9 289.86l-3.008 8.586c2.864-1.506 4.278-5.7 3.008-8.586z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293129",
    d: "M287.4 289.86l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M287.9 289.86l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M292.92 289.86l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M294.75 290.02l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M295.42 289.86l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M299.43 289.86l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M299.43 290.34v.477h2.507l-2.507-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M300.94 289.86l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M301.44 289.86v.477h3.51l-3.51-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M304.95 289.86l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M305.45 289.86l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M305.95 289.86l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M306.45 289.86l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M310.96 289.86l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M220.72 290.34l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M221.22 290.34l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M222.23 290.34l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M222.73 290.34l.5.477-.5-.477m3.51 0v1.43h.5l-.5-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M226.74 290.34l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M229.25 290.34l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M231.25 290.34l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M232.25 290.34l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M233.76 290.34l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5231",
    d: "M236.26 290.34l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#526b42",
    d: "M237.27 290.34l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M242.11 290.5l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M243.45 290.66l.167.318-.167-.318m1.337-.318l.5.477-.5-.478m2.005 0l.502.477-.502-.478z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M251.3 290.34l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M251.81 290.34l1.003 2.385h1.504l-2.507-2.385z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#311000",
    d: "M252.31 290.34l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#422100",
    d: "M255.32 290.34l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M256.82 290.34v1.908h.5l-.5-1.908z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M257.82 290.34l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M264.34 290.34l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "M264.84 290.34l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M265.34 290.34l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#083121",
    d: "M274.37 290.34l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M274.87 290.34l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M275.37 290.34l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#102110",
    d: "M276.37 290.34l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M276.87 290.34l-.5 4.293h.5v-4.293z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#083121",
    d: "M277.37 290.34l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000818",
    d: "M278.88 290.34l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M280.88 290.34l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "M281.38 290.34l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M282.89 290.34l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M283.39 290.34l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00215a",
    d: "M283.89 290.34l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103910",
    d: "M284.39 290.34l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M284.89 290.34l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103910",
    d: "M285.4 290.34l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M285.9 290.34l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "M286.4 290.34l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M287.4 290.34l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M287.9 290.34l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M290.58 290.66l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M292.92 290.34l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M293.92 290.34l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M298.43 290.34l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M298.93 290.34l.5.477-.5-.477m3.008 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "M302.44 290.34v.477h1.504l-1.504-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a6342",
    d: "M304.28 290.5l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M305.45 290.34l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M305.95 290.34l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M306.45 290.34l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M306.95 290.34l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M307.45 290.34l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M220.72 290.82l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M224.23 290.82l.5 1.908h.503l-1.003-1.908z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M225.57 290.98l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M227.74 290.82l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M228.24 290.82l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M228.74 290.82l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213918",
    d: "M230.75 290.82l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M231.25 290.82l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M232.25 290.82l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M232.76 290.82l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a2908",
    d: "M233.26 290.82l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M233.76 290.82l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "M234.26 290.82l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M236.26 290.82l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M237.27 290.82l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M240.78 290.82l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M244.79 290.82l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181000",
    d: "M246.79 290.82l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#310000",
    d: "M247.29 290.82l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313918",
    d: "M251.3 290.82l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M251.81 290.82l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293100",
    d: "M252.81 290.82l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1010",
    d: "M253.31 290.82l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#734a42",
    d: "M254.15 290.98l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a2121",
    d: "M254.81 290.82l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M255.32 290.82l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M257.82 290.82l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M258.32 290.82l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M264.34 290.82l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M264.84 290.82l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M271.86 290.82l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00216b",
    d: "M272.36 290.82l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103921",
    d: "M274.37 290.82l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M274.87 290.82l-.5 6.2c1.862-1.735 1.816-4.11.5-6.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#102121",
    d: "M275.37 290.82l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212139",
    d: "M275.87 290.82l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M276.37 290.82l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293129",
    d: "M277.37 290.82l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "M277.88 290.82l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#31425a",
    d: "M278.38 290.82l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M278.88 290.82l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#31425a",
    d: "M279.38 290.82l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "M280.21 290.98l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M281.55 291.14l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "M281.89 290.82l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636b7b",
    d: "M282.39 290.82l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "M282.89 290.82l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "M283.89 290.82l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M284.39 290.82l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M284.89 290.82l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M285.9 290.82l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M286.4 290.82l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M291.41 290.82l.5.477-.5-.477m1.003 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M292.92 290.82l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M293.92 290.82l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M297.43 290.82l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M297.93 290.82l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M298.43 290.82l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M302.94 290.82l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M303.44 290.82l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M303.94 290.82l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M304.45 290.82l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M304.95 290.82l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M305.95 290.82l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M306.45 290.82l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M306.95 290.82l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M307.45 290.82l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M220.72 291.3l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M221.22 291.3l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M221.73 291.3l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#396b10",
    d: "M222.23 291.3l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213918",
    d: "M222.73 291.3l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M223.56 291.45l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M225.57 291.45l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M227.07 291.45l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M227.74 291.3l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M230.25 291.3l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M230.75 291.3l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#420000",
    d: "M232.76 291.3l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M234.43 291.61l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M234.76 291.3l.5 1.908h.503l-1.003-1.908z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M236.43 291.61l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M237.27 291.3l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M237.77 291.3l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M240.78 291.3l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M243.28 291.3l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M244.29 291.3l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M246.29 291.3l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M246.79 291.3l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M247.29 291.3l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213918",
    d: "M247.8 291.3l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M248.3 291.3l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M248.8 291.3l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M249.3 291.3l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M249.8 291.3l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#526b42",
    d: "M251.3 291.3l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M251.81 291.3l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M252.31 291.3l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M253.81 291.3l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M254.31 291.3l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5231",
    d: "M254.81 291.3l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M258.32 291.3l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b5252",
    d: "M258.82 291.3l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M259.33 291.3l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M259.83 291.3l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002984",
    d: "M269.35 291.3l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00184a",
    d: "M269.85 291.3l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42425a",
    d: "M270.36 291.3l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M270.86 291.3l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M271.36 291.3l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M271.86 291.3l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M272.36 291.3l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M275.37 291.3l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M275.87 291.3l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M278.38 291.3l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M280.38 291.3l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M280.88 291.3l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M282.39 291.3l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M283.89 291.3l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M284.39 291.3l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M284.89 291.3l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M285.4 291.3l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M285.9 291.3l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M286.4 291.3l.5.477-.5-.477m4.01 0l.502.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M291.58 291.61l.167.318-.167-.318m.836-.318l.5.477-.5-.478z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M293.42 291.3l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M293.92 291.3l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M296.42 291.3l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M296.93 291.3l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M297.43 291.3l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M304.45 291.3l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M304.95 291.3l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M305.45 291.3l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M221.06 291.93l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M222.23 291.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M222.73 291.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M223.73 293.68l1.003-1.43c-1.297-.286-2.077.465-1.003 1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M225.57 291.93l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M226.24 291.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M229.25 291.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M229.75 291.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M230.25 291.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a2121",
    d: "M232.76 291.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M237.77 291.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M238.27 291.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M240.94 292.09l.167.318-.167-.318m1.838-.318l.502.477-.502-.478z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M246.29 291.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M247.29 291.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M247.8 291.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M248.3 291.77l.5 3.34 2.508 1.907 3.51.477.5-.477c-.37-1.292-4.465-6.87-5.013-3.816l-1.002-1.43H248.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M249.3 291.77v.954l1.003-.954H249.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M250.3 291.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M251.14 291.93l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M251.97 292.09l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M252.81 291.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M254.31 291.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M254.81 291.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#526b42",
    d: "M258.32 291.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M259.83 291.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M260.33 291.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M260.83 291.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M261.33 291.77l.5.477-.5-.477m6.517 0l.502.477-.503-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M268.35 291.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M268.85 291.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M269.35 291.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M269.85 291.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M275.37 291.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M275.87 291.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M277.88 291.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M278.38 291.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M279.88 291.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "M280.38 291.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M280.88 291.77l-3.51 5.724c3.933-.044 5.62-2.048 6.017-5.724h-.502l-3.51 5.247 1.505-5.247z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a6342",
    d: "M281.38 291.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M282.39 291.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M283.39 291.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M283.89 291.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M284.89 291.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M285.4 291.77l-3.51 6.2c2.335-1.093 4.07-3.667 3.51-6.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "M285.9 291.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M286.4 291.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M290.41 291.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M293.42 291.77l.5.477-.5-.477m2.507 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M296.42 291.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M298.26 291.93l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M298.93 291.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M299.43 291.77v.477h1.504l-1.504-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M300.94 291.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M301.77 291.93l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M302.44 291.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M303.11 292.09l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M303.44 291.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M305.95 291.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M306.45 291.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M306.95 291.77l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M222.23 292.25l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M223.73 292.25l-.5.954h1l-.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M224.23 292.25l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M228.24 292.25l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5231",
    d: "M228.74 292.25l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M229.25 292.25l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M231.25 292.25l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M231.75 292.25l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c9c84",
    d: "M232.25 292.25l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5231",
    d: "M232.76 292.25l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#422100",
    d: "M233.26 292.25l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a2908",
    d: "M233.76 292.25l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#311000",
    d: "M234.26 292.25l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M235.26 292.25l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M236.26 292.25l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M238.27 292.25l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M242.78 292.25l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M245.79 292.25l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M246.29 292.25l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M247.8 292.25l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M248.8 292.25l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M252.31 292.25l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M253.31 292.25l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M254.81 292.25l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M256.99 292.57l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M258.49 292.57l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M260.83 292.25l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M261.33 292.25l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M261.83 292.25l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M267.35 292.25l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M267.85 292.25l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M268.35 292.25l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M275.87 292.25l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M277.88 292.25l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M278.38 292.25l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M279.88 292.25l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M280.38 292.25l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M281.72 292.41l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M282.39 292.25l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M283.39 292.25l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M283.89 292.25l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "M284.39 292.25l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M284.89 292.25l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M285.9 292.25l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M290.41 292.25l.5.477-.5-.477m1.003 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M293.42 292.25l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M294.42 292.73v.477h1.504l-1.504-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M295.42 292.25l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M295.92 292.25l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "M303.44 292.25l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "M303.94 292.25l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395231",
    d: "M304.45 292.25l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M304.95 292.25l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M305.45 292.25l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M306.28 292.41l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M306.95 292.25l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M307.45 292.25l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5231",
    d: "M222.23 292.73l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M225.74 292.73l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M226.24 292.73l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M226.74 292.73l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5231",
    d: "M227.24 292.73l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M227.74 292.73l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M228.24 292.73l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M229.08 292.89l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M229.75 292.73l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M230.25 292.73l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#396b10",
    d: "M230.75 292.73l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M231.25 292.73l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M230.25 293.2v.477h4.512v.477h-4.512v.477h1.003v.478c-2.74.143-4.127 1.11-5.515 3.34l8.523-.478v.477c-2.31.698-5.675.45-6.517 2.863 3.2-1.243 7.83-1.67 9.526-4.77l-3.01 1.43 1.505-1.908-4.512-.477v-.477l8.02.477v.477h-1.503v.477l6.517-.478v-.477h-1.504v-.477h3.008v-.477l-4.01.955-11.53-2.385z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M235.76 292.73l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M236.26 292.73l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M238.27 292.73l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M238.77 292.73l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M240.78 292.73l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M242.61 292.89l.334.16-.334-.16m2.172-.16l.502.478-.502-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M245.79 292.73l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M247.8 292.73l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M248.3 292.73l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M249.63 292.89l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M253.31 292.73l1.504.954v-.477l-1.504-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M253.98 293.04l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M255.32 292.73l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M261.83 292.73l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M262.33 292.73l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M262.84 292.73l.5.477-.5-.477m3.51 0l-1.003 1.43 1.002-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M266.85 292.73l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M267.35 292.73l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M275.87 292.73l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M277.88 292.73l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M278.38 292.73l-3.008 4.77c1.9-.925 3.604-2.634 3.008-4.77z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M278.88 292.73l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M279.38 292.73l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M279.88 292.73l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M280.88 292.73l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M281.38 292.73l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M281.89 292.73l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M283.39 292.73l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M283.89 292.73l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M284.39 292.73l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M285.4 292.73l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M285.9 292.73l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M289.41 292.73l.5.477-.5-.477zm4.01 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M294.92 292.73l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M303.94 292.73l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M304.45 292.73l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M304.95 292.73l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M305.45 292.73l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M305.95 292.73l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M306.45 292.73l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M306.95 292.73l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M307.45 292.73l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M307.96 292.73l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M222.39 293.52l.167.318-.167-.318m1.337-.318l.5.477-.5-.478z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#526b42",
    d: "M224.23 293.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M225.07 293.36l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M225.74 293.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M226.24 293.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M228.24 293.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.74 293.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M229.25 293.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M229.75 293.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "M236.26 293.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M236.77 293.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M238.27 293.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M238.77 293.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M239.27 293.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "M240.78 293.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M241.78 293.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M242.28 293.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M243.78 293.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M244.29 293.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M244.79 293.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M247.8 293.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M248.3 293.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M250.3 293.2l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M255.32 293.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M256.82 293.2v1.908h.5l-.5-1.908z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M258.32 293.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M262.84 293.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M263.34 293.2l1.504 1.908-1.504-1.908z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M266.34 293.2l-1.003 1.43 1.003-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M266.85 293.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M276.04 293.52l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.37 293.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M277.88 293.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M278.88 293.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M279.38 293.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M280.88 293.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M281.38 293.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M281.89 293.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M283.39 293.2l.5.477-.5-.477m2.005 0l.502.477-.502-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M289.41 293.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M293.92 293.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M294.42 293.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M304.45 293.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103910",
    d: "M304.95 293.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M305.45 293.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M306.95 293.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M307.45 293.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M307.96 293.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M308.46 293.2l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M221.73 293.68l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213918",
    d: "M222.73 293.68l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M223.23 293.68l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M223.73 293.68l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M228.74 293.68l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M229.25 293.68l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M229.75 293.68v.477h2.507l-2.507-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M232.25 293.68l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M232.76 293.68l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M233.26 293.68l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M233.76 293.68l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M234.26 293.68l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213918",
    d: "M236.77 293.68l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M237.27 293.68l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M237.77 293.68l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M238.27 293.68l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M239.27 293.68l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M239.77 293.68l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M240.28 293.68l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M240.78 293.68l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M241.28 293.68l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M241.78 293.68l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M242.28 293.68l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M242.78 293.68l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#102110",
    d: "M243.28 293.68l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M243.78 293.68l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M244.29 293.68l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M248.3 293.68l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M251.3 293.68l1.504 1.43-1.504-1.43m3.008 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M255.98 294l.167.318-.167-.318m2.34-.318l.5.477-.5-.478z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M274.37 293.68l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M276.87 293.68l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M277.37 293.68l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "M278.88 293.68l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M279.38 293.68l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "M280.88 293.68l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M281.38 293.68l.5.477-.5-.477m1.504 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M283.72 293.84l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M285.4 293.68l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M286.9 293.68l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M293.92 293.68l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M295.42 293.68l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M295.92 293.68l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M296.42 293.68v.477h1.504l-1.504-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M297.93 293.68l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M298.43 293.68v.477h2.507l-2.507-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M300.94 293.68l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M301.44 293.68l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M301.94 293.68l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M302.44 293.68l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M305.45 293.68l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M305.95 293.68l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M221.73 294.16l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M222.23 294.16l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M222.73 294.16l-1.003.477v.477l1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M229.75 294.16l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M234.76 294.16l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M235.26 294.16l.5.477-.5-.477m2.005 0l.502.477-.502-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#391810",
    d: "M237.77 294.16l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#423100",
    d: "M240.11 294.32l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M241.28 294.16l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M241.78 294.16l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293100",
    d: "M242.28 294.16l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M242.78 294.16v.477h2.005l-2.005-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M244.79 294.16l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M245.29 294.16l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M245.79 294.16l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M246.29 294.16l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M248.3 294.16l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M251.3 294.16l.5.477-.5-.477m3.008 0l.5 1.43h.503l-1.002-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M258.32 294.16l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M264.84 294.16l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a6342",
    d: "M274.37 294.16l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M276.87 294.16l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M278.38 294.16l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M278.88 294.16l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M280.38 294.16l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M280.88 294.16l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M282.89 294.16l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M283.39 294.16l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M284.89 294.16l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M285.4 294.16l.5.477-.5-.477m1.504 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M294.42 294.16l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M294.92 294.16l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M295.42 294.16l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M301.44 294.16l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M301.94 294.16l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "M302.44 294.16l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M302.94 294.16l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M303.44 294.16l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M303.94 294.16l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M304.45 294.16l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M306.45 294.16l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M228.24 294.63l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5231",
    d: "M228.74 294.63l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M229.25 294.63l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M229.75 294.63l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M230.58 294.79l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M237.77 294.63l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293100",
    d: "M238.27 294.63l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M238.77 294.63l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M239.27 294.63l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M239.77 294.63l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M240.28 294.63l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M240.78 294.63l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M241.28 294.63l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M245.79 294.63l-1.504 1.43 1.504-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M246.29 294.63v.954h1.003l-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213918",
    d: "M246.79 294.63l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M247.29 294.63l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M248.3 294.63l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M251.81 294.63l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M254.31 294.63l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M255.82 294.63l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M258.32 294.63l.5.477-.5-.477m6.517 0l.502.477-.503-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "M274.37 294.63l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M276.87 294.63l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M278.88 294.63l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M280.38 294.63l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M282.39 294.63l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.89 294.63l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M283.39 294.63l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M284.89 294.63l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M286.9 294.63l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M288.9 294.63l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M289.74 294.79l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M290.41 294.63l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M290.91 294.63l-.5.954.5-.954m2.005 0l.502.477-.502-.477m9.526 0l.502.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103910",
    d: "M302.94 294.63l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M303.44 294.63l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M303.94 294.63l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M304.45 294.63l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M304.95 294.63l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "M305.45 294.63l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M305.95 294.63l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M306.45 294.63l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M306.95 294.63l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M227.24 295.11l-1.003 1.43 1.003-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M227.74 295.11l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M228.24 295.11l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M231.59 295.27l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M232.42 295.43l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M239.61 295.27l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.78 295.11l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M241.28 295.11l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M242.78 295.11v.477h1.504l-1.504-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M247.29 295.11l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M248.3 295.11l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M248.8 295.11l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M249.3 295.11l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#422100",
    d: "M249.8 295.11l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a4208",
    d: "M250.3 295.11l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M252.31 295.11l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M252.81 295.11v.954h1.003l-1.003-.954zm5.01 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M258.32 295.11l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M273.86 295.11l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M274.37 295.11l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M275.87 295.11l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M277.88 295.11l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M278.38 295.11l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M279.88 295.11l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M280.38 295.11l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M282.72 295.27l.334.16-.334-.16m2.172-.16l.502.478-.502-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M286.4 295.11l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M286.9 295.11l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M290.91 295.11l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M291.41 295.11l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M291.91 295.11l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M292.41 295.11l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M295.92 295.11l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M296.42 295.11l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M296.93 295.11v.954h1.003l-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M297.43 295.11l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M303.44 295.11l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M303.94 295.11l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M305.95 295.11l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M306.45 295.11l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "M306.95 295.11l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M307.96 295.11l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M227.24 295.59l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M232.76 295.59l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M233.26 295.59v.477h2.005l-2.005-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M235.26 295.59l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M235.76 295.59v1.43l2.005-1.43h-2.005z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M238.1 295.75l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M238.77 295.59l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M241.78 295.59l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M242.28 295.59l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M244.79 295.59l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M245.29 295.59l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M245.79 295.59l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M246.29 295.59v.954h1.003l-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M247.63 295.75l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.8 295.59l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M249.3 295.59l.5.477-.5-.477zm1 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M250.8 295.59l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M255.15 295.75l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M257.82 295.59l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M273.86 295.59l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M275.87 295.59l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M277.37 295.59l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M277.88 295.59l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M280.05 295.91l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M281.89 295.59l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "M282.39 295.59l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M284.73 295.75l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M286.4 295.59l.5.477-.5-.477m6.183.318l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M293.08 295.91l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M293.42 295.59l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M294.92 295.59l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M295.42 295.59l-1.003 1.43 1.003-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M297.93 295.59v.477h1.504l-1.504-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M299.43 295.59l1.003.954v-.954h-1.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M300.44 295.59l.5.477-.5-.477m3.51 0l1.503 1.43-1.504-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M304.45 295.59l1.504 1.43-1.504-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M306.95 295.59l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M307.79 295.75l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M226.74 296.07l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "M235.76 296.07l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M242.78 296.07l2.005.954v-.477l-2.005-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M243.28 296.07l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "M243.78 296.07l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M244.29 296.07l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M244.79 296.07l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M245.79 296.07l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M247.29 296.07l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#734a42",
    d: "M248.8 296.07l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#423100",
    d: "M250.8 296.07l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M255.48 296.38l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M257.32 296.07l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M257.82 296.07l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M273.86 296.07l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M275.54 296.38l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M275.87 296.07l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M277.37 296.07l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M279.38 296.07l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M282.05 296.38l.167.318-.167-.318m2.34-.318l.5.477-.5-.478z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M286.4 296.07l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M287.9 296.07l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M288.4 296.07l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M287.4 296.54v.477l4.512-.477H287.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M291.91 296.07l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.42 296.07l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M293.92 296.07l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M295.42 296.07l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M295.92 296.07l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M296.42 296.07l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.44 296.07l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M300.94 296.07l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M301.44 296.07l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M301.94 296.07l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M302.44 296.07l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M226.24 296.54l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M232.76 296.54l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M233.26 296.54l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M235.26 296.54l-.5 1.43.5-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M237.27 296.54l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M237.77 296.54l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M238.27 296.54l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M238.77 296.54l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M239.27 296.54v.477h2.005l-2.005-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M241.28 296.54l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M241.78 296.54l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "M242.28 296.54l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M240.28 298.93l10.528-1.43c-3.274-1.31-8.092-1.2-10.528 1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M246.29 296.54v.477h1.504l-1.504-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M247.8 296.54v.477h1.504l-1.504-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#422100",
    d: "M249.3 296.54l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a2908",
    d: "M249.8 296.54l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M250.3 296.54l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M250.8 296.54l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M257.32 296.54l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M273.36 296.54l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M276.37 297.5l1.504-.954-1.504.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M279.38 296.54l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M281.38 296.54l-1.003 1.43h1.504l-.5-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M284.23 296.7l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M285.9 296.54l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M286.73 296.7l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M290.41 296.54l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M291.91 296.54l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M292.41 296.54v.477l7.02 1.908v-.477l-7.02-1.908z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M293.92 296.54l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M296.42 296.54l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M296.93 296.54l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M297.43 296.54l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M300.44 296.54l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M300.94 296.54l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M301.44 296.54l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M301.94 296.54l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M302.44 296.54l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M302.94 296.54l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M303.44 296.54l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M303.94 296.54l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M225.74 297.02l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M226.24 297.02l.5.477-.5-.477m2.005 0v.954h1.504v-.954h-1.505z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M229.75 297.02l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M230.25 297.02l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M230.75 297.02l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M231.59 297.18l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M237.27 297.02l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M238.77 297.02l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M239.27 297.02v.477h2.005l-2.005-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M241.28 297.02l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M241.78 297.02l.5.477-.5-.477m9.024 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "M251.81 297.02v.477h1.504l-1.504-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M253.31 297.02l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M254.81 297.02l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M255.32 297.02l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M257.32 297.02l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd8c8c",
    d: "M258.16 297.18l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#845a52",
    d: "M258.82 297.02l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c4a42",
    d: "M264.34 297.02l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad524a",
    d: "M264.84 297.02l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#845a52",
    d: "M270.36 297.02l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd8c8c",
    d: "M271.19 297.18l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293129",
    d: "M273.36 297.02l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "M274.87 297.02l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M281.38 297.02l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M283.39 297.02l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M283.89 297.02l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M285.4 297.02l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M285.9 297.02l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M285.9 298.45l12.533 1.908v1.908c1.42-4.19-10.154-6.955-12.533-3.816z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M291.91 297.02l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M292.41 297.02l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M292.92 297.02l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M293.42 297.02l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M297.43 297.02l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "M297.93 297.02l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M298.43 297.02l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M298.93 297.02l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M301.44 297.02l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M303.94 297.02l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M304.45 297.02l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M305.28 297.18l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M305.95 297.02l.5.477-.5-.477m-80.715.477l-1.003 1.43 1.003-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M225.74 297.5l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M226.74 297.5l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M227.57 297.66l.334.16-.334-.16m6.684-.16l.502.478-.502-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M236.77 297.5l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M240.28 297.5l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293129",
    d: "M240.78 297.5l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M249.63 297.66l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M250.3 297.5l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#423100",
    d: "M250.8 297.5l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#422100",
    d: "M251.64 297.66l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a2908",
    d: "M252.31 297.5l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M252.81 297.5v.477h1.504l-1.504-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M254.31 297.5v.477h1.504l-1.504-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M255.82 297.5l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M244.29 306.08v-.477l-3.008.477v-.477c13.567-4.093 33.56-4.093 47.125 0v.477l-2.507-.477c2.474 3.59 9.242 1.364 6.996-2.812-1.916-3.56-8.896-3.98-12.51-4.472-10.188-1.382-21.416-1.496-31.584.09-3.62.566-8.025.867-10.914 3.278-2.058 1.718-1.308 5.194 1.436 5.964 1.696.476 3.582-.805 4.966-1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M273.36 297.5l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M275.37 297.5l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M276.2 297.66l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b2908",
    d: "M276.87 297.5l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M278.88 297.5l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M279.38 297.5l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M279.88 297.5l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M280.88 297.5l.5.477-.5-.477m2.507 0l-.502.954.502-.954m2.005 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M292.92 297.5l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M294.25 297.66l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M294.92 297.5l-.5.954.5-.954m3.008 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M298.43 297.5l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M298.93 297.5l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M299.43 297.5l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#315221",
    d: "M299.93 297.5l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M300.44 297.5l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103910",
    d: "M301.94 297.5l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M302.44 297.5l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M304.95 297.5l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M305.45 297.5l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#102110",
    d: "M305.95 297.5l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M306.45 297.5l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M225.24 297.97l3.008 1.43-3.008-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M233.42 298.29l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M233.76 297.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M236.26 297.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M236.77 297.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M240.28 297.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M246.29 297.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M246.79 297.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M247.29 297.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#422100",
    d: "M247.8 297.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "M248.3 297.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M248.8 297.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M249.3 297.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M249.8 297.97l.5.477-.5-.477m29.58 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M279.88 297.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M280.38 297.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M280.88 297.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#422100",
    d: "M281.38 297.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a4208",
    d: "M281.89 297.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M282.39 297.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M283.39 297.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M284.89 297.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M285.4 297.97l.5.477-.5-.477m1.003 0l2.506.477-2.507-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M288.4 297.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M294.92 297.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "M295.42 297.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M295.92 297.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M296.42 297.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M298.93 297.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M300.44 297.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M300.94 297.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M301.44 297.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M301.94 297.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M302.44 297.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M305.95 297.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M306.45 297.97l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "M224.73 298.45l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M228.24 298.45v.954h1.003v-.954h-1.003m3.676.318l.168.318-.168-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M232.59 298.61l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M235.26 298.45l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M235.76 298.45l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M236.26 298.45l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M239.77 298.45l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M242.11 298.61l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M243.12 298.61l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "M243.78 298.45l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#181000",
    d: "M244.29 298.45l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#310000",
    d: "M244.79 298.45l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M245.29 298.45l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M245.79 298.45l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M246.29 298.45l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M246.79 298.45l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M257.82 298.45l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M258.32 298.45l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M258.82 298.45l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M260.83 298.45l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M261.33 298.45l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M265.17 298.61l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M265.84 298.45l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M268.68 298.61l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M269.35 298.45l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M282.89 298.45l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M283.39 298.45l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M283.89 298.45l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a2908",
    d: "M284.39 298.45l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293100",
    d: "M284.89 298.45l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M285.4 298.45l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M285.9 298.45l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M288.9 298.45v.477h1.504l-1.504-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M290.41 298.45l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M290.91 298.45l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M295.92 298.45l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "M296.42 298.45l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293129",
    d: "M296.93 298.45l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M297.43 298.45l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M297.93 298.45l.5.477-.5-.477m1.504 0l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M299.93 298.45l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M301.44 298.45l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M301.94 298.45l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M302.44 298.45l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M302.94 298.45l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M224.23 298.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M229.25 298.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M229.75 298.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M230.25 298.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M231.08 299.09l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M234.26 298.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M234.76 298.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M235.26 298.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M239.27 298.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M240.11 299.09l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M239.27 299.88v.477l3.008-.954-3.008.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293100",
    d: "M242.28 298.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a2908",
    d: "M242.78 298.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M243.28 298.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M243.78 298.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M250.3 298.93l.5.477-.5-.477zm2.01 0l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M257.32 298.93l.5.477-.5-.477zm2.01 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "M261.33 298.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M266.85 298.93l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "M267.85 298.93l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M269.85 298.93l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M270.36 298.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M272.36 298.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "M273.36 298.93l-.5 3.34.5-3.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M273.86 298.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M274.87 298.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "M275.37 298.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "M275.87 298.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M276.87 298.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M278.88 298.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M285.4 298.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M285.9 298.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a1000",
    d: "M286.4 298.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293100",
    d: "M286.9 298.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M287.9 298.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M288.4 298.93v.477l5.013.954-5.013-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M290.41 298.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M291.41 298.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M291.91 298.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M292.58 299.25l.167.318-.167-.318m4.345-.318l.5.477-.5-.478z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M297.43 298.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M297.93 298.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M298.43 298.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M298.93 298.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M299.43 298.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M300.44 298.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M302.44 298.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M302.94 298.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M303.44 298.93l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M227.24 299.4l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M227.74 299.4l.5.477-.5-.477m4.512 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M232.76 299.4l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#396b10",
    d: "M233.26 299.4l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M233.76 299.4l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M234.26 299.4l.5.477-.5-.477m4.512 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M239.27 299.4l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M241.28 299.4l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M241.78 299.4l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "M247.8 299.4l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "M252.31 299.4l.5.477-.5-.477m1.504 0l.5.477-.5-.477m3.844.16l.334.158-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M258.32 299.4l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "M259.16 299.56l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "M266.85 299.4l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "M269.69 299.56l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M271.86 299.4l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M275.03 299.72l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "M279.88 299.4l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "M281.38 299.4l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M283.39 299.4l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M287.4 299.4l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M287.9 299.4l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293100",
    d: "M288.4 299.4l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M288.9 299.4l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M292.92 299.4l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001000",
    d: "M293.42 299.4l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M293.92 299.4l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M294.42 299.4l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M294.92 299.4l.5.477-.5-.477m2.507 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M297.93 299.4l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M298.43 299.4l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M298.93 299.4l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M299.43 299.4l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M300.27 299.56l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M300.94 299.4l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M227.24 299.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M230.25 299.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#396b10",
    d: "M230.75 299.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#526b42",
    d: "M231.25 299.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M231.75 299.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M232.25 299.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M232.76 299.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M238.27 299.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213918",
    d: "M238.77 299.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a1000",
    d: "M239.77 299.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M240.28 299.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M243.62 300.04l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "M247.29 299.88l.5.477-.5-.477zm2.68.32l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M251.3 299.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M251.81 299.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M252.81 299.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M258.82 299.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "M259.33 299.88l.5.477-.5-.477m1.003 0l.5.477-.5-.477zm1.497 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M265.84 299.88v1.43h.5l-.5-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "M266.34 299.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M268.35 299.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M268.85 299.88l.5 1.43-.5-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M271.86 299.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "M272.36 299.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "M279.38 299.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "M279.88 299.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "M280.88 299.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M281.89 299.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "M282.89 299.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "M283.39 299.88l-.5 1.43.5-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "M284.06 300.2l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M285.4 299.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M285.9 299.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M288.9 299.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a2908",
    d: "M289.41 299.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M289.91 299.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M290.41 299.88l.5.477-.5-.477m3.175.318l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M293.92 299.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M294.42 299.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M294.92 299.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M295.42 299.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M295.92 299.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M296.42 299.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M298.43 299.88l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M298.93 299.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M299.93 299.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M300.44 299.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "M300.94 299.88l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M227.24 300.36l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M229.25 300.36l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M229.75 300.36l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M230.25 300.36l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M238.27 300.36l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#311000",
    d: "M238.77 300.36l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M239.27 300.36l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "M241.78 300.36l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "M242.28 300.36l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "M242.78 300.36l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "M243.28 300.36l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "M243.78 300.36l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M248.3 300.36l.5.477-.5-.477zm4.51 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "M261.16 300.52l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "M266.34 300.36l.5.477-.5-.477m5.515 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M274.87 300.36l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "M275.87 300.36l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M280.38 300.36v1.908l2.005-.477-2.005-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M281.89 300.36l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "M282.89 300.36l.5.477-.5-.477m2.84.16l.335.158-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M286.9 300.36l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M287.4 300.36l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M289.91 300.36l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M290.41 300.36l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M291.24 300.52l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M291.91 300.36l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M292.75 300.52l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M293.92 300.36l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M294.42 300.36l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M294.92 300.36l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M295.42 300.36l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M295.92 300.36l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M296.42 300.36l1.003 1.43-1.003-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M296.93 300.36l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M297.43 300.36l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M297.93 300.36l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M299.43 300.36l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M228.24 300.84l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M228.74 300.84l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M229.25 300.84l.5.477-.5-.477m8.02 0l.503.477-.502-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#524242",
    d: "M237.77 300.84l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M238.27 300.84l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M240.11 300.99l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "M241.78 300.84l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "M242.78 300.84l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M245.79 300.84l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "M246.29 300.84l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M248.46 301.15l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "M259.33 300.84l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M259.83 300.84l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "M260.5 301.15l.167.318-.167-.318m1.504 0l.167.318-.166-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "M266.68 300.99l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M268.35 300.84l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "M271.36 300.84l.5.477-.5-.477zm6.01 0l-.5 1.908.5-1.908z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M278.88 300.84l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "M279.55 301.15l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "M280.05 301.15l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M282.39 300.84l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "M283.39 300.84l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "M284.06 301.15l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M284.89 300.84l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "M286.9 300.84l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "M287.4 300.84l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M290.91 300.84l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#210800",
    d: "M291.41 300.84l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "M291.91 300.84l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M292.41 300.84l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M292.92 300.84l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M293.42 300.84l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M293.92 300.84l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a6b52",
    d: "M294.42 300.84l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M294.92 300.84l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M295.42 300.84l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293129",
    d: "M295.92 300.84l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M297.43 300.84l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "M297.93 300.84l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M298.93 300.84l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M299.43 300.84l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M227.74 301.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M228.24 301.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M236.77 301.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M237.27 301.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M237.77 301.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M238.77 301.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "M239.27 301.31l.5.477-.5-.477zm1.51 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "M241.78 301.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M242.78 301.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "M244.79 301.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M247.29 301.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M251.3 301.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M251.81 301.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "M257.65 301.47l.334.16-.334-.16m1.504 0l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M259.83 301.31l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "M261.16 301.47l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M262.33 301.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "M265.84 301.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M266.85 301.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M267.35 301.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "M269.69 301.47l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "M271.36 301.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "M272.36 301.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "M276.37 301.31l.5.477-.5-.477zm6.52 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "M283.39 301.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M284.89 301.31l.5.477-.5-.477m1.504 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "M286.9 301.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "M287.4 301.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M288.9 301.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "M289.57 301.63l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M291.91 301.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M292.41 301.31l1.003.954v-.954h-1.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M293.42 301.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M295.42 301.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M295.92 301.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M296.42 301.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b735a",
    d: "M297.93 301.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M298.93 301.31l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M227.74 301.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M236.26 301.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631818",
    d: "M236.77 301.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M238.27 301.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "M238.77 301.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "M239.77 301.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "M240.28 301.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M241.78 301.79l.5.477-.5-.477m3.008 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "M245.79 301.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M246.29 301.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "M247.8 301.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "M248.3 301.79l-.5.954.5-.954zm7.02 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M257.32 301.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "M259.83 301.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "M260.33 301.79l.5.477-.5-.477m1.504 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "M262.33 301.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "M266.34 301.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "M267.85 301.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M271.36 301.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "M272.36 301.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "M279.38 301.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "M279.88 301.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "M280.88 301.79l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M281.89 301.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "M282.39 301.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "M285.4 301.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "M286.4 301.79l-.5.954.5-.954zm1 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M288.4 301.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M292.41 301.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M293.42 301.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M294.08 302.11l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M294.42 301.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M294.92 301.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M297.93 301.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a6342",
    d: "M298.93 301.79l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M235.76 302.27l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631818",
    d: "M236.26 302.27l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M239.77 302.27l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M240.28 302.27l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M241.28 302.27l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M241.95 302.59l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "M242.95 302.59l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M243.28 302.27l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M244.79 302.27l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M245.79 302.27l.5.477-.5-.477zm4.01 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M253.31 302.27l.5.477-.5-.477zm4.51 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M258.32 302.27l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M258.82 302.27l.5.477-.5-.477m1.337.16l.334.158-.333-.16m2.005 0l.334.16-.334-.16zm6.187-.158l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M268.85 302.27l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M269.35 302.27l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M270.86 302.27l.5.477-.5-.477m1.003 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M272.36 302.27v.477h1.504l-1.504-.477m2.507 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "M275.37 302.27l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "M279.38 302.27l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "M282.89 302.27l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "M284.06 302.59l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "M284.89 302.27l.5.477-.5-.477m1.504 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M287.4 302.27l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M292.92 302.27l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M293.42 302.27l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M294.42 302.27l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M294.92 302.27l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M295.42 302.27l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M298.1 302.59l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M298.43 302.27l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M298.93 302.27l.5.477-.5-.477m-63.168.477l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M236.26 302.74l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M238.77 302.74l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "M239.27 302.74l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "M241.28 302.74l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "M242.28 302.74l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M243.28 302.74l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "M244.29 302.74l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "M245.29 302.74l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "M245.79 302.74l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M248.3 302.74l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "M248.8 302.74l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M249.3 302.74l.5.477-.5-.477m30.58 0l.502.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "M280.38 302.74l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M280.88 302.74l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M281.38 302.74l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M282.39 302.74l.5.477-.5-.477m1.003 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M284.39 302.74l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "M285.06 303.06l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M285.73 302.9l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M287.4 302.74l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "M287.9 302.74l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M288.9 302.74l.5.477-.5-.477zm1.17.32l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#736b6b",
    d: "M293.42 302.74l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M293.92 302.74l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M294.42 302.74l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "M294.92 302.74l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "M295.42 302.74l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M295.92 302.74l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M298.43 302.74l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M298.93 302.74l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b4242",
    d: "M235.76 303.22l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "M240.28 303.22l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "M240.78 303.22l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "M242.28 303.22l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "M244.29 303.22l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M245.29 303.22l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M245.79 303.22l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M256.82 303.22v.477h3.008l-3.008-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M259.83 303.22l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M260.33 303.22v.477h9.525l-9.525-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M269.85 303.22v.477h3.008l-3.008-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M272.86 303.22l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M283.39 303.22l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "M283.89 303.22l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M284.39 303.22l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M285.73 303.38l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "M286.9 303.22l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M287.4 303.22l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "M288.9 303.22l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631818",
    d: "M293.42 303.22l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M295.59 303.54l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M295.92 303.22l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M296.42 303.22l.5.477-.5-.477m1.504 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M298.43 303.22l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M229.75 303.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M230.25 303.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b4242",
    d: "M230.75 303.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M232.76 303.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M233.26 303.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M233.76 303.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b2908",
    d: "M235.76 303.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "M239.27 303.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "M239.94 304.02l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "M241.28 303.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M243.28 303.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M243.78 303.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M250.64 303.86l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M251.3 303.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M251.81 303.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#733129",
    d: "M252.31 303.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#734a42",
    d: "M253.14 303.86l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#845a52",
    d: "M253.81 303.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M254.31 303.7v.477h2.005l-2.005-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M256.32 303.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M256.82 303.7v.477h1.504l-1.504-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M258.32 303.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M258.82 303.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M259.33 303.7l1.504 1.43-1.504-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M259.83 303.7c1.32 1.583 2.382 2.282 4.512 1.908l-4.512-1.908z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M262.84 303.7l1.003 2.385h1.002l-2.005-2.385z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M263.34 303.7l1.504 1.43-1.504-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M265.34 303.7l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M265.84 303.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M266.34 306.08l4.01-1.908c-2.042-.814-4.41-.584-4.01 1.908z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M270.36 303.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M270.86 303.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#946b63",
    d: "M275.37 303.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#734a42",
    d: "M276.2 303.86l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c3939",
    d: "M276.87 303.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M277.37 303.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M277.88 303.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M278.71 303.86l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M279.38 303.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "M286.73 303.86l.334.16-.334-.16m1.17-.16l.5.478-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "M288.4 303.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "M288.9 303.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M289.91 303.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M293.42 303.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M295.92 303.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M296.42 303.7l.5.477-.5-.477zm2.51 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M299.43 303.7l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M229.25 304.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631818",
    d: "M229.75 304.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M230.25 304.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M229.75 308.47c5.233-3 11.967 5.274 16.043-1.43l-.5-.478c-1.667.584-3.682 1.96-5.514 1.705-1.227-.172-13.884-8.372-10.03.203z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M233.26 304.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M233.76 304.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631818",
    d: "M234.26 304.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M234.76 304.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M235.26 304.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#734a42",
    d: "M235.76 304.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3110",
    d: "M239.27 304.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7b08",
    d: "M240.28 304.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M246.29 304.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M246.79 304.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M247.29 304.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#733129",
    d: "M247.8 304.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#734a42",
    d: "M248.3 304.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c6363",
    d: "M248.8 304.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M249.63 304.33l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M250.64 304.33l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M251.3 304.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M259.33 304.18l1.504 1.43-1.504-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103910",
    d: "M265.34 304.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M269.85 304.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M270.36 304.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M278.71 304.33l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M279.71 304.33l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c7373",
    d: "M280.38 304.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#734a42",
    d: "M280.88 304.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#733939",
    d: "M281.38 304.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M281.89 304.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M282.39 304.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M282.89 304.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M287.4 304.18l.5.477-.5-.477m1.67.318l.168.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b2908",
    d: "M293.42 304.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M293.92 304.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M294.42 304.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#733129",
    d: "M294.92 304.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M295.42 304.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M295.92 304.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M284.89 306.56c-.694 6.672 11.805.054 15.04 1.908 1.724-3.644-2.3-5.268-5.422-3.37-1.496.91-2.242 2.783-4.123 3.113-1.855.326-3.85-1-5.495-1.65z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M298.93 304.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M299.43 304.18l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M299.93 304.18l.5.477-.5-.477m-71.19.477l.502.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M229.25 304.65l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M235.26 304.65l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#310000",
    d: "M235.76 304.65l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M236.26 304.65l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef9408",
    d: "M239.77 304.65l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e75a10",
    d: "M240.28 304.65l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M243.28 304.65l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M243.78 304.65l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M244.29 304.65l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b2908",
    d: "M244.79 304.65l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#734a42",
    d: "M245.29 304.65l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M245.79 304.65l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M246.29 304.65l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M246.79 304.65l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293129",
    d: "M264.84 304.65l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M265.34 304.65l1.003 1.43-1.003-1.43m3.51 0l-.502.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103910",
    d: "M269.35 304.65l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M269.85 304.65l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M282.39 304.65l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M282.89 304.65l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M283.39 304.65l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#734a42",
    d: "M283.89 304.65l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#733129",
    d: "M284.39 304.65l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M284.89 304.65l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M285.4 304.65l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M285.9 304.65l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7b508",
    d: "M289.41 304.65l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#420000",
    d: "M293.42 304.65l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M293.92 304.65l.5.477-.5-.477m6.016 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M300.44 304.65l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M228.24 305.13l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#842118",
    d: "M228.74 305.13l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M235.76 305.13l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M236.26 305.13l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M241.78 305.13l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "M243.78 305.13l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M244.29 305.13l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M260.83 305.13l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M264.84 305.13l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293129",
    d: "M268.85 305.13l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M284.89 305.13l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#391810",
    d: "M285.4 305.13l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M285.9 305.13l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M286.4 305.13l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M286.9 305.13l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M287.4 305.13l1.003.954-1.003-.954m5.515 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M293.42 305.13l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M300.44 305.13l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M300.94 305.13l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M228.24 305.61l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M228.74 305.61l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M236.26 305.61l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M236.77 305.61l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M241.61 305.77l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631818",
    d: "M244.29 305.61l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M244.79 305.61l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M258.82 305.61l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M259.33 305.61l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#734a42",
    d: "M259.83 305.61v.477h1.504l-1.504-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293100",
    d: "M261.33 305.61l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M261.83 305.61l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M264.84 305.61l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#082108",
    d: "M265.34 305.61l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M267.35 305.61l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M267.85 305.61l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M268.35 305.61l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#733939",
    d: "M268.85 305.61l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#734a42",
    d: "M269.35 305.61l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#736b6b",
    d: "M269.85 305.61l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M270.36 305.61l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M284.39 305.61l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1010",
    d: "M284.89 305.61l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M285.4 305.61l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M287.4 305.61l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M292.41 305.61l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M292.92 305.61l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#736b6b",
    d: "M300.94 305.61l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c6363",
    d: "M228.24 306.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "M236.77 306.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M237.27 306.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M243.78 306.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M244.29 306.08l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#100808",
    d: "M244.79 306.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M245.29 306.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M256.82 306.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M257.32 306.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M257.82 306.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M258.32 306.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M258.82 306.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M259.33 306.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M258.82 308.47l4.01.477c-.245-2.927-3.433-3.64-4.01-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M261.83 306.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M262.33 306.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "M262.84 306.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#422100",
    d: "M263.34 306.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M263.84 306.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M264.34 306.08v.477h1.504l-1.504-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#311000",
    d: "M265.84 306.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#293100",
    d: "M266.34 306.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M266.85 306.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M267.35 306.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M266.85 306.56l.5 2.385 3.51-.477c-.41-2.34-1.796-2.387-4.01-1.908z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M270.36 306.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#423131",
    d: "M270.86 306.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M271.36 306.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M271.86 306.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M272.36 306.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M272.86 306.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101810",
    d: "M284.39 306.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M284.89 306.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M285.4 306.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "M292.41 306.08l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#734a42",
    d: "M301.1 306.4l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M228.24 306.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M236.77 306.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M237.27 306.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M242.78 306.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M243.28 306.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M244.29 306.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M245.29 306.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M245.79 306.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M254.81 306.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M255.32 306.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#736b6b",
    d: "M255.82 306.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631818",
    d: "M256.32 306.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M256.82 306.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M257.32 306.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M257.82 306.56l-2.005.477v2.862c1.733-.7 2.734-1.513 2.005-3.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M258.32 306.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "M262.84 306.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M263.34 306.56v2.862h3.008v-2.862h-3.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "M266.34 306.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M270.86 306.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M271.36 306.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M271.86 306.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M272.36 306.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M272.86 306.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b4242",
    d: "M273.36 306.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M273.86 306.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M274.37 306.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M283.39 306.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1010",
    d: "M283.89 306.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M284.39 306.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M285.4 306.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M285.9 306.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M286.4 306.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M291.91 306.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M292.41 306.56l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M228.41 307.36l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M228.74 307.04l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M231.25 307.04l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M231.75 307.04l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M237.27 307.04l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M237.77 307.04l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M241.78 307.04l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "M242.28 307.04l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M242.78 307.04l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M245.79 307.04l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M254.98 307.36l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M255.32 307.04l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M258.32 307.04v1.908h.5l-.5-1.908m4.512 0v1.908h.5l-.5-1.908z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M266.34 307.04l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M266.85 307.04l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M270.86 307.04l-1.504 2.385h1.504v-.954l1.003.478v-1.908h-1.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M271.86 307.04v2.385l2.005.477.502-2.385-2.507-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M273.86 307.04l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b4242",
    d: "M274.37 307.04l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M283.39 307.04l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M283.89 307.04l.5.477-.5-.477m2.507 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "M286.9 307.04l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M287.4 307.04l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M291.41 307.04l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M291.91 307.04l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M297.76 307.2l.334.16-.334-.16m2.674-.16l.5.478-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M300.94 307.04l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M224.73 307.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M225.24 307.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M227.74 307.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1010",
    d: "M228.74 307.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M230.25 307.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M230.75 307.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M231.25 307.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M231.75 307.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M232.25 307.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M232.76 307.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M233.26 307.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M233.76 307.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M237.77 307.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M238.44 307.83l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M240.78 307.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M241.28 307.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M241.78 307.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M242.28 307.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M245.29 307.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M245.79 307.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M255.32 307.51l.5.477-.5-.477m11.03 0v.954h1.002v-.954h-1.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M274.53 307.83l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M283.39 307.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M283.89 307.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M287.4 307.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M287.9 307.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M288.4 307.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M290.91 307.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "M291.41 307.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M291.91 307.51l.5.477-.5-.477m3.51 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M295.92 307.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M296.76 307.67l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M297.43 307.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M297.93 307.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M298.43 307.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M298.93 307.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "M300.44 307.51l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M301.27 307.67l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M304.28 307.67l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M223.23 307.99l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M223.73 307.99l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#733129",
    d: "M224.23 307.99l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M224.73 307.99l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M222.23 309.42c2.015 4.108 12.55 5.25 15.04.954-5.83.7-9.585-3.675-15.04-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M227.74 307.99l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M228.24 307.99l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M228.74 307.99l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M230.75 307.99l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M236.77 309.9c-4.703-3.61-7.752.932 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M233.26 307.99l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M233.76 307.99l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "M234.26 307.99l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M234.76 307.99l.5.477-.5-.477zm6.02 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M241.28 307.99l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a2121",
    d: "M245.29 307.99l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M255.32 307.99l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#736b6b",
    d: "M283.89 307.99l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M284.39 307.99l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M288.4 307.99l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M288.9 307.99l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M294.42 307.99l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M295.25 308.15l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M295.92 307.99l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M292.92 309.42v.477c2.59.312 5.465 1.236 6.016-1.908l-6.016 1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "M298.93 307.99l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M299.93 307.99l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M300.44 307.99l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M300.94 307.99l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M301.44 307.99l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M292.41 310.38c2.477 4.274 13.046 3.11 15.04-.954-5.455-2.72-9.21 1.655-15.04.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M304.45 307.99l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b2908",
    d: "M304.95 307.99l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#736b6b",
    d: "M305.45 307.99l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M305.95 307.99l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M306.45 307.99l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M222.23 308.47l-1.003 1.43 1.003-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a3131",
    d: "M222.73 308.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M223.23 308.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M229.25 308.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M234.76 308.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M235.6 308.63l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M236.26 308.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631818",
    d: "M244.79 308.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M245.29 308.47l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M255.32 308.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M258.82 308.47v.477l2.005.477-2.005-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M266.34 308.47l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M266.85 308.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M268.85 308.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M270.86 308.47l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M273.86 308.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M274.37 308.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M283.89 308.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a2121",
    d: "M284.39 308.47l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M292.92 308.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M293.42 308.47l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M293.92 308.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M294.42 308.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M298.93 308.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M299.43 308.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M305.95 308.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a2121",
    d: "M306.45 308.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M306.95 308.47l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631818",
    d: "M222.23 308.95l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M229.25 308.95l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#210800",
    d: "M229.75 308.95l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M230.25 308.95l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M235.76 308.95l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M236.26 308.95l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#420000",
    d: "M236.77 308.95l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M237.27 308.95l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M243.78 308.95l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1010",
    d: "M244.29 308.95l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#734a42",
    d: "M255.32 308.95l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M257.82 308.95l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#310000",
    d: "M258.32 308.95l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M258.99 309.26l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M259.66 309.1l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M260.83 308.95l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M261.33 308.95l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M261.83 308.95l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M262.33 308.95l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "M262.84 308.95l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#420000",
    d: "M266.34 308.95l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M267.35 308.95v.477h1.504l-1.504-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M268.85 308.95l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M269.85 308.95l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#310000",
    d: "M270.86 308.95l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M273.86 308.95l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M274.37 308.95l.5.477-.5-.477m10.027 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M285.4 308.95l.5.477-.5-.477m6.517 0l.502.477-.503-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "M292.41 308.95l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M293.42 308.95l.5.477-.5-.477m5.515 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#210800",
    d: "M299.43 308.95l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M299.93 308.95l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M306.95 308.95l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M307.45 308.95l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631818",
    d: "M221.73 309.42l2.507 2.862-2.507-2.862z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#420000",
    d: "M230.25 309.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#842118",
    d: "M236.77 309.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M237.27 309.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#524242",
    d: "M237.77 309.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M238.27 309.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M238.77 309.42l.5.477-.5-.477m4.01 0l.502.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M243.28 309.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M243.78 309.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M244.29 309.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#845a52",
    d: "M255.32 309.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M256.32 309.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631818",
    d: "M256.82 309.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b5252",
    d: "M257.32 309.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M257.82 309.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M258.32 309.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M259.33 309.42v.477h2.005l-2.005-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M261.33 309.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M261.83 309.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M262.33 309.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392100",
    d: "M262.84 309.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "M263.34 309.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M263.84 309.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M264.67 309.58l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M265.34 309.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#311000",
    d: "M265.84 309.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292100",
    d: "M266.34 309.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a1000",
    d: "M266.85 309.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M267.35 309.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M267.85 309.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M268.35 309.42v.477h2.005l-2.005-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M270.36 309.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1010",
    d: "M270.86 309.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M271.36 309.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M271.86 309.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b2131",
    d: "M272.36 309.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M272.86 309.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M273.86 309.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M285.4 309.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631818",
    d: "M285.9 309.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M286.4 309.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M290.41 309.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M290.91 309.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#733939",
    d: "M291.41 309.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M291.91 309.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631818",
    d: "M292.41 309.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M307.45 309.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M307.96 309.42l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M221.22 309.9l2.005 1.908-2.005-1.908z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M230.25 309.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M230.75 309.9l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M234.76 309.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M235.43 310.22l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M236.1 310.06l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M236.77 309.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392121",
    d: "M237.27 309.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M238.27 309.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M238.77 309.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M239.27 309.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b2131",
    d: "M239.77 309.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M240.28 309.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c4239",
    d: "M240.78 309.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad524a",
    d: "M241.28 309.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#734a42",
    d: "M241.78 309.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M242.28 309.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M242.78 309.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M243.28 309.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M255.32 309.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b2131",
    d: "M255.82 309.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M256.32 309.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M256.82 309.9l.5.477-.5-.477m1.504 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M258.82 309.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M259.33 309.9v.477h2.005l-2.005-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M261.33 309.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M261.83 309.9l-.5 1.908.5-1.908z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M262.67 310.06l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#214210",
    d: "M263.34 309.9l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M263.84 309.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M264.67 310.06l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M265.34 309.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M265.84 309.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M266.34 309.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M266.85 309.9c1.83 2.139 4.956 4.796 7.52 2.385l-7.52-2.385z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M267.85 309.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M268.35 309.9v.477h2.005l-2.005-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M270.36 309.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M270.86 309.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M272.86 309.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#524242",
    d: "M273.36 309.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1010",
    d: "M273.86 309.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M286.4 309.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M286.9 309.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#734a42",
    d: "M287.4 309.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad524a",
    d: "M288.24 310.06l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M288.9 309.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#733129",
    d: "M289.41 309.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#736b6b",
    d: "M289.91 309.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M290.41 309.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M290.91 309.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M291.91 309.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M292.41 309.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M293.25 310.06l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M294.08 310.22l.167.318-.167-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M294.42 309.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M298.43 309.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631818",
    d: "M307.45 309.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M307.96 309.9l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M308.46 309.9l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M220.72 310.38l2.005 1.908-2.005-1.908z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M221.22 310.38l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M230.75 310.38l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M232.09 310.54l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M232.76 310.38l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M233.26 310.38l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M233.76 310.38l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M234.59 310.54l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M237.27 310.38l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M237.77 310.38l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M255.32 310.38l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M257.82 310.38l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "M258.32 310.38l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M258.82 310.38l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#319400",
    d: "M255.82 312.28c2.356 2.212 4.845.153 6.517-1.908l-6.517 1.908z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M263.34 310.38l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M266.34 310.38l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M266.85 310.38l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M270.86 310.38l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M271.36 310.38l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M271.86 310.38l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M273.86 310.38l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#420000",
    d: "M291.91 310.38l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M294.42 310.38l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M294.92 310.38l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M295.42 310.38l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M295.92 310.38l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M296.42 310.38l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M296.93 310.38v.477h1.504l-1.504-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M298.43 310.38l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#520808",
    d: "M306.95 310.38l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M307.96 310.38l-1.003 1.43 1.003-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M308.46 310.38l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M220.22 310.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M221.73 310.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M237.27 310.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M237.77 310.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M257.32 310.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M257.82 310.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M262.33 310.85l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M266.85 310.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213918",
    d: "M267.35 310.85l.5.477-.5-.477m4.512 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M272.36 310.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M291.91 310.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M306.45 310.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M306.95 310.85l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M307.96 310.85l-1.003 1.43 1.003-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M308.46 310.85l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M220.72 311.33l.5.477-.5-.477m1.504 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M236.77 311.33l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M237.27 311.33l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M256.32 311.33l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "M256.82 311.33l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M257.32 311.33l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M262.33 311.33l.5.477-.5-.477m5.013 0l.502.477-.502-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M267.85 311.33l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M268.35 311.33l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M272.36 311.33l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M272.86 311.33l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M273.36 311.33l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M291.91 311.33l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M292.41 311.33l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M305.95 311.33l-1.003 1.43 1.003-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M306.45 311.33l-1.003 1.43 1.003-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M308.96 311.33l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M220.22 311.81l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M221.22 311.81l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M221.73 311.81l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M222.73 311.81l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M223.23 311.81l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a3131",
    d: "M236.77 311.81l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M255.32 311.81l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M255.82 311.81l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M256.32 311.81l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M260.83 311.81l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M261.33 311.81l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M268.35 311.81l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M268.85 311.81l.5.477-.5-.477m4.512 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M273.86 311.81l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M274.37 311.81l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M292.41 311.81l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M292.92 311.81l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M306.45 311.81l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a59494",
    d: "M307.45 311.81l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M308.46 311.81l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M308.96 311.81l-.5 1.43.5-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M220.72 312.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M222.23 312.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M222.73 312.28l3.51 2.862-3.51-2.862z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M223.23 312.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b1008",
    d: "M224.23 312.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M228.74 312.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M229.25 312.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c3939",
    d: "M229.75 312.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#843129",
    d: "M233.26 312.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b5252",
    d: "M235.76 312.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M236.26 312.28l.5.477-.5-.477m18.55 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184a00",
    d: "M255.32 312.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M259.83 312.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294221",
    d: "M260.33 312.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M260.83 312.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M268.85 312.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213918",
    d: "M269.35 312.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103900",
    d: "M274.37 312.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M274.87 312.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M292.92 312.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#736b6b",
    d: "M293.42 312.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M293.92 312.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#842118",
    d: "M295.92 312.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c4a4a",
    d: "M296.42 312.28l.5.477-.5-.477zm3.01 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631808",
    d: "M299.93 312.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M300.44 312.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M300.94 312.28l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M305.95 312.28l-1.504 1.908 1.504-1.908z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M306.45 312.28l-2.507 3.34 2.507-3.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M307.29 312.44l.334.16-.334-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M220.72 312.76l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M221.22 312.76l1.003 1.43-1.003-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M222.23 312.76l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M223.73 312.76l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M224.23 312.76l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M224.73 312.76l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd2110",
    d: "M227.24 312.76l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M227.74 312.76l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#736b6b",
    d: "M228.24 312.76l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M228.74 312.76l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M254.81 312.76l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#314231",
    d: "M255.32 312.76l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#297b00",
    d: "M255.82 312.76l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M259.33 312.76l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M259.83 312.76l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M260.33 312.76l.5.477-.5-.477m9.024 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M269.85 312.76l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#294200",
    d: "M270.36 312.76l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M273.86 312.76l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52525a",
    d: "M274.37 312.76l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M274.87 312.76l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M300.44 312.76l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M300.94 312.76l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#631818",
    d: "M301.44 312.76l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M301.94 312.76l.5.477-.5-.477m2.507 0l-.502.954.502-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "M304.95 312.76l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M306.95 312.76l.5.477-.5-.477m1.003 0l-1.504 1.908 1.503-1.908z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M221.73 313.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M222.73 313.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M224.73 313.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ad1810",
    d: "M225.24 313.24l.5.477-.5-.477m1.504 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M227.24 313.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M227.74 313.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M255.82 313.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M258.32 313.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M258.82 313.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M259.33 313.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M270.36 313.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425242",
    d: "M270.86 313.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M271.36 313.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63636b",
    d: "M273.86 313.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M301.94 313.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M302.44 313.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "M304.45 313.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M306.45 313.24l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M307.96 313.24l-1.003 1.43 1.003-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M223.23 313.72l2.005 1.908-2.005-1.908z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M223.73 313.72l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "M225.24 313.72l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b51010",
    d: "M225.74 313.72l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#941808",
    d: "M226.24 313.72l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M226.74 313.72l.5.477-.5-.477m29.58 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185200",
    d: "M256.82 313.72l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#296300",
    d: "M257.32 313.72l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395231",
    d: "M257.82 313.72l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M258.32 313.72l.5.477-.5-.477m13.035 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5231",
    d: "M271.86 313.72l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#397b00",
    d: "M272.36 313.72l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#295200",
    d: "M272.86 313.72l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M273.36 313.72l.5.477-.5-.477m29.077 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a1008",
    d: "M302.94 313.72l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2110",
    d: "M303.44 313.72l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#391810",
    d: "M303.94 313.72l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M305.95 313.72l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M224.23 314.19l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313931",
    d: "M225.74 314.19l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M226.24 314.19l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M256.82 314.19l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c9494",
    d: "M257.32 314.19l.5.477-.5-.477m15.04 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ada5a5",
    d: "M272.86 314.19l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M302.94 314.19l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292921",
    d: "M303.44 314.19l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M303.94 314.19l.5.477-.5-.477m1.504 0l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M222.73 314.67l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M223.23 314.67l2.005 1.908-2.005-1.908z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M224.73 314.67l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M304.95 314.67l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M305.95 314.67l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7373",
    d: "M306.45 314.67l-.5.954.5-.954m-83.22.477l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M225.24 315.15l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M304.45 315.15l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M223.73 315.62l1.003.954-1.003-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M225.24 315.62l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M304.95 315.62l.5.477-.5-.477m-81.216.477l1.003.954-1.003-.953z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M304.45 316.1l.5.477-.5-.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M305.45 316.1l-.5.954.5-.954z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.99,
    d: "M248.23 228.22l.807-.215c.054.148.14.255.257.322.117.066.272.087.464.065.212-.025.367-.08.464-.167a.235.235 0 0 0 .08-.22.195.195 0 0 0-.076-.14c-.045-.033-.14-.057-.287-.072-.68-.062-1.115-.14-1.306-.234a.765.765 0 0 1-.453-.62.806.806 0 0 1 .236-.682c.19-.198.507-.323.952-.375.424-.05.747-.02.97.087.223.107.39.285.5.533l-.754.226a.468.468 0 0 0-.224-.243c-.1-.05-.234-.065-.405-.045-.216.025-.367.07-.453.14a.183.183 0 0 0-.073.168c.006.056.04.1.1.132.08.044.344.087.79.13.45.044.77.125.96.24.19.12.3.304.332.55.035.27-.054.517-.266.74-.212.22-.55.36-1.015.413-.42.05-.766.006-1.034-.128a1.156 1.156 0 0 1-.566-.607zm-3.635-.262c-.033-.26.002-.517.105-.775s.268-.465.497-.62c.23-.157.497-.253.8-.288.47-.055.872.046 1.208.3.337.255.533.603.59 1.045.057.446-.047.833-.313 1.163-.263.327-.625.517-1.083.57a1.895 1.895 0 0 1-.838-.088 1.33 1.33 0 0 1-.655-.467c-.165-.222-.27-.5-.312-.84zm.845-.056c.038.292.14.508.305.646.166.14.355.195.57.17a.695.695 0 0 0 .506-.295c.127-.172.17-.406.133-.702-.037-.288-.14-.5-.305-.64a.714.714 0 0 0-.566-.17.704.704 0 0 0-.51.295c-.125.173-.17.405-.132.697zm-2.55-1.604l-.092-.722.82-.095.092.723-.82.095zm.43 3.346l-.378-2.947.82-.095.377 2.947-.82.094zm-4.832-3.567l1.578-.183c.355-.042.63-.047.823-.017.26.04.49.14.69.3.203.158.368.363.494.613.127.248.215.562.264.943.043.335.036.63-.02.88-.07.31-.19.567-.366.773-.132.156-.32.288-.565.395-.183.08-.434.14-.753.176l-1.624.19-.522-4.07zm.952.588l.345 2.694.645-.076c.24-.028.413-.06.517-.1a.804.804 0 0 0 .325-.21c.083-.09.142-.23.177-.417.034-.19.03-.442-.01-.756s-.1-.552-.18-.713a.944.944 0 0 0-.295-.366.867.867 0 0 0-.424-.144c-.123-.012-.36.003-.712.044l-.388.045z",
    fill: "#ecca5e"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#ecca5e",
    d: "M250.007 239.54l12.19 15.242-.592.684-12.19-15.24zm31.367-1.163l-13.62 18.012-1.044-.36 13.62-18.013zm-34.514 4.173l14.425 13.357-.478.76-14.425-13.358zm-3.34 3.09l15.84 11.818-.39.804-15.84-11.82zm39.906-2.308l-14.278 13.498-.79-.467 14.278-13.5zm3.154 2.498l-15.987 11.635-.72-.56 15.987-11.637z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.564,
    fill: "#7b5a00",
    d: "M277 243.98l3.305-4.2-.4-.286L277 243.98z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.475,
    fill: "#7b5a00",
    d: "M269.5 253.88l3.305-4.2-.4-.286-2.905 4.486z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.68,
    fill: "#7b5a00",
    d: "M273.25 249.12l3.305-4.2-.4-.286-2.905 4.486z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.525,
    fill: "#7b5a00",
    d: "M280.97 249.63l4.627-2.855-.273-.4-4.354 3.255z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.398,
    fill: "#7b5a00",
    d: "M274.91 251.34l4.112-3.497-.334-.356-3.778 3.853z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M235.93 286.02h-.5c-.095-2.733-1.16-4.483-4.012-5.247.07 1.455 1.116 7.136 3.51 5.247h.5l-1.002 4.293c1.497-1.58 7.68-7.142 5-9.593-2.293-2.097-3.47 4.253-3.496 5.3zm-3.83-34.13h-.5c-.095-2.733-1.16-4.483-4.012-5.247.07 1.455 1.116 7.136 3.51 5.247h.5l-1.002 4.293c1.497-1.58 7.68-7.142 5-9.593-2.293-2.097-3.47 4.253-3.496 5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.99,
    d: "M297.13 230.59l-.76-.084.052-.433a1.256 1.256 0 0 1-.496.327 1.21 1.21 0 0 1-1.4-.445c-.22-.302-.3-.697-.24-1.186.06-.5.23-.866.51-1.098.28-.233.607-.33.985-.287.347.038.63.208.85.51l.178-1.466.82.09-.498 4.07zm-2-1.78c-.038.314-.02.547.054.698a.62.62 0 0 0 .516.366.63.63 0 0 0 .51-.174c.15-.14.245-.36.282-.664.042-.338.007-.59-.103-.75a.615.615 0 0 0-.466-.28.643.643 0 0 0-.518.167c-.148.132-.24.344-.276.637zm-3.3-.884l-.73-.21c.12-.276.288-.47.51-.585s.532-.15.935-.104c.365.04.633.112.802.215.168.103.28.22.338.357.058.134.066.37.025.71l-.12.91a3.04 3.04 0 0 0-.032.578c.012.125.045.262.1.41l-.81-.09a2.428 2.428 0 0 1-.052-.24c-.008-.047-.013-.078-.018-.094a1.367 1.367 0 0 1-1.007.283c-.318-.035-.56-.145-.724-.33a.793.793 0 0 1-.198-.655.805.805 0 0 1 .566-.69c.16-.055.386-.092.676-.112.392-.026.665-.06.82-.104l.01-.077c.02-.15-.007-.26-.077-.332-.07-.074-.213-.123-.43-.146a.61.61 0 0 0-.35.045.567.567 0 0 0-.234.264zm1.018.754c-.11.022-.28.043-.513.065-.234.02-.388.05-.463.086-.116.06-.18.147-.195.258-.013.11.018.21.094.298.077.09.18.14.313.155a.735.735 0 0 0 .44-.09.515.515 0 0 0 .228-.237c.03-.065.056-.19.08-.377l.018-.156zm-2.09-1.785l-.077.622-.56-.062-.145 1.19c-.03.24-.04.38-.037.422.007.04.027.075.06.105.037.03.082.05.137.055a1.08 1.08 0 0 0 .338-.04l-.004.614c-.2.058-.422.073-.663.046a1.079 1.079 0 0 1-.39-.113.592.592 0 0 1-.24-.213.702.702 0 0 1-.078-.318 3.463 3.463 0 0 1 .04-.552l.157-1.286-.376-.042.078-.62.375.04.072-.586.88-.364-.128 1.04.56.064zm-3.323 2.62l-.82-.09.36-2.95.762.086-.05.42c.153-.184.286-.3.396-.353a.7.7 0 0 1 .368-.055c.188.02.362.09.523.207l-.337.652a.731.731 0 0 0-.37-.17.466.466 0 0 0-.303.058c-.087.05-.163.152-.23.304-.063.153-.125.48-.187.98l-.11.912zm-2.2-1.194l.802.222c-.14.273-.333.472-.58.597-.243.122-.535.165-.875.127-.54-.06-.918-.27-1.135-.635-.172-.29-.232-.64-.182-1.05.06-.49.24-.856.543-1.102.302-.248.658-.35 1.07-.304.46.05.806.237 1.037.557.23.318.304.776.22 1.372l-2.055-.227c-.022.232.022.42.132.563.11.143.26.224.45.245a.528.528 0 0 0 .336-.064.622.622 0 0 0 .238-.3zm.144-.782c.02-.227-.02-.405-.122-.534a.57.57 0 0 0-.405-.225.593.593 0 0 0-.466.136c-.132.11-.21.273-.234.486l1.226.136zm-5.74 1.114l.5-4.07.82.09-.18 1.467c.286-.247.602-.35.95-.313.376.042.672.207.887.496.216.286.293.673.234 1.16-.06.503-.235.877-.52 1.12a1.225 1.225 0 0 1-1.477.125 1.25 1.25 0 0 1-.398-.424l-.053.434-.76-.085zm1.003-1.448c-.037.306-.014.537.07.694a.647.647 0 0 0 .527.374.6.6 0 0 0 .488-.168c.147-.134.24-.36.278-.676.04-.336.007-.586-.104-.748a.613.613 0 0 0-.465-.28.637.637 0 0 0-.517.165c-.148.13-.24.343-.277.64zm-2.218-2.08l.09-.722.82.09-.09.723-.82-.09zm-.41 3.348l.36-2.948.822.09-.36 2.95-.82-.092zm-3.62-.4l.494-4.038.862.096-.41 3.35 2.148.24-.084.684-3.01-.333z",
    fill: "#ecca5e"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#428c00",
    d: "M226.99 261.39h-.5c-.095-2.733-1.16-4.483-4.012-5.247.07 1.455 1.116 7.137 3.51 5.247h.5l-1.002 4.293c1.497-1.58 7.68-7.142 5-9.593-2.293-2.097-3.47 4.253-3.496 5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.7 246.23c0 .366-.415.662-.928.662s-.93-.296-.93-.663c0-.367.417-.663.93-.663s.93.296.93.662zm3.13-3.31c0 .366-.415.662-.928.662s-.93-.296-.93-.663c0-.367.417-.663.93-.663s.93.296.93.662zm2.91-3.09c0 .366-.415.662-.928.662s-.93-.296-.93-.663c0-.367.417-.663.93-.663s.93.296.93.662zm30.88-1.22c0 .366-.415.662-.928.662s-.93-.296-.93-.663c0-.367.417-.663.93-.663s.93.296.93.662zm2.21 4.31c0 .366-.415.662-.928.662s-.93-.296-.93-.663c0-.367.417-.663.93-.663s.93.296.93.662zm3.25 2.76c0 .366-.415.662-.928.662s-.93-.296-.93-.663c0-.367.417-.663.93-.663s.93.296.93.662z",
    fillRule: "evenodd",
    fill: "#fac349"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.99,
    d: "M270.82 222.37l-.748-.135c.087-.287.234-.498.44-.634.208-.135.514-.2.92-.197.368.003.642.048.82.133.18.084.306.19.377.32.072.127.107.36.103.702l-.018.917c-.003.26.008.453.032.578.027.124.075.256.146.4l-.816-.008a3.164 3.164 0 0 1-.077-.233c-.013-.047-.023-.077-.028-.092-.143.13-.294.225-.456.29-.16.063-.333.094-.515.092-.32-.003-.573-.088-.757-.256a.808.808 0 0 1-.27-.63.803.803 0 0 1 .487-.747c.153-.07.373-.13.66-.178.386-.066.654-.127.803-.186v-.078c.003-.15-.036-.258-.114-.323-.078-.065-.226-.1-.443-.1a.596.596 0 0 0-.345.08.564.564 0 0 0-.202.285zm1.098.647a5.7 5.7 0 0 1-.504.116c-.23.044-.38.09-.45.133-.11.07-.164.163-.165.275-.002.11.04.206.126.287.085.08.194.122.327.123.15 0 .292-.044.428-.135.1-.07.168-.156.2-.26.022-.065.035-.193.036-.38l.002-.158zm-3.373-1.976l.007-.726.825.008-.007.727-.825-.01zm-.034 3.372l.03-2.968.826.008-.03 2.968-.825-.008zm-1.55-.014l-.825-.008.03-2.968.766.007-.003.42c.133-.198.252-.328.356-.39a.685.685 0 0 1 .36-.092c.188.002.368.053.542.153l-.263.683a.756.756 0 0 0-.386-.132.481.481 0 0 0-.295.09c-.08.06-.144.168-.193.326-.047.158-.073.49-.078.995l-.01.917zm-1.333-2.98l-.006.625-.563-.005-.012 1.196c-.002.243 0 .384.01.425a.18.18 0 0 0 .073.098.25.25 0 0 0 .14.04c.077 0 .188-.023.333-.072l.065.61c-.192.076-.41.113-.653.11-.15 0-.282-.025-.4-.072a.614.614 0 0 1-.264-.187.729.729 0 0 1-.11-.31 3.356 3.356 0 0 1-.022-.552l.013-1.294-.38-.002.006-.626.38.003.005-.59.834-.45-.01 1.047.563.005zm-4.168.867l-.75-.135c.088-.287.235-.498.442-.634.207-.136.513-.202.918-.198.37.003.642.048.822.133.18.085.304.19.375.32.074.128.108.362.105.703l-.018.916c-.003.26.008.453.032.578.027.124.075.256.146.4l-.816-.008a3.164 3.164 0 0 1-.077-.233c-.015-.047-.024-.078-.03-.093-.142.13-.294.226-.455.29-.16.064-.333.095-.515.093-.32-.003-.574-.088-.76-.256a.813.813 0 0 1-.268-.63.81.81 0 0 1 .13-.446.826.826 0 0 1 .356-.3c.153-.068.373-.128.66-.177.386-.066.654-.128.804-.186v-.077c.002-.15-.036-.26-.114-.323-.078-.066-.225-.1-.442-.1a.596.596 0 0 0-.345.08.564.564 0 0 0-.202.285zm1.097.647a5.79 5.79 0 0 1-.504.116c-.23.044-.38.09-.45.133-.11.072-.164.164-.165.276 0 .11.04.205.126.286.086.08.195.122.328.123.15 0 .29-.044.427-.136.1-.07.166-.156.2-.26.02-.066.033-.193.035-.38l.002-.158zm-5.743 1.373l.04-4.097 1.397.013c.53.006.874.03 1.034.072.246.063.45.2.616.408.164.206.245.473.24.8-.002.25-.05.46-.15.632a1.15 1.15 0 0 1-.37.402 1.299 1.299 0 0 1-.45.188 5.04 5.04 0 0 1-.904.05l-.567-.004-.016 1.546-.87-.008zm.904-3.396l-.012 1.162.476.004c.343.003.572-.016.688-.058a.552.552 0 0 0 .375-.517.517.517 0 0 0-.134-.37.61.61 0 0 0-.347-.184 4.37 4.37 0 0 0-.625-.033l-.42-.004zm1.722 78.86l-.57-.015a.817.817 0 0 1 .246-.52c.136-.124.355-.207.655-.25.274-.04.483-.038.626.004.143.04.25.106.318.193.07.086.126.256.166.508l.102.682c.03.194.063.335.097.425.034.088.087.18.157.278l-.605.088a2.738 2.738 0 0 1-.119-.23 1.011 1.011 0 0 1-.67.394c-.24.034-.437 0-.594-.103a.618.618 0 0 1-.28-.437.589.589 0 0 1 .266-.607c.105-.067.26-.137.466-.206.278-.093.47-.17.572-.23l-.01-.057c-.017-.112-.06-.187-.124-.226-.066-.04-.18-.047-.34-.024a.458.458 0 0 0-.246.1.415.415 0 0 0-.114.234zm.894.354a3.868 3.868 0 0 1-.358.143c-.164.06-.27.11-.317.15-.072.065-.1.14-.088.222a.29.29 0 0 0 .13.197c.073.05.16.068.258.054a.547.547 0 0 0 .3-.148.368.368 0 0 0 .114-.214c.008-.052 0-.148-.02-.288l-.02-.116zm-1.82-.242l-.585.19a.433.433 0 0 0-.182-.238.433.433 0 0 0-.293-.046.47.47 0 0 0-.342.204c-.074.113-.092.286-.055.52.042.262.117.44.226.534.11.095.243.13.398.108a.427.427 0 0 0 .27-.135c.065-.074.1-.19.105-.35l.617.012c-.02.272-.108.487-.264.647-.156.158-.383.26-.68.303-.34.05-.625-.014-.86-.187-.232-.175-.377-.44-.435-.8-.058-.364-.002-.66.168-.892.17-.232.426-.373.77-.423.282-.04.515-.014.7.078.184.09.332.25.442.474zm-3.407-.478l-.086-.54.613-.087.086.538-.613.09zm.4 2.5l-.352-2.202.612-.088.352 2.2-.613.09zm-1.24.18l-.485-3.04.612-.088.485 3.038-.613.09zm-2.75.396l-.486-3.038.613-.088.175 1.094a.879.879 0 0 1 .622-.404.95.95 0 0 1 .745.19c.216.168.352.433.41.796.06.376.012.68-.144.91a.889.889 0 0 1-.634.404.894.894 0 0 1-.407-.037.964.964 0 0 1-.377-.232l.052.323-.57.082zm.423-1.236c.037.228.102.39.195.49.13.14.283.196.46.17.134-.02.24-.09.317-.213.078-.123.1-.303.06-.54-.04-.25-.116-.425-.23-.522a.476.476 0 0 0-.395-.115.466.466 0 0 0-.34.217c-.08.122-.102.293-.067.514zm-1.6 1.406l-.053-.33a.84.84 0 0 1-.29.327.95.95 0 0 1-.416.164.893.893 0 0 1-.433-.036.6.6 0 0 1-.31-.235 1.164 1.164 0 0 1-.162-.476l-.222-1.393.612-.087.162 1.01c.05.31.09.5.123.566a.333.333 0 0 0 .15.147.502.502 0 0 0 .505-.094.417.417 0 0 0 .137-.227c.018-.086 0-.287-.05-.602l-.147-.928.612-.09.35 2.202-.567.082zm-4.616-1.584l.57-.083.052.324a.86.86 0 0 1 .661-.477c.27-.04.513.028.732.2.22.175.357.44.414.798.06.367.01.667-.146.9a.901.901 0 0 1-.638.403.832.832 0 0 1-.36-.02 1.252 1.252 0 0 1-.366-.203l.177 1.11-.61.087-.486-3.038zm.775.975c.038.25.12.425.24.528a.496.496 0 0 0 .406.122.45.45 0 0 0 .33-.213c.076-.123.095-.308.056-.555-.037-.23-.113-.395-.228-.493a.47.47 0 0 0-.39-.117.477.477 0 0 0-.345.22c-.082.123-.105.293-.07.508zm-1.66.69l.625.008a.949.949 0 0 1-.295.54c-.15.136-.353.222-.607.26-.402.057-.72-.026-.953-.248-.185-.178-.3-.42-.35-.725-.058-.365-.004-.665.164-.9.167-.236.404-.376.71-.42.345-.05.633.02.867.208.234.186.382.503.445.95l-1.533.223c.03.172.102.3.212.382a.49.49 0 0 0 .376.093.379.379 0 0 0 .23-.11.453.453 0 0 0 .11-.26zm-.06-.595c-.03-.168-.097-.29-.198-.363a.44.44 0 0 0-.34-.087.434.434 0 0 0-.308.187.518.518 0 0 0-.068.396l.914-.133zm-4.383 1.953l-.485-3.038 1.357-.197c.34-.05.592-.057.755-.024.164.03.303.11.418.235.116.126.188.28.216.46a.792.792 0 0 1-.122.595c-.117.168-.313.292-.587.37.153.058.28.127.386.206.107.08.255.226.447.44l.485.537-.77.11-.573-.593a4.425 4.425 0 0 0-.41-.396.535.535 0 0 0-.215-.1 1.181 1.181 0 0 0-.33.013l-.13.02.202 1.268-.645.093zm.365-1.847l.477-.068c.308-.045.5-.085.572-.12.073-.037.126-.088.16-.155s.044-.146.03-.238a.368.368 0 0 0-.127-.235.41.41 0 0 0-.26-.085c-.055 0-.212.02-.473.058l-.503.072.122.77zm47.779.318l-.542-.17a.846.846 0 0 1 .393-.43c.168-.082.403-.103.704-.063.273.036.472.095.597.175.126.08.208.17.248.272.04.102.044.28.006.532l-.107.68c-.03.194-.04.338-.035.434.007.094.03.197.068.31l-.607-.08a2.91 2.91 0 0 1-.033-.182l-.012-.07c-.12.082-.24.14-.368.172a1.01 1.01 0 0 1-.392.022c-.24-.032-.418-.12-.54-.26a.605.605 0 0 1-.135-.495.607.607 0 0 1 .438-.508c.122-.04.292-.063.51-.073a3.7 3.7 0 0 0 .617-.064l.01-.058c.015-.112-.002-.196-.053-.25-.05-.057-.157-.096-.32-.117a.457.457 0 0 0-.264.028.44.44 0 0 0-.18.194zm.75.583c-.08.014-.21.027-.386.04-.174.01-.29.03-.348.056-.088.043-.138.106-.15.19-.013.08.01.155.065.223.056.068.133.11.232.122.11.015.22-.006.33-.06a.382.382 0 0 0 .176-.175c.023-.048.045-.14.066-.28l.017-.117zm-2.056.805l-.613-.082.167-1.125c.035-.237.045-.392.03-.465a.32.32 0 0 0-.106-.18.354.354 0 0 0-.202-.088.514.514 0 0 0-.298.045.45.45 0 0 0-.207.197c-.044.086-.084.253-.12.5l-.147.998-.614-.082.325-2.204.57.076-.048.323a.964.964 0 0 1 .818-.27.929.929 0 0 1 .36.12c.106.06.18.13.227.21.048.08.076.166.084.26.01.095 0 .228-.024.398l-.202 1.37zm-3.908-2.083l-.542-.17c.094-.205.224-.35.392-.43.168-.082.402-.104.703-.064.273.038.472.096.597.177.124.078.207.17.247.272.04.1.043.278.006.53l-.107.68c-.03.195-.04.34-.035.435.007.093.03.197.068.31l-.607-.082c-.01-.04-.023-.1-.035-.18-.005-.036-.01-.06-.01-.07-.12.082-.243.14-.37.172a.99.99 0 0 1-.392.02c-.24-.03-.418-.117-.537-.26a.59.59 0 0 1-.137-.493.605.605 0 0 1 .437-.51c.12-.037.29-.06.508-.07.294-.014.5-.035.617-.065l.01-.058c.016-.113-.002-.196-.053-.25-.052-.057-.158-.096-.32-.118a.445.445 0 0 0-.264.03.416.416 0 0 0-.18.193zm.75.582c-.082.014-.21.028-.386.04-.175.012-.292.03-.35.057-.087.043-.137.106-.15.19-.01.08.01.156.066.224.055.068.132.11.23.122a.56.56 0 0 0 .333-.062c.08-.043.14-.1.174-.173.023-.048.045-.142.065-.28l.016-.118zm-1.67-.726l-.62.024a.409.409 0 0 0-.1-.278.43.43 0 0 0-.267-.125.483.483 0 0 0-.39.104c-.105.087-.175.25-.21.484-.038.262-.02.453.056.573.077.12.194.192.35.213a.44.44 0 0 0 .3-.056c.082-.054.15-.155.204-.305l.588.178c-.102.255-.25.437-.448.548-.197.11-.445.146-.743.106-.34-.045-.594-.183-.767-.413-.17-.23-.23-.525-.176-.884.053-.364.196-.634.428-.81.232-.175.52-.24.865-.195.282.04.498.127.647.265.15.138.244.33.282.576zm-3.122-1.385l.08-.54.613.082-.08.54-.613-.082zm-.37 2.504l.326-2.206.613.082-.324 2.204-.615-.08zm-.62-.084l-.614-.082.166-1.126c.035-.238.045-.393.03-.466a.324.324 0 0 0-.106-.18.367.367 0 0 0-.203-.087.514.514 0 0 0-.298.045.442.442 0 0 0-.208.197c-.044.087-.084.253-.12.5l-.148 1-.613-.083.326-2.205.57.075-.048.324a.966.966 0 0 1 .82-.273.958.958 0 0 1 .36.12c.104.06.18.13.226.21a.6.6 0 0 1 .084.26c.01.096.002.228-.023.398l-.202 1.37zm-2.98-2.95l.08-.54.612.08-.08.54-.613-.08zm-.37 2.503l.325-2.206.613.082-.325 2.205-.613-.08zm-3.694-2.742l.565.076-.044.3c.238-.206.496-.29.775-.254.15.02.273.066.374.14.1.07.176.17.228.298.12-.104.242-.177.368-.22a.872.872 0 0 1 .39-.037c.17.024.31.077.418.16a.59.59 0 0 1 .22.322c.03.1.028.256-.003.466l-.206 1.41-.613-.082.186-1.26c.032-.22.032-.363 0-.432-.045-.09-.126-.144-.244-.16a.441.441 0 0 0-.45.24c-.048.09-.087.24-.117.45l-.156 1.057-.614-.08.178-1.21c.032-.213.042-.353.03-.418a.264.264 0 0 0-.083-.153.325.325 0 0 0-.178-.072.464.464 0 0 0-.266.04.412.412 0 0 0-.194.187c-.046.087-.084.237-.115.448l-.158 1.072-.614-.082.325-2.205zm-2.983.694c.03-.193.107-.374.234-.542a1.04 1.04 0 0 1 .487-.358c.2-.072.412-.092.64-.062.35.047.62.194.813.44.192.247.264.536.215.866a1.14 1.14 0 0 1-.463.785c-.257.19-.558.26-.9.215-.214-.028-.41-.1-.59-.218a.966.966 0 0 1-.38-.46 1.299 1.299 0 0 1-.055-.665zm.624.115c-.03.22 0 .394.09.525.093.13.22.206.378.228a.55.55 0 0 0 .428-.12c.126-.103.205-.264.238-.486.032-.216.002-.39-.09-.52a.525.525 0 0 0-.376-.228.557.557 0 0 0-.43.12c-.125.103-.205.262-.237.48zm-3.424-2.436l1.18.16c.266.034.466.08.6.138.18.078.327.192.44.345.115.152.193.33.234.535.04.203.04.447 0 .732-.038.25-.102.462-.195.634-.112.21-.253.375-.422.492-.127.09-.29.15-.49.183-.148.022-.342.02-.58-.013l-1.215-.162.448-3.044zm.57.602l-.297 2.016.48.064c.18.024.313.032.396.024a.636.636 0 0 0 .278-.092.63.63 0 0 0 .213-.27c.064-.132.114-.315.148-.55.035-.236.04-.42.014-.55a.69.69 0 0 0-.14-.32.625.625 0 0 0-.278-.183 3.363 3.363 0 0 0-.526-.1l-.29-.038z",
    fill: "#ecca5e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDo);
export default __webpack_public_path__ + "static/media/do.aadafa905aa978f337afb93b57e26042.svg";
export { ForwardRef as ReactComponent };